import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import { TextField, Button, Paper } from '@mui/material';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import FormControlLabel from '@mui/material/FormControlLabel';
import styles from './index.styles';
import '../assign-prescriptions/index.css';
import BinStatusLegend, { BIN_STATUS_LEGEND, withKioskMarketplaceLegend } from '../assign-prescriptions/BinStatusLegend';
import KioskDeliveryInfoPanel from '../assign-prescriptions/KioskDeliveryInfoPanel';
import { ConfirmDialog, ErrorDialog, InfoDialog, WarningDialog } from '../common/message-dialog/MessageDialog';
import Boxlayout from '../assign-prescriptions/box-layout';
import randomized from 'randomatic';
import assignmentstatus from './assignment-status';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Tooltip from '@mui/material/Tooltip';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import ShopBinDialog from '../assign-prescriptions/ShopBinDialog';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/system';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import InputLabel from '@mui/material/InputLabel';
import { toast } from 'react-toastify';
import FormHelperText from '@mui/material/FormHelperText';
import PlayArrow from '@mui/icons-material/PlayArrow';
import Pause from '@mui/icons-material/Pause';
import RemoveIcon from '@mui/icons-material/Remove';
import PrintTemplate from 'react-print';
import EVENT_TYPES from '../common/event-type';
import EVENT_CRUD_TYPES from '../common/event-crud-types';
import EventLogHandler from '../common/event-log-handler';
import { writeAuditLog } from '../common/apis';
import { DesktopDatePicker, LocalizationProvider } from '@mui/lab';
import DateAdapter from "@mui/lab/AdapterDateFns";
import { extendMoment } from 'moment-range';
import originalMoment from 'moment';
import AmountFormat from '../common/AmountFormat';
import HomeIcon from '@mui/icons-material/Home';
import WorkIcon from '@mui/icons-material/Work';
import curbsideIcon from '../iLocal-Delivery-Icons/Curbside.svg';
import counterIcon from '../iLocal-Delivery-Icons/Counter.svg';
import inpatientIcon from '../iLocal-Delivery-Icons/Bedside.svg';
import courierIcon from '../iLocal-Delivery-Icons/Courier.svg';
import LOCATION_TYPE from '../enum/location_type';
import DEVICE_TYPE from '../enum/device_type';
import Manualconsultation from '../assign-prescriptions/Manual-consultation';
import InputAdornment from '@mui/material/InputAdornment';
import MagnifyIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import NumberFormat from 'react-number-format';
import BOX_TYPE from '../enum/box_type';
import io from 'socket.io-client';
import TablePagination from '@mui/material/TablePagination';
import '../assign-prescriptions/index.css';
import { IMaskInput } from 'react-imask';
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import LabelTemplate from '../assign-prescriptions/labelTemplate';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import checked from './images/checked.png';
import { withTranslation } from 'react-i18next';
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';
import userroles from '../common/userroles';
import {
  resolveSizeBasedAssignUIFromBox,
  parseAvailableBinCounts,
  SIZE_BASED_ASSIGN_BIN_SIZES,
  parseSizeBasedBinCounts,
  getBinSizeTranslationMap,
  resolveBinSizeLabel,
} from '../../utils/preAssignment';
import SizeBasedBinAvailabilitySummary from '../SizeBasedBinAvailabilitySummary';
import SearchableSelect from '../common/SearchableSelect';
import AssignPrescriptionActionFooter from '../assign-prescriptions/AssignPrescriptionActionFooter';
import { navigate } from '@reach/router';
import { FeatureUnavailableCallout } from '../features/OtcDeliveryCallout';
import {
  fetchEntitlements,
  getSelectedBoxId,
  decorateLocationTypesWithLicense,
  isLocationTypeUsable,
  getFirstUsableLocationTypeId,
  getFeatureLockedRedirectPath,
  featureKeyForLocationType,
  findEntitlement,
  isFeatureUsable,
  KIOSK_MARKETPLACE_KEY,
  getInitialAssignLocationTypeId,
  getLocationTypeIdFromSearch,
} from '../../utils/productLicensing';
import {
  getDeliverTabLoading,
  stopDeliverTabLoading,
} from '../../utils/deliverTabLoading';
import {
  getAssignActionButtonSx,
  formatAssignActionTooltip,
  assignActionIconButtonSize,
} from '../assign-prescriptions/assignActionButtonStyles';

const mapLocationTypesHelper = (locationDetails, t) => {
  if (!Array.isArray(locationDetails)) {
    return [];
  }
  return locationDetails.map((type) => {
    if (!type) {
      return { id: null, label: '' };
    }
    if (type.locationtype_id === LOCATION_TYPE.Kiosk) {
      return { id: type.locationtype_id, label: t('API.LocationType.Kiosk') };
    }
    if (type.locationtype_id === LOCATION_TYPE.Home) {
      return { id: type.locationtype_id, label: t('API.LocationType.Home') };
    }
    if (type.locationtype_id === LOCATION_TYPE.Work) {
      return { id: type.locationtype_id, label: t('API.LocationType.Work') };
    }
    if (type.locationtype_id === LOCATION_TYPE.Courier) {
      return { id: type.locationtype_id, label: t('API.LocationType.Courier') };
    }
    if (type.locationtype_id === LOCATION_TYPE.Counter) {
      return { id: type.locationtype_id, label: t('API.LocationType.Counter') };
    }
    if (type.locationtype_id === LOCATION_TYPE.Curbside) {
      return { id: type.locationtype_id, label: t('API.LocationType.CurbSide') };
    }
    if (type.locationtype_id === LOCATION_TYPE.Bedside) {
      return { id: type.locationtype_id, label: t('API.LocationType.Bedside') };
    }
    if (type.locationtype_id === LOCATION_TYPE.Other) {
      return { id: type.locationtype_id, label: t('API.LocationType.Other') };
    }
    return type;
  });
};

const localeTheme = createTheme(
  {

  },
  localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR,
);
const LOGO_BLUE = '#00a7e1';
const detailsDialogTheme = createTheme(
  {
    palette: {
      primary: {
        main: LOGO_BLUE,
        dark: '#0077a3',
        light: '#5fd0f5',
        contrastText: '#fff',
      },
    },
  },
  localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR,
);
const moment = extendMoment(originalMoment);
const uuidv4 = require('uuid/v4');

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask='(#00) 000-0000'
      definitions={{
        '#': /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

let searchedRxNumbers = [];
// let tosterMsg = false;
let nums = Array.from(Array(5).keys());
let nums1 = Array.from(Array(12).keys());
let elem = ['A', 'B', 'C', 'D', 'E'];
function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  if (array && array.length <= 0) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const notifyChannelForContact = (email, phone, customer) => {
  const emailOn = customer && (customer.email_notification === true || customer.email_notification === 'true');
  const smsOn = customer && (customer.sms_notification === true || customer.sms_notification === 'true');
  if (smsOn && !emailOn) return 'sms';
  if (emailOn) return 'email';
  const hasEmail = String(email || '').trim() !== '';
  const hasPhone = String(phone || '').trim() !== '';
  if (!hasEmail && hasPhone) return 'sms';
  return 'email';
};

function getSorting(order, orderBy) {
  return order === 'desc'
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}

class EnhancedTableHead extends React.Component {
  createSortHandler = (property) => (event) => {
    this.props.onRequestSort(event, property);
  };

  handlePrescriptionResponse = (data, bin_info) => {
    // Shared handler to bind prescription response into component state
    if (!data || !data.response || !data.response.box) {
      const DefaultCartItem = {
        id: '-1',
        rxNo: '',
        drugname: '',
        ndcCode: '',
        price: '0.00',
        CoPayAmount: '0.00',
        qty: 0,
        ConsultRequire: false,
      };
      this.setState({
        searchedRxNo: [],
        searchedItems: [],
        rxNumber: '',
        selected: [],
        scanRxItems: [DefaultCartItem],
      });
      return;
    }

    const details = data.response.box;
    if (!details.customers || !details.customers.length) {
      const DefaultCartItem = {
        id: '-1',
        rxNo: '',
        drugname: '',
        ndcCode: '',
        price: '0.00',
        CoPayAmount: '0.00',
        qty: 0,
        ConsultRequire: false,
      };
      this.setState({
        searchedRxNo: [],
        searchedItems: [],
        rxNumber: '',
        selected: [],
        scanRxItems: [DefaultCartItem],
      });
      return;
    }

    // Preserve existing reminder data behavior
    if (bin_info) {
      this.setState({
        reminderData: { bin_info, data },
        isVisibleForPause: true,
      });
    }

    const basicDetails = details && details.customers[0];
    const orders = details && details.customers[0].orders[0];
    const typeId = orders.type_id;
    const stockcode = orders.stock_code;
    const pickupcode = orders.pucode;
    const rxItems = orders.items;
    const orderId = details && details.customers[0].orders[0].id;
    const rxNo = details && details.customers[0].orders[0].items[0].rx_no;
    const bindId = details && details.customers[0].orders[0].bin_id;
    const binSize = orders && orders.bin_size;
    const contactDetails = details && details.customers[0].contacts[0];
    const locationDetails = orders && orders.customerLocations;

    this.setState({
      stockCode: orders.stock_code,
      pickupCode: orders.pucode,
      locationDetails: locationDetails,
      basicDetails: basicDetails,
      contactDetails: contactDetails,
      PrintisCoolItem: orders['is_cool_item'],
      EmailID: contactDetails.email,
      phone: contactDetails.phone,
      notifyChannel: notifyChannelForContact(contactDetails.email, contactDetails.phone, basicDetails),
    });

    let address1;
    let address2;
    let city;
    let state;
    let zip;
    let country;
    let location_notes;

    if (locationDetails && locationDetails.length > 0) {
      const locationtypesdata = mapLocationTypesHelper(locationDetails, this.props.t);
      this.setState({
        locationtype: locationtypesdata,
        locationtype_id: locationtypesdata[0].id,
      });
      if (this.state.locationtype_id === LOCATION_TYPE.Kiosk) {
        const boxData = this.state.boxdata;
        boxData.forEach((item) => {
          if (this.state.box_id === item.id && item && item.address) {
            address1 = item.address.address_line_1 || '';
            address2 = item.address.address_line_2 || '';
            city = item.address.city || '';
            state = item.address.state || '';
            zip = item.address.zip || '';
            country = item.address.country || '';
            location_notes = item.address.location_notes || '';
          }
        });
      } else {
        locationDetails.forEach((type) => {
          if (this.state.locationtype_id === type.locationtype_id) {
            address1 = type.addressline1;
            address2 = type.addressline2;
            city = type.city;
            state = type.state;
            zip = type.zip;
            country = type.country;
            location_notes = type.location_notes;
          }
        });
      }
    } else {
      if (this.state.locationtype_id === LOCATION_TYPE.Kiosk) {
        const locationtypesdata = [
          { id: this.state.locationtype_id, label: this.props.t('API.LocationType.Kiosk') },
        ];
        this.setState({ locationtype: locationtypesdata });
        const boxData = this.state.boxdata;
        boxData.forEach((item) => {
          if (this.state.box_id === item.id && item && item.address) {
            address1 = item.address.address_line_1 || '';
            address2 = item.address.address_line_2 || '';
            city = item.address.city || '';
            state = item.address.state || '';
            zip = item.address.zip || '';
            country = item.address.country || '';
            location_notes = item.address.location_notes || '';
          }
        });
      }
    }

    if (typeId === DEVICE_TYPE.Hold) {
      this.setState({ isAlreadyOnHold: true });
    } else {
      this.setState({ isAlreadyOnHold: false });
    }
    if (typeId === DEVICE_TYPE.Assigned) {
      this.setState({ isAlreadyAssigned: true });
    } else {
      this.setState({ isAlreadyAssigned: false });
    }
    if (typeId === DEVICE_TYPE.Stocked) {
      this.setState({ is_stocked: true });
    } else {
      this.setState({ is_stocked: false });
    }

    let Patient = [];
    Patient.push({ id: basicDetails.id, name: basicDetails.name });
    let Arraycart = this.buildCartFromApiRxItems(rxItems);
    this.setState({
      isPatientSelectionDisabled: true,
      searchedItems: {
        FirstName: basicDetails.first_name,
        LastName: basicDetails.last_name,
        DateOfBirth: basicDetails.dob_str,
        MobileNo: this.state && this.state.phone,
        EmailID: this.state && this.state.EmailID,
        AddressLine1: address1,
        AddressLine2: address2,
        City: city,
        State: state,
        Zip: zip,
        Country: country,
        location_notes: location_notes,
        isCoolItem: orders && orders.is_cool_item,
      },
      rxNumber: rxNo,
      selectedBinId: bindId,
      selectedBinSize: this.resolveSelectedBinSize(bindId, binSize),
      binSizeLocked: true,
      isBinSizeRequired: false,
      isBinIdRequired: false,
      stockCode: stockcode,
      pickupCode: pickupcode,
      orderId: orderId,
      selectedPatient: Patient[0],
      readOnly: true,
      scanRxItems: Arraycart,
      isPatientRecordNumberRequired: false,
    });
    this.getPaymentDetails(orderId, basicDetails.id);
    this.getCartRxNumbers();
    this.setState({ assignedPrescription: details });
    this.forceUpdate();
  };

  render() {
    const {
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      isVisibleForPause,
      className,
      t,
    } = this.props;
    const rows = [
      {
        id: 'rxNo',
        numeric: false,
        disablePadding: false,
        label: t('Unplugged.RxHash'),
      },
      {
        id: 'drugname',
        numeric: false,
        disablePadding: false,
        label: t('Unplugged.DrugName'),
      },
      {
        id: 'ndcCode',
        numeric: false,
        disablePadding: false,
        label: t('Unplugged.NDCCode'),
      },
      {
        id: 'qty',
        numeric: false,
        disablePadding: false,
        label: t('Unplugged.Qty'),
      },
      {
        id: 'price',
        numeric: false,
        disablePadding: false,
        label: t('Unplugged.Price'),
      },
      {
        id: 'consultrequire',
        numeric: false,
        disablePadding: true,
        label: t('Unplugged.ConsultRequired'),
      },
      {
        id: 'isreturnable',
        numeric: false,
        disablePadding: true,
        label: t('Assign.IsReturnable'),
      },
      {
        id: 'iscontrolled',
        numeric: false,
        disablePadding: true,
        label: t('Assign.IsControlled'),
      }
    ];
    return (
      <TableHead>
        <TableRow style={{ height: 'auto' }}>
          {!isVisibleForPause && (
            <TableCell
              padding='checkbox'
              style={{ padding: 0, textAlign: 'center', width: 36, maxWidth: 36 }}>
              <Checkbox
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={numSelected === rowCount}
                onChange={onSelectAllClick}
                style={{ color: '#4fc3f7' }}
              />
            </TableCell>
          )}
          {rows.map((row) => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === row.id ? order : false}
                className={className}
                style={{
                  textAlign: 'left',
                  fontSize: '0.68rem',
                  fontWeight: 600,
                  whiteSpace: 'normal',
                  lineHeight: 1.2,
                  verticalAlign: 'bottom',
                  padding: '6px 4px',
                  wordBreak: 'normal',
                  overflowWrap: 'normal',
                  hyphens: 'none',
                }}>
                <Tooltip
                  title={t("Global.Label.Filter.Sort")}
                  placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}>
                  <TableSortLabel
                    active={orderBy === row.id}
                    direction={order}
                    onClick={this.createSortHandler(row.id)}
                    sx={{
                      whiteSpace: 'normal',
                      height: 'auto',
                      alignItems: 'flex-start',
                      wordBreak: 'normal',
                      overflowWrap: 'normal',
                      hyphens: 'none',
                      '& .MuiTableSortLabel-icon': { flexShrink: 0, mt: '2px' },
                    }}>
                    {row.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number,
  onRequestSort: PropTypes.func,
  onSelectAllClick: PropTypes.func,
  order: PropTypes.string,
  orderBy: PropTypes.string,
  rowCount: PropTypes.number,
  className: PropTypes.object.isRequired,
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: '#4fc3f7',
        backgroundColor: 'rgb(255, 234, 231)',
      }
      : {
        color: '#4fc3f7',
        backgroundColor: 'rgb(255, 234, 231)',
      },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
  add: {
    //backgroundColor: theme.palette.secondary.main,
    backgroundColor: '#0284c7',
    color: '#fff',
    transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      backgroundColor: '#0284c7',
      color: '#fff',
    },
  },
  gridActions: {
    display: 'inline-block',
    width: '144px',
  },
  deletePrimaryButton: {
    background: 'none',
    color: 'rgba(0, 0, 0, 0.54)',
    '&:hover': {
      background: '#0284c7',
      color: '#fff',
    },
  },
});

let EnhancedTableToolbar = (props) => {
  const {
    numSelected,
    classes,
    /* add,  deleteUsers, editUser, viewUser, */ confirmDelete,
  } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}>
      <div className={classes.title}>
        {numSelected > 0 && (
          <Typography color='inherit' variant='subheading'>
            {numSelected} selected
          </Typography>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected === 1 && (
          <div>
            {/* <div className={classes.gridActions}> */}
            <Tooltip key='single-delete' title='Delete'>
              <IconButton
                aria-label='Delete'
                onClick={confirmDelete}
                className={classes.deletePrimaryButton}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </div>
        )}
        {numSelected > 1 && (
          <Tooltip key='multi-delete' title='Delete'>
            <IconButton
              aria-label='Delete'
              onClick={confirmDelete}
              className={classes.deletePrimaryButton}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      thousandSeparator
      prefix='$'
      decimalScale={2}
      allowNegative={false}
      decimalSeparator={'.'}
      fixedDecimalScale={true}
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};


export class AssignPrescriptions extends Component {
  triggerPreAssignmentRefresh = () => {
    this.setState({ makePreAssignmentAPICall: false }, () => {
      setTimeout(() => {
        this.setState({ makePreAssignmentAPICall: true });
      }, 0);
    });
  };
  refreshAfterHoldResume = () => {
    const { isSizeBasedPreAssignment, box_id } = this.state;
    if (isSizeBasedPreAssignment) {
      this.triggerPreAssignmentRefresh();
    } else if (box_id) {
      this.setState(
        (prev) => ({ binLayoutRefreshKey: prev.binLayoutRefreshKey + 1 }),
        () => this.getAssignedBins(box_id)
      );
    }
  };
  triggerFastlaneMatrixRefresh = () => {
    this.setState({ makeFastlaneAPICall: false }, () => {
      setTimeout(() => {
        this.setState({ makeFastlaneAPICall: true });
      }, 0);
    });
  };
  handleBinsSectionRefreshSettled = () => {
    this.setState({ binsRefreshing: false });
  };
  refreshBinsSection = () => {
    const { box_id, binsRefreshing, isSizeBasedPreAssignment, boxTypeId, locationtype_id } =
      this.state;
    if (binsRefreshing || !box_id) {
      return;
    }
    if (locationtype_id !== LOCATION_TYPE.Kiosk) {
      return;
    }
    const nextBox = (this.state.boxdata || []).find(
      (box) => box && String(box.id) === String(box_id)
    );
    const isSizeBased =
      isSizeBasedPreAssignment || resolveSizeBasedAssignUIFromBox(nextBox);
    if (isSizeBased) {
      this.setState({ binsRefreshing: true }, () => {
        this.triggerPreAssignmentRefresh();
      });
      return;
    }
    const isFastlaneFamily =
      boxTypeId === BOX_TYPE.FASTLANE || boxTypeId === BOX_TYPE.FASTLANEGOLIATH;
    if (isFastlaneFamily) {
      this.triggerFastlaneMatrixRefresh();
    }
    this.getAssignedBins(box_id, { sectionRefresh: true });
  };
  renderBinsSectionRefreshButton = (t) => {
    const { binsRefreshing, box_id } = this.state;
    const refreshLabel = t('Location.Refresh', { defaultValue: 'Refresh' });
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          width: '98%',
          mb: 0.5,
        }}
      >
        <Tooltip title={refreshLabel}>
          <span>
            <IconButton
              size='small'
              onClick={this.refreshBinsSection}
              disabled={binsRefreshing || !box_id}
              aria-label={refreshLabel}
              sx={{ p: 0.5 }}
            >
              {binsRefreshing ? (
                <CircularProgress size={16} />
              ) : (
                <RefreshRoundedIcon fontSize='small' />
              )}
            </IconButton>
          </span>
        </Tooltip>
      </Box>
    );
  };

  constructor(props) {
    super(props);
    this.state = {
      rxDetails: [
        {
          PatientID: '100001',
          FirstName: 'John',
          LastName: 'Smith',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '51655-157',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123456',
                  name: 'Amoxicillan',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 10,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 10,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                  strength: '500 mg/1',
                  route: 'Oral',
                  doseage_form: 'Capsule',
                  non_proprietary_name: 'Amoxicillan',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100002',
          FirstName: 'Paul',
          LastName: 'Jones',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '0071-0155',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123457',
                  name: 'Lipitor',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 90,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 100,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                  strength: '10 mg/1',
                  route: 'Oral',
                  doseage_form: 'Tablet',
                  non_proprietary_name: 'atorvastatin calcium',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100003',
          FirstName: 'Nicole',
          LastName: 'Smith',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '55289-926',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123458',
                  name: 'Valtrex',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 30,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 75,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                  strength: '500 mg/1',
                  route: 'Oral',
                  doseage_form: 'Tablet',
                  non_proprietary_name: 'valacyclovir hydrochloride',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100001',
          FirstName: 'John',
          LastName: 'Smith',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '50742-189',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123459',
                  name: 'Prednisone',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 15,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 50,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100002',
          FirstName: 'Paul',
          LastName: 'Jones',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '51655-157',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123460',
                  name: 'Amoxicillan',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 10,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 10,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100003',
          FirstName: 'Nicole',
          LastName: 'Smith',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '0071-0155',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123461',
                  name: 'Lipitor',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 90,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 100,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100001',
          FirstName: 'John',
          LastName: 'Smith',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '55289-926',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123462',
                  name: 'Valtrex',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 30,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 75,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100002',
          FirstName: 'Paul',
          LastName: 'Jones',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '50742-189',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123463',
                  name: 'Prednisone',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 15,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 50,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100003',
          FirstName: 'Nicole',
          LastName: 'Smith',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '51655-157',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123464',
                  name: 'Amoxicillan',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 10,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 10,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
                {
                  ndcCode: '51655-157',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123444',
                  name: 'Amoxicillan',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 10,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 10,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100010',
          FirstName: 'Michael',
          LastName: 'Thomas',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '0071-0155',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123465',
                  name: 'Lipitor',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 90,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 100,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100011',
          FirstName: 'Joseph',
          LastName: 'Box',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '55289-926',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123466',
                  name: 'Valtrex',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 30,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 75,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100012',
          FirstName: 'Paul',
          LastName: 'Patient',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '50742-189',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123467',
                  name: 'Prednisone',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 15,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 50,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100013',
          FirstName: 'Paul',
          LastName: 'Patient',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '51655-157',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123468',
                  name: 'Amoxicillan',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 10,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 10,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100014',
          FirstName: 'Bryan',
          LastName: 'Rigney',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '0071-0155',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123469',
                  name: 'Lipitor',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 90,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 100,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100015',
          FirstName: 'Ivan',
          LastName: 'Smith',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '55289-926',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123470',
                  name: 'Valtrex',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 30,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 75,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100016',
          FirstName: 'Jonah',
          LastName: 'Smith',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '50742-189',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123471',
                  name: 'Prednisone',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 15,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 50,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100017',
          FirstName: 'Grayson',
          LastName: 'Smith',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '51655-157',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123472',
                  name: 'Amoxicillan',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 10,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 10,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100018',
          FirstName: 'Gabriel',
          LastName: 'Smith',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '0071-0155',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123473',
                  name: 'Lipitor',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 90,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 100,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100019',
          FirstName: 'Vishal',
          LastName: 'Zacharias',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '55289-926',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123474',
                  name: 'Valtrex',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 30,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 75,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100060',
          FirstName: 'Manav',
          LastName: 'Pandya',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'manav.pandya@epistic.net',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '55289-926',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'Z123474',
                  name: 'Valtrex',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 30,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 75,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
                {
                  ndcCode: '55289-927',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'Z123475',
                  name: 'Valtrex',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 30,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 75,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
      ],
      selectedBinId: '',
      stockCode: '',
      pickupCode: '',
      searchedRxNo: [],
      prescriptionMasterData: {},
      rxNumber: '',
      selected: [],
      box: [],
      hasError: false,
      box_id: getSelectedBoxId() || null,
      pharmacyDetails: {},
      accountDetails: {},
      BinStatus: [],
      binLayoutRefreshKey: 0,
      binsRefreshing: false,
      deactivatedBins: [],
      assignedPrescription: {},
      isVisibleForPause: false,
      isBoxSelected: false,
      selectedUnitName: '',
      customervalues: [],
      customerList: [],
      popupDOB: null,
      scanRxItems: [],
      copyScanRxItems: [],
      scanFlagsDialogOpen: false,
      scanFlagRows: [],
      pendingSaveType: null,
      appDialog: {
        open: false,
        variant: 'error',
        title: '',
        message: '',
      },
      isPaymentRequired: false,
      CoPayAmountIndex: '',
      CoPayAmountValue: '0.00',
      readOnly: false,
      selectedPatient: {},
      expansionUnits: [
        {
          id: -1,
          order: 0,
          pos: 'M',
          selectedUnitIndex: 0,
          box_position: 0,
        },
      ],
      box_expansions_id: '',
      isADACompatible: false,
      locationtype_id: getInitialAssignLocationTypeId(
        typeof window !== 'undefined' ? window.location.search : ''
      ) || '',
      featureEntitlements: null,
      EmailID: '',
      notifyChannel: 'email',
      phone: '',
      is_stocked: false,
      order: 'desc',
      orderBy: 'created_on',
      PrintFirstName: '',
      PrintLastName: '',
      ADAData: [],
      SearchResultDialogOpen: false,
      reminderData: [],
      source_location: '',
      delivery_notes: '',
      order_notes: '',
      patient_notes: '',
      boxdata: [],
      prefer_location_name: '',
      courier_type: [],
      courier_tracking: '',
      default_courier_selected: '',
      isEdit: false,
      indexNo: null,
      page: 0,
      rowsPerPage: 10,
      printDialogOpen: false,
      selectedObject: [],
      searchObj: {
        searchTxt: '',
        pageNo: 0,
        pageSize: 10,
        sortOrder: 'desc',
      },
      patientSearchInput: '',
      openAutoComplete: false,
      isVerifyingBin: false,
      isVerifyingBinMessage: '',
      doesPatientSelected: false,
      boxTypeId: '',
      brandPhone: '',
      brandName: '',
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
      patientNotes: '',
      patientNotesReadOnly: true,
      selectedBinSize: '',
      binSizeByBinId: {},
      binSizeLocked: false,
      isBinSizeRequired: false,
      isSizeBasedPreAssignment: false,
      isBinIdRequired: false,
      key: 0,
      isPatientSelectionDisabled: false,
      largeBinsCount: 0,
      mediumBinsCount: 0,
      smallBinsCount: 0,
      coolBinsCount: 0,
      binCountsBySize: {},
      makePreAssignmentAPICall: false,
      makeFastlaneAPICall: false,
      isPatientRecordNumberRequired: false,
      is_returnable: false,
      isManualOverridePermissionEnabled: false, 
      prescriptionUnAssign: false, 
      prescriptionAssign: false, 
      prescriptionView: false,
      prescriptionDirectPickup: false,
      prescriptionRemind: false,
      prescriptionConsult: false,
      prescriptionHoldResume: false,
      prescriptionAcDc: false,
      isOpenPath: false,
      printLoading: false,
      binid: null,
      pmid: null,
      rxEntries: [],
    };
    this.textInput = React.createRef();
  }

  initSocket = async (authToken) => {
    if (!this.socket && this.user) {
      /**
       ** Socket Initialization **
       */

      this.socket = io(
        `${process.env.REACT_APP_VIDEO_SOCKET_BASEURL}/console-socket`,
        {
          transports: ['websocket'],
          auth: {
            token: `Bearer ${this.user.signInUserSession.idToken.jwtToken}`,
          },
          secure: true,
        }
      );

      /**
       ** Internal Socket Event **
       */

      this.socket &&
        this.socket.on('connect', () => {
          console.log('Socket connection established from PORTAL(ReConnect)');
        });
      this.socket &&
        this.socket.on('connect_error', (error) => {
          console.log('Connect Error: ', error);
          if (
            error.message === 'TokenExpiredError' ||
            error.message === 'JsonWebTokenError' ||
            error.message === 'NoTokenFound'
          ) {
            console.log('Token issue!');
          }
        });
      this.socket &&
        this.socket.on('connect_failed', (error) => {
          console.log('Connect Failed: ', error);
        });
      this.socket &&
        this.socket.on('error', (error) => {
          console.log('Error: ', error);
        });
      this.socket &&
        this.socket.on('disconnect', (reason) => {
          console.log(
            `Socket Disconnected From Portal and Reason is: ${reason}`
          );
        });
    }
  };

  componentWillUnmount() {
    this.socket && this.socket.disconnect();
    this.socket = false;
  }

  async componentDidMount() {
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.getBoxes(0);
    this.getSelectedUnitName(0);
    this.getFlageForPaymentRequired();
    let kioskId = 'a5bd2ad0-0780-42cd-a270-7e76c4f20500';
    const urlTypeId = getLocationTypeIdFromSearch(
      (this.props.location && this.props.location.search) ||
        (typeof window !== 'undefined' && window.location.search) ||
        ''
    );
    this.getAllBoxes(urlTypeId || this.state.locationtype_id || kioskId);
    !this.socket && (await this.initSocket());
    this.is_pre_assignment = ['true', true].includes(sessionStorage.getItem('is_pre_assignment'));
    this.setPermission();
    this.loadFeatureEntitlements();
    this.maybeStopDeliverTabLoading();
  }

  componentDidUpdate(prevProps) {
    const prevSearch = prevProps.location && prevProps.location.search;
    const nextSearch = this.props.location && this.props.location.search;
    if (prevSearch !== nextSearch) {
      this.applyDeliveryTypeFromUrl();
    }
    this.maybeStopDeliverTabLoading();
  }

  maybeStopDeliverTabLoading = () => {
    const loadingType = getDeliverTabLoading();
    if (!loadingType) {
      return;
    }
    const activeKey = featureKeyForLocationType(this.getActiveLocationTypeId());
    if (activeKey === loadingType) {
      stopDeliverTabLoading();
    }
  };

  applyDeliveryTypeFromUrl = () => {
    const search =
      (this.props.location && this.props.location.search) ||
      (typeof window !== 'undefined' && window.location.search) ||
      '';
    const typeId = getLocationTypeIdFromSearch(search);
    if (!typeId || typeId === this.state.locationtype_id) {
      return;
    }
    if (!Array.isArray(this.state.featureEntitlements)) {
      try {
        localStorage.setItem('selectedLocationTypeId', typeId);
      } catch (_err) {
        // ignore
      }
      this.setState({ locationtype_id: typeId });
      return;
    }
    this.handletypeChange(typeId);
  };

  syncDeliveryTypeInUrl = (locationTypeId) => {
    const featureKey = featureKeyForLocationType(locationTypeId);
    const path =
      (this.props.location && this.props.location.pathname) ||
      (typeof window !== 'undefined' && window.location.pathname) ||
      '';
    if (!path) {
      return;
    }
    const nextHref = featureKey ? path + '?type=' + featureKey : path;
    const currentSearch =
      (this.props.location && this.props.location.search) ||
      (typeof window !== 'undefined' && window.location.search) ||
      '';
    const currentHref = path + currentSearch;
    if (currentHref === nextHref) {
      return;
    }
    navigate(nextHref, { replace: true });
  };

  loadFeatureEntitlements = () => {
    fetchEntitlements({ boxId: getSelectedBoxId() || this.state.box_id })
      .then((data) => {
        this.setState(
          { featureEntitlements: (data && data.entitlements) || [] },
          () => this.bounceUnlicensedLocationType()
        );
      })
      .catch(() => {
        this.setState({
          featureEntitlements: Array.isArray(this.state.featureEntitlements)
            ? this.state.featureEntitlements
            : null,
        });
      });
  };

  bounceUnlicensedLocationType = () => {
    if (!Array.isArray(this.state.featureEntitlements)) {
      return;
    }
    if (isLocationTypeUsable(this.state.locationtype_id, this.state.featureEntitlements)) {
      return;
    }
    const nextLocationTypeId = getFirstUsableLocationTypeId(
      this.state.locationtype,
      this.state.featureEntitlements,
      this.state.locationtype_id
    );
    if (nextLocationTypeId && nextLocationTypeId !== this.state.locationtype_id) {
      this.handletypeChange(nextLocationTypeId);
    }
  };

  getCurrentLocationTypeEntitlement = () => {
    const featureKey = featureKeyForLocationType(this.state.locationtype_id);
    if (!featureKey) {
      return null;
    }
    return findEntitlement(this.state.featureEntitlements, featureKey);
  };

  getActiveLocationTypeId = () => {
    const current = this.state.locationtype_id;
    if (!Array.isArray(this.state.featureEntitlements)) {
      return current || LOCATION_TYPE.Kiosk;
    }
    if (isLocationTypeUsable(current, this.state.featureEntitlements)) {
      return current;
    }
    return (
      getFirstUsableLocationTypeId(
        this.state.locationtype,
        this.state.featureEntitlements,
        current
      ) || LOCATION_TYPE.Kiosk
    );
  };

  renderLocationTypeLicenseCallout = () => {
    const entitlement = this.getCurrentLocationTypeEntitlement();
    if (
      !entitlement ||
      isLocationTypeUsable(this.state.locationtype_id, this.state.featureEntitlements)
    ) {
      return null;
    }
    return (
      <FeatureUnavailableCallout
        t={this.props.t}
        entitlement={entitlement}
        boxId={this.state.box_id}
      />
    );
  };

  /** Assign UI variant is driven only by box.selected_regioin (en_CA / fr_CA vs other). */
  syncAssignUIFromBoxRegion = (boxId) => {
    if (!boxId) {
      this.setState({ isSizeBasedPreAssignment: false });
      this.BinSizes = [];
      return;
    }
    const box =
      this.state &&
      this.state.boxdata &&
      this.state.boxdata.find((x) => x.id === boxId);
    const isSizeBased = resolveSizeBasedAssignUIFromBox(box);
    this.BinSizes = isSizeBased ? [...SIZE_BASED_ASSIGN_BIN_SIZES] : [];
    this.setState({ isSizeBasedPreAssignment: isSizeBased });
  };

  getAllBoxes = async (id) => {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'getBoxesById/' + id, {
      method: 'get',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          this.setState({ loader: false });
          return null;
        }
      })
      .then((data) => {
        if (data && data.length > 0) {
          const preferredId = getSelectedBoxId();
          const preferredBox = preferredId
            ? data.find((x) => x && String(x.id) === String(preferredId))
            : null;
          const currentBox = this.state.box_id
            ? data.find((x) => x && String(x.id) === String(this.state.box_id))
            : null;
          const selectedBox = preferredBox || currentBox || data[0];
          const boxId = selectedBox.id;
          const tmp = data.map((val) => {
            return {
              id: val.id,
              value: val.name,
              location_notes: val.location_notes,
              brandName: val.brandName,
              brandPhone: val.brandPhone,
              location_type_id: val.location_type_id,
              type_id: val.type_id,
              ...val,
            };
          });
          const obj = data.find((x) => String(x.id) === String(boxId));
          this.getAssignedBins(boxId);
          this.getBoxesByID(boxId);
          this.getBoxes();
          this.setState({
            boxdata: tmp,
            box_id: boxId,
            ...(obj
              ? {
                boxTypeId: obj.type_id,
                prefer_location_name: obj.name,
                locationtype_id: obj.location_type_id,
                brandPhone: obj.brandPhone,
                brandName: obj.brandName
              }
              : {}),
            hasError: false,
            selectedBinId: '',
            isBoxSelected: true,
            loader: false,
          });
          this.syncAssignUIFromBoxRegion(boxId);
        } else {
          this.setState({ boxdata: [], loader: false });
        }
      });
  };

  //Naresh Start
  getFlageForPaymentRequired() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'getConnection', {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((accountConnectionsId) => {
        if (
          accountConnectionsId !== null &&
          accountConnectionsId.length > 0 &&
          accountConnectionsId[0].is_payment_required !== ''
        ) {
          this.setState({
            isPaymentRequired: accountConnectionsId[0].is_payment_required,
            loader: false
          });
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  }

  textInputHandler = (type, value) => {
    this.setState({ [type]: value });
  };

  getCustomer(queryParam) {
    fetch(
      process.env.REACT_APP_BASEURL + 'Getcustomers?searchText=' + queryParam,
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
      }
    )
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((data) => {
        if (data) {
          const cuslist = data.map((cus) => {
            return { id: cus.id, name: cus.name + ' | ' + cus.dob_str };
          });
          this.setState({ customervalues: cuslist });
          this.setState({ customerList: data });
        }
      });
  }
  onPatientChange = (event) => {
    if (event.length > 3) {
      this.getCustomer(event);
    }
  };

  handleDialogClose = (event) => {
    this.setAutoCompleteOpen(false);
    this.setState({
      showDialog: false,
      popupDOB: null,
      popupphone: '',
      customervalues: [],
      openAutoComplete: false,
    });
    this.onOptionSelect(null, null, 'clear');
  };
  handleCoPayAmountDialogClose = (index, dataType, value) => {
    if (dataType === 'CoPayAmount') {
      dataType = 'price';
      let newState = this.state.scanRxItems.map((item, i) => {
        if (i === index) {
          return { ...item, [dataType]: value };
        }
        return item;
      });
      this.setState({
        scanRxItems: newState,
        CoPayAmountIndex: index,
        CoPayAmountValue: value,
      });
    } else {
      this.setState({ showCoPayAmountDialog: value });
    }
  };

  handleDialogValidate = async (event) => {
    const { t } = this.props;
    let isValidate = false;
    let validatedPatient = null;
    const pObj = this.state.customerList.find(
      (x) => x.id === this.state.selectedPatient.id
    );
    if (pObj && pObj.id) {
      let cusdob = pObj.dob_str
        ? moment(pObj.dob_str).format('YYYY-MM-DD')
        : null;
      let txtdob = this.state.popupDOB
        ? moment(this.state.popupDOB).format('YYYY-MM-DD')
        : null;
      const primaryContact =
        (Array.isArray(pObj.contacts) && pObj.contacts[0]) || {};
      let cusphone =
        primaryContact.phone !== '' && primaryContact.phone != null
          ? primaryContact.phone
          : null;
      let txtphone =
        this.state.popupphone !== '' && this.state.popupphone !== undefined
          ? this.state.popupphone
          : null;
      let address1;
      let address2;
      let city;
      let state;
      let zip;
      let country;

      const customerLocations = Array.isArray(pObj.customerLocations)
        ? pObj.customerLocations
        : [];
      // Prefer default address; otherwise use any saved location (truthy flag, not === true).
      let locationDetails = customerLocations.filter(
        (x) => x && (x.is_default_address === true || x.is_default_address === 'true' || x.is_default_address === 1)
      );
      if (!locationDetails.length) {
        locationDetails = customerLocations.filter(Boolean);
      }

      let locationtypesdata = [];
      if (locationDetails.length > 0) {
        locationtypesdata = locationDetails.map((type) => {
          const mapped = mapLocationTypesHelper([type], this.props.t);
          const base = (mapped && mapped[0]) || {};
          return {
            ...type,
            id: base.id || type.locationtype_id || type.id,
            label: base.label || type.label,
          };
        });
      } else if (this.state.locationtype_id) {
        // User selected a location/box on the form even if patient has no saved locations.
        const selectedFromState =
          (Array.isArray(this.state.locationtype) &&
            this.state.locationtype.find(
              (loc) =>
                loc &&
                (loc.id === this.state.locationtype_id ||
                  loc.box_id === this.state.box_id)
            )) ||
          null;
        locationtypesdata = [
          selectedFromState || {
            id: this.state.locationtype_id,
            label: this.props.t('API.LocationType.Kiosk'),
            box_id: this.state.box_id,
          },
        ];
      }

      const primaryLocation =
        locationtypesdata[0] ||
        customerLocations[0] ||
        {
          id: this.state.locationtype_id,
          box_id: this.state.box_id,
        };

      if (locationtypesdata.length > 0) {
        this.setState({
          locationtype: locationtypesdata,
          locationtype_id: primaryLocation.id || this.state.locationtype_id,
          box_id: primaryLocation.box_id || this.state.box_id,
        }, () => this.bounceUnlicensedLocationType());
      }

      const resolvedTypeId = primaryLocation.id || this.state.locationtype_id;
      const resolvedBoxId = primaryLocation.box_id || this.state.box_id || null;
      const boxTypes = Array.isArray(this.state.boxTypes) ? this.state.boxTypes : [];

      if (resolvedTypeId === LOCATION_TYPE.Kiosk) {
        const item = boxTypes.find((box) =>
          [this.state.box_id, resolvedBoxId].includes(box.id)
        );
        if (item && item.address) {
          address1 = item.address.address_line_1;
          address2 = item.address.address_line_2;
          city = item.address.city;
          state = item.address.state;
          zip = item.address.zip;
          country = item.address.country;
        }
      } else if (primaryLocation) {
        address1 = primaryLocation.addressline1;
        address2 = primaryLocation.addressline2;
        city = primaryLocation.city;
        state = primaryLocation.state;
        zip = primaryLocation.zip;
        country = primaryLocation.country;
      }

      if (
        cusdob === txtdob &&
        this.ReplacePhone(cusphone).replace(/-/g, '') ===
        this.ReplacePhone(txtphone).replace(/-/g, '')
      ) {
        isValidate = true;
        const nameParts = String(pObj.name || '')
          .split('|')[0]
          .trim()
          .split(/\s+/)
          .filter(Boolean);
        validatedPatient = {
          phone: primaryContact.phone,
          EmailID: primaryContact.email,
          notifyChannel: notifyChannelForContact(primaryContact.email, primaryContact.phone),
          box_id: resolvedBoxId,
          searchedItems: {
            FirstName: pObj.first_name || nameParts[0] || '',
            LastName: pObj.last_name || nameParts.slice(1).join(' ') || '',
            DateOfBirth: pObj.dob_str || '',
            MobileNo: primaryContact.phone,
            EmailID: primaryContact.email,
            PatientID: pObj.patient_id || '',
            AddressLine1: address1,
            AddressLine2: address2,
            City: city,
            State: state,
            Zip: zip,
            Country: country,
            notes: pObj.notes,
            location_notes: primaryLocation.location_notes,
            order_notes: primaryLocation.patient_notes,
          },
          patientNotes: this.validateFields(pObj && pObj.notes),
        };
        this.setState({
          ...validatedPatient,
          customervalues: [],
          openAutoComplete: false,
          patientNotesReadOnly: false,
        });
      }

      if (resolvedTypeId) {
        await this.handletypeChange(resolvedTypeId);
      }
      if (resolvedBoxId) {
        await this.handleChange(resolvedBoxId);
      }
    }

    if (!isValidate) {
      toast.error(t("Assign.DoesNotMatch"));
    } else {
      const DefaultCartItem = {
        id: '-1',
        rxNo: '',
        drugname: '',
        ndcCode: '',
        price: '0.00',
        CoPayAmount: '0.00',
        qty: 0,
        ConsultRequire: false,
      };
      this.setState((prev) => {
        const current =
          prev.searchedItems && !Array.isArray(prev.searchedItems)
            ? prev.searchedItems
            : {};
        const patient = validatedPatient || {};
        return {
          showDialog: false,
          popupDOB: null,
          popupphone: '',
          scanRxItems: [DefaultCartItem],
          customervalues: [],
          openAutoComplete: false,
          phone: patient.phone || prev.phone,
          EmailID: patient.EmailID || prev.EmailID,
          notifyChannel: patient.notifyChannel || prev.notifyChannel,
          patientNotes: patient.patientNotes,
          patientNotesReadOnly: false,
          searchedItems: {
            ...current,
            ...(patient.searchedItems || {}),
          },
        };
      });
      if (![undefined, 'undefined', null, 'null', ''].includes(pObj)) {
        if (![undefined, 'undefined', null, 'null', ''].includes(pObj.patient_id)) {
          const contact = (Array.isArray(pObj.contacts) && pObj.contacts[0]) || {};
          this.checkADACompatible(pObj.patient_id, contact.email, contact.phone);
        }
      }
      this.generateCodes();
      const focusOnRxField = document.getElementById('rxNo');
      focusOnRxField && focusOnRxField.focus();
    }
  };

  checkADACompatible = (PatientID, EmailID, phone) => {
    let patientObj = {
      PatientID: PatientID,
      EmailID: EmailID,
    };
    fetch(process.env.REACT_APP_BASEURL + 'getADACompatiblePatients', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(patientObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((Pdata) => {
        if (Pdata && Pdata.ADAcustomers && Pdata.ADAcustomers.length > 0) {
          this.setState({ ADAData: Pdata.ADAcustomers, isADACompatible: true });
        } else {
          this.setState({ ADAData: [], isADACompatible: false, loader: false });
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };
  ReplacePhone = (phone) => {
    let newphone = '';
    if (phone && String(phone).length > 0) {
      newphone = String(phone)
        .replace('(', '')
        .replace(')', '')
        .replace(' ', '')
        .replace('-', '');
    }
    return newphone;
  };
  handlePhoneChange = (event) => {
    this.setState({ popupphone: event.target.value });
  };
  onDateSelect = (date) => {
    date = date ? moment(date).format() : '';
    this.setState({ popupDOB: date });
  };
  handleBlurdob = (e) => {
    let date = null;
    date =
      e.target.value && e.target.value !== ''
        ? moment(e.target.value).format()
        : null;
    this.setState({
      popupDOB: date,
    });
  };

  onRXValidate = (index, dataType, value) => {
    const rxValue = value == null ? '' : String(value).trim();
    if (rxValue === '') return true;

    if (this.checkExistRxNo(rxValue, index) > 0) {
      toast.error(this.props.t('Toast.Error.RxAddedToCart'));
      const scanRxItems = (this.state.scanRxItems || []).map((item, i) =>
        i === index ? { ...item, rxNo: '' } : item
      );
      this.setState({ scanRxItems, rxNumber: '', loader: false });
      return;
    }
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'checkrxexistornot/' + encodeURIComponent(rxValue) + '/false' , {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => response.json())
      .then((boxes) => {
        if (boxes && !boxes.Rx_Is_Exist) {
          let newState = this.state.scanRxItems.map((item, i) => {
            if (i === index) {
              this.state.rxDetails.filter((element) => {
                return element.orders.some((order) => {
                  return order.items.some((items) => {
                    const trulyValue =
                      items.rxNo.toString().toUpperCase() ===
                      rxValue.toString().toUpperCase();
                    return trulyValue;
                  })
                })
              });
              return { ...item, [dataType]: rxValue };
            }
            return item;
          });

          if (this.state.isPaymentRequired === true) {
            this.setState({
              showCoPayAmountDialog: true,
              CoPayAmountIndex: index,
              CoPayAmountValue: '0.00',
            });
          }
          const scanrxIndex = newState.findIndex((x) => x.rxNo === '');
          if (scanrxIndex > -1) {
          } else {
            const DefaultCartItem = {
              id: '-1',
              rxNo: '',
              drugname: '',
              ndcCode: '',
              price: '0.00',
              CoPayAmount: '0.00',
              qty: 0,
              ConsultRequire: false,
            };
            newState.push(DefaultCartItem);
          }
          this.setState({
            scanRxItems: newState,
            loader: false
          });
          const elements = document.querySelectorAll('#drugname');
          elements.length && elements[elements.length - 2].focus();
        } else {
          this.setState({ rxNumber: '', loader: false });
          toast.error(this.props.t('Toast.Error.RxAssigned'));
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  onScanRxChange = (index, dataType, value) => {
    if (dataType === 'rxNo') {
      if (value.toString().toUpperCase().length > 0) {
        const searchedString = value;
        this.setState({ rxNumber: searchedString && searchedString });
        let scanRxItems = this.state.scanRxItems.map((item, i) => {
          if (i === index) return { ...item, [dataType]: value };
          return item;
        });
        this.setState({ scanRxItems });
        if (searchedString.length === 20) {
          let { scanRxItems, accountDetails } = this.state;
          const rxNo = searchedString.substring(0, 8);
          const taxablePriceStr = searchedString.substring(8, 14);
          const nonTaxablePriceStr = searchedString.substring(14);
          const taxablePrice = Number(taxablePriceStr) / 100;
          const nonTaxablePrice = Number(nonTaxablePriceStr) / 100;
          let totalPrice = nonTaxablePrice;
          const taxRate = accountDetails && accountDetails.tax_data.tax_rate;
          if (accountDetails && accountDetails.is_taxable) {
            totalPrice = taxablePrice + nonTaxablePrice + taxablePrice * Number(taxRate)
          }
          scanRxItems = scanRxItems.map((item, index) => {
            if (index === scanRxItems.length - 1) {
              item.rxNo = rxNo
              item.price = totalPrice.toString()
              return item
            }
            return item
          })
          this.setState({ scanRxItems })
          setTimeout(() => {
            const elements = document.querySelectorAll('#drugname');
            elements.length && elements[elements.length - 1].focus();
          }, 10);
        }
      } else {
        let scanRxItems = this.state.scanRxItems.map((item, i) => {
          if (i === index) {
            return { ...item, [dataType]: value };
          }
          return item;
        });
        this.setState({ scanRxItems });
      }
    } else {
      let newState = this.state.scanRxItems.map((item, i) => {
        if (i === index) {
          return { ...item, [dataType]: value };
        }
        return item;
      });
      this.setState({
        scanRxItems: newState,
      });
    }
  };

  checkExistRxNo = (rxno, idx) => {
    const needle = String(rxno || '').trim().toLowerCase();
    if (!needle) return 0;
    return (this.state.scanRxItems || []).filter((item, index) => {
      if (index === idx) return false;
      const current = String((item && item.rxNo) || '').trim().toLowerCase();
      return current !== '' && current === needle;
    }).length;
  };

  getBoxesByID = (id) => {
    this.setState({ loader: true });
    fetch(`${process.env.REACT_APP_BASEURL}boxes/${id}`, {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((boxes) => {
        if (boxes.length > 0) {
          this.setState(
            {
              courier_type:
                boxes[0].courier_type && boxes[0].courier_type.length > 0
                  ? boxes[0].courier_type.map((val) => {
                    return val.courier_type;
                  })
                  : [],
            },
            () => {
              if (this.state.courier_type.length > 0) {
                this.setState({
                  default_courier_selected:
                    boxes[0].courier_type[0].default_courier_type,
                });
              }
            }
          );
          const locationNotes = (boxes[0] && boxes[0].location_notes) || '';
          this.setState((prev) => {
            const current = prev.searchedItems;
            if (!current || Array.isArray(current)) {
              return { loader: false };
            }
            return {
              loader: false,
              searchedItems: {
                ...current,
                location_notes: locationNotes || current.location_notes || '',
              },
            };
          });
          if (
            this.is_pre_assignment &&
            !this.state.isSizeBasedPreAssignment &&
            boxes[0].type_id === BOX_TYPE.Locker &&
            !this.BinSizes.includes('Large')
          ) {
            this.BinSizes.unshift('Large')
          }
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };
  //Naresh End
  getBoxes(value) {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'boxes', {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((boxtypes) => {
        if (boxtypes) {
          const tmp = boxtypes.map((val) => {
            return {
              id: val.id,
              value: val.name,
              location_notes: val.location_notes,
              brandName: val.brandName,
              brandPhone: val.brandPhone,
              location_type_id: val.location_type_id,
              type_id: val.type_id,
              ...val,
            };
          });
          if (boxtypes.length > 0) {
            if (value === 0) {
              const preferredId = getSelectedBoxId();
              const preferredBox = preferredId
                ? tmp.find((x) => x && String(x.id) === String(preferredId))
                : null;
              const defaultSelectedBoxId =
                this.state.box_id ||
                (preferredBox && preferredBox.id) ||
                tmp[0].id;
              if (!this.state.box_id) {
                this.setState({ box_id: defaultSelectedBoxId });
                this.getAssignedBins(defaultSelectedBoxId);
              }
              this.getPharmacyDetails(defaultSelectedBoxId);
              this.getExpansionBins(defaultSelectedBoxId);
              {
                const boxForRegion =
                  (this.state.boxdata &&
                    this.state.boxdata.find((b) => b.id === defaultSelectedBoxId)) ||
                  tmp.find((b) => b.id === defaultSelectedBoxId);
                if (resolveSizeBasedAssignUIFromBox(boxForRegion)) {
                  this.getAvailableBinsCount(defaultSelectedBoxId);
                }
              }
            } else {
              this.getAssignedBins(this.state && this.state.box_id);
              this.getPharmacyDetails(this.state && this.state.box_id);
              this.getExpansionBins(this.state && this.state.box_id);
              {
                const activeBoxId = this.state && this.state.box_id;
                const boxForRegion =
                  this.state.boxdata &&
                  this.state.boxdata.find((b) => b.id === activeBoxId);
                if (resolveSizeBasedAssignUIFromBox(boxForRegion)) {
                  this.getAvailableBinsCount(activeBoxId);
                }
              }
            }
          }
          // Do NOT set boxdata here: GET /boxes does not return brandName/brandPhone.
          // boxdata must come from getAllBoxes (getBoxesById) which includes brand info for labels.
          this.setState({ boxTypes: tmp, loader: false, isOpenPath: tmp && tmp.openpath });
        } else {
          this.setState({ loader: false });
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'locationtypes', {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => response.json())
      .then((locationtypes) => {
        if (locationtypes) {
          const locationtypesdata = [];
          let newLocationtypes = [
            ...new Set(locationtypes && locationtypes.map((obj) => obj.name)),
          ].map((name) => {
            return (
              locationtypes && locationtypes.find((obj) => obj.name === name)
            );
          });
          for (let i = 0; i < newLocationtypes.length; i++) {
            if (
              newLocationtypes[i].id !==
              '5e94cb81-ab9b-4e82-8b98-721a2d1794df' &&
              newLocationtypes[i].id !==
              'fd7c6330-8b9a-45e2-a1f6-f791db65f5d0' &&
              newLocationtypes[i].id !== 'ee98b36c-a0e9-4cc4-a411-6c925ad442b6'
            ) {
              let tmp = {};
              tmp = {
                id: newLocationtypes[i].id,
                label: this.props.t(newLocationtypes[i].name_es),
              };
              locationtypesdata.push(tmp);
            }
          }
          if (!this.state.locationtype_id) {
            this.setState({ locationtype_id: locationtypesdata.length > 0 ? locationtypesdata[0].id : [], loader: false });
          }
          this.setState({ locationtype: locationtypesdata, loader: false }, () =>
            this.bounceUnlicensedLocationType()
          );
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  }

  generateCodes() {
    const _stockCode = [true, "true"].includes(this.state.isOpenPath) || JSON.parse(localStorage.getItem("isNumericCode"))
      ? randomized("0", 4)
      : randomized("A0", 6, { exclude: "0oOiIlL1&zZ" });
    const _pickupCode = [true, "true"].includes(this.state.isOpenPath) || JSON.parse(localStorage.getItem("isNumericCode"))
      ? randomized("0", 4)
      : randomized("A0", 6, { exclude: "0oOiIlL1&zZ" });
    setTimeout(() => {
      this.checkIfCodesExists({
        stockCode: _stockCode,
        pickupCode: _pickupCode,
      });
    }, 3500);
  }

  normalizeBinKey = (binId) => String(binId || '').replace(/\s/g, '');
  binHasActiveOrder = (binId) => {
    const normalized = this.normalizeBinKey(binId);
    if (!normalized) {
      return false;
    }
    const { BinStatus, orderId, selectedBinId } = this.state;
    const hasOccupiedBin =
      Array.isArray(BinStatus) &&
      BinStatus.some(
        (entry) => this.normalizeBinKey(entry.bin_id) === normalized
      );
    const hasLoadedOrder =
      Boolean(orderId) &&
      this.normalizeBinKey(selectedBinId) === normalized;
    return hasOccupiedBin || hasLoadedOrder;
  };
  clearHoldResumeOrderState = () => ({
    isVisibleForPause: false,
    is_stocked: false,
    isAlreadyOnHold: false,
    isAlreadyAssigned: false,
  });
  hasHoldResumePermission = () => {
    try {
      const checkUserRole = JSON.parse(sessionStorage.getItem('permissionUser'));
      if (checkUserRole === userroles.SUPERADMIN) {
        return true;
      }
      const permissions = JSON.parse(sessionStorage.getItem('permissions')) || [];
      const assignPrescriptions = permissions.filter(
        (item) => item.permission_entity_type === 'Assign Prescription'
      );
      return assignPrescriptions.some(
        (x) => x.name.trim() === 'Hold/Resume' && x.is_allowed === 1
      );
    } catch (error) {
      return false;
    }
  };

  getSelectedBin = (binId, position, flag) => {
    const mappedSize = this.resolveSelectedBinSize(binId, '');
    const patch = {
      selectedBinId: binId,
      box_position: position,
      isSelectedFlag: flag,
      isBinIdRequired: false,
      selectedBinSize: mappedSize,
      binSizeLocked: Boolean(binId),
    };
    if (!this.binHasActiveOrder(binId)) {
      Object.assign(patch, this.clearHoldResumeOrderState());
    }
    this.setState(patch);
  };

  resolveSelectedBinSize = (binId, explicitSize) => {
    const fromOrder = resolveBinSizeLabel(explicitSize);
    if (fromOrder) {
      return fromOrder;
    }
    const key = binId === undefined || binId === null ? '' : String(binId).trim();
    if (!key) {
      return '';
    }
    const mapped = (this.binSizeByBinId || this.state.binSizeByBinId || {})[key];
    return resolveBinSizeLabel(mapped) || '';
  };

  storeBinSizeMap = (rows) => {
    const binSizeByBinId = {};
    (rows || []).forEach((row) => {
      if (!row || !row.bin_id) {
        return;
      }
      const label = resolveBinSizeLabel(row.bin_size);
      if (label) {
        binSizeByBinId[String(row.bin_id).trim()] = label;
      }
    });
    this.binSizeByBinId = binSizeByBinId;
    return (prev) => {
      const patch = { binSizeByBinId };
      const currentBin = prev.selectedBinId;
      const currentSize = resolveBinSizeLabel(prev.selectedBinSize);
      if (currentBin && !currentSize) {
        const mapped = binSizeByBinId[String(currentBin).trim()];
        if (mapped) {
          patch.selectedBinSize = mapped;
          patch.binSizeLocked = true;
        }
      }
      return patch;
    };
  };
  /*
      Added By : Belani Jaimin
      Added Date : 02/11/2019
      Description : Get Bin Status
    */
  getAssignedBins = (box_id, options = {}) => {
    const { sectionRefresh = false } = options;
    const { t } = this.props;
    const clearSectionRefresh = () => {
      if (sectionRefresh) {
        this.setState({ binsRefreshing: false });
      }
    };
    const clearGlobalLoader = () => {
      if (!sectionRefresh) {
        this.setState({ loader: false });
      }
    };
    if (!this.state.isSizeBasedPreAssignment && resolveSizeBasedAssignUIFromBox(
      (this.state.boxdata || []).find((box) => box && String(box.id) === String(box_id))
    )) {
      clearSectionRefresh();
      clearGlobalLoader();
      return;
    }
    if (!box_id) {
      clearSectionRefresh();
      clearGlobalLoader();
      return;
    }
    if (this.state.isSizeBasedPreAssignment) {
      clearSectionRefresh();
      clearGlobalLoader();
      return;
    }
    if (!sectionRefresh) {
      this.setState({ loader: true });
    }
    let _binStatus = [];
    if (sectionRefresh) {
      this.setState({ binsRefreshing: true });
    }
    fetch(process.env.REACT_APP_BASEURL + 'api/v2/orders/occupied-bins/' + box_id, {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`occupied-bins ${response.status}`);
        }
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((bins) => {
        clearGlobalLoader();
        try {
          _binStatus = bins ? JSON.parse(bins) : [];
        } catch (parseError) {
          clearSectionRefresh();
          if (sectionRefresh) {
            toast.error(
              t('Assign.RefreshBinsFailed', {
                defaultValue: 'Unable to refresh bin statuses. Please try again.',
              })
            );
          }
          return;
        }
        let deactivatedBins;
        if (_binStatus && _binStatus[0] && _binStatus[0].disabled_bins) {
          deactivatedBins = _binStatus[0].disabled_bins.toString().split(',');
          this.setState({
            deactivatedBins: deactivatedBins,
            BinStatus: _binStatus,
            ...(sectionRefresh ? { binsRefreshing: false } : {}),
          });
        } else {
          this.setState({
            deactivatedBins: [],
            BinStatus: _binStatus,
            ...(sectionRefresh ? { binsRefreshing: false } : {}),
          });
        }
      })
      .catch(() => {
        clearGlobalLoader();
        clearSectionRefresh();
        if (sectionRefresh) {
          toast.error(
            t('Assign.RefreshBinsFailed', {
              defaultValue: 'Unable to refresh bin statuses. Please try again.',
            })
          );
        }
      });
  };

  handleChange = async (value) => {
    const boxtype =
      this.state &&
      this.state.boxdata &&
      this.state.boxdata.length > 0 &&
      this.state.boxdata.find((x) => x && String(x.id) === String(value));
    boxtype &&
      this.setState({
        boxTypeId: boxtype.type_id,
        prefer_location_name: boxtype.value,
        box_id: value,
      });

    if (this.state.locationtype_id !== LOCATION_TYPE.Kiosk) return;
    this.syncAssignUIFromBoxRegion(value);
    this.getBoxesByID(value);
    this.getPharmacyDetails(value);
    this.getExpansionBins(value);

    if (this.state.selectedBinId !== '') {
      let items = document.getElementById(this.state.selectedBinId);
      items.style.removeProperty('background');
    }

    this.setState({
      hasError: false,
      selectedBinId: '',
      selectedBinSize: '',
      binSizeLocked: false,
      isBoxSelected: true,
    });
    this.getAssignedBins(value);
    this.getBoxes();
    const nextBox = (this.state.boxdata || []).find(
      (box) => box && String(box.id) === String(value)
    );
    if (resolveSizeBasedAssignUIFromBox(nextBox) || this.state.isSizeBasedPreAssignment) {
      this.getAvailableBinsCount(value);
    }
    setTimeout(() => {
      const elements = document.querySelectorAll('#rxNo');
      elements.length && elements[elements.length - 1].focus();
    }, 10);
  };

  handletypeChange = async (value) => {
    if (!isLocationTypeUsable(value, this.state.featureEntitlements)) {
      if (Array.isArray(this.state.featureEntitlements)) {
        const featureKey = featureKeyForLocationType(value);
        if (featureKey) {
          navigate(getFeatureLockedRedirectPath(featureKey));
        }
        return;
      }
    }
    this.syncDeliveryTypeInUrl(value);
    let orders =
      this.state && this.state.searchedItems && this.state.searchedItems.orders;
    const locationDetails = this.state.locationDetails;
    const basicDetails = this.state.basicDetails;
    const contactDetails = this.state.contactDetails;

    await this.getAllBoxes(value);

    let address1;
    let address2;
    let city;
    let state;
    let zip;
    let country;
    // eslint-disable-next-line
    let location_notes;
    if (locationDetails && locationDetails.length > 0) {
      if (value === LOCATION_TYPE.Kiosk) {
        const boxData = Array.isArray(this.state.boxdata) ? this.state.boxdata : [];
        boxData.forEach((item) => {
          if (item && String(this.state.box_id) === String(item.id) && item.address) {
            address1 = item.address.address_line_1;
            address2 = item.address.address_line_2;
            city = item.address.city;
            state = item.address.state;
            zip = item.address.zip;
            country = item.address.country;
            location_notes = item.address.location_notes;
          }
        });
      } else {
        locationDetails.forEach((type) => {
          if (value === type.locationtype_id) {
            address1 = type.addressline1;
            address2 = type.addressline2;
            city = type.city;
            state = type.state;
            zip = type.zip;
            country = type.country;
            location_notes = type.location_notes;
          }
        });
      }
      this.setState((prev) => {
        const prevItems =
          prev.searchedItems && !Array.isArray(prev.searchedItems)
            ? prev.searchedItems
            : {};
        const basic = basicDetails || prev.basicDetails;
        const contact = contactDetails || prev.contactDetails;
        return {
          loader: true,
          locationtype_id: value,
          EmailID: (contact && contact.email) || prev.EmailID,
          phone: (contact && contact.phone) || prev.phone,
          notifyChannel: notifyChannelForContact(
            (contact && contact.email) || prev.EmailID,
            (contact && contact.phone) || prev.phone
          ),
          searchedItems: {
            ...prevItems,
            FirstName: (basic && basic.first_name) || prevItems.FirstName || '',
            LastName: (basic && basic.last_name) || prevItems.LastName || '',
            DateOfBirth: (basic && basic.dob_str) || prevItems.DateOfBirth || '',
            PatientID: prevItems.PatientID || (basic && basic.patient_id) || '',
            MobileNo: (contact && contact.phone) || prevItems.MobileNo,
            EmailID: (contact && contact.email) || prevItems.EmailID,
            AddressLine1: address1 || prevItems.AddressLine1,
            AddressLine2: address2 || prevItems.AddressLine2,
            City: city || prevItems.City,
            State: state || prevItems.State,
            Zip: zip || prevItems.Zip,
            Country: country || prevItems.Country,
            orders: orders || prevItems.orders,
            location_notes: location_notes || prevItems.location_notes || '',
            notes: (basic && basic.notes) || prevItems.notes,
          },
          patientNotes: this.validateFields(
            (basic && basic.notes) || prevItems.notes || prev.patientNotes
          ),
        };
      });
    }
  };
  getPharmacyDetails(boxId) {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'boxes/' + boxId, {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((phrmacydetail) => {
        if (phrmacydetail && phrmacydetail[0]) {
          this.setState({ pharmacyDetails: phrmacydetail[0], loader: false });
          const accountId = phrmacydetail[0].parent_account_id;
          this.getAccountDetails(accountId);
          if (
            this.is_pre_assignment &&
            !this.state.isSizeBasedPreAssignment &&
            phrmacydetail[0].type_id === BOX_TYPE.Locker &&
            !this.BinSizes.includes('Large')
          ) {
            this.BinSizes.unshift('Large')
          }
        } else {
          this.setState({ loader: false });
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  }
  //Added by Naresh | DI-329 | Date:27-05-2019
  getExpansionBins(boxId) {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'box-expansions/' + boxId, {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((expansionDetails) => {
        let order = 0;
        let UnitLayout = [];
        let UnitIndex = 0;
        if (expansionDetails && expansionDetails.length > 0) {
          //Add Left side Unit
          UnitLayout = [];
          if (expansionDetails.findIndex((x) => x.direction === 1) > -1) {
            expansionDetails &&
              expansionDetails.map((unit, index) => {
                let boxlist = [];
                if (unit.direction === 1) {
                  boxlist = unit;
                  boxlist.order = order + 1;
                  boxlist.selectedUnitIndex = Math.abs(unit.box_position);
                  boxlist.pos = 'L';
                  boxlist.box_position = unit.box_position;
                  order = order + 1;
                  UnitLayout.push(boxlist);
                  UnitIndex = UnitIndex + 1;
                }
                if (this.is_pre_assignment && !this.state.isSizeBasedPreAssignment) {
                  if (unit.expansion_id === BOX_TYPE.Cool && !this.BinSizes.includes('Cool')) {
                    this.BinSizes.push('Cool');
                  }
                  if (unit.expansion_id === BOX_TYPE.L60 && !this.BinSizes.includes('Large')) {
                    this.BinSizes.unshift('Large');
                  }
                }
                return true;
              });
          }
          if (UnitLayout.length > 0) {
            UnitLayout.reverse();
          }
          order = order + 1;
          //UnitLayout.push({ id: -1, order: order, pos: 'M', selectedUnitIndex: 0, box_position: 0 });
          UnitIndex = UnitIndex + 1;
          const unitExpansions = {
            id: -1,
            order: order,
            pos: 'M',
            selectedUnitIndex: 0,
            box_position: 0,
          };
          const boxesExpansions =
            expansionDetails &&
            expansionDetails.find((x) => x.box.id === boxId);
          if (boxesExpansions && boxesExpansions !== undefined) {
            if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== '' &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.Locker
            ) {
              if (
                this.is_pre_assignment &&
                !this.state.isSizeBasedPreAssignment &&
                !this.BinSizes.includes('Large')
              ) {
                this.BinSizes.unshift('Large')
              }
              UnitLayout.push(unitExpansions);
            } else if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== '' &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.M22
            ) {
              unitExpansions.pos = 'M22';
              UnitLayout.push(unitExpansions);
            } else if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== '' &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.M24
            ) {
              unitExpansions.pos = 'M24';
              UnitLayout.push(unitExpansions);
            } else if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== '' &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.M41
            ) {
              unitExpansions.pos = 'M41';
              UnitLayout.push(unitExpansions);
            } else {
              UnitLayout.push(unitExpansions);
            }
          }

          //Add Right side Unit
          if (expansionDetails.findIndex((x) => x.direction === 2) > -1) {
            expansionDetails &&
              expansionDetails.map((unit, index) => {
                let boxlist = [];
                if (unit.direction === 2) {
                  boxlist = unit;
                  boxlist.order = order + 1;
                  boxlist.selectedUnitIndex = unit.box_position;
                  boxlist.pos = 'R';
                  boxlist.box_position = unit.box_position;
                  order = order + 1;
                  UnitLayout.push(boxlist);
                  UnitIndex = UnitIndex + 1;
                }
                if (this.is_pre_assignment && !this.state.isSizeBasedPreAssignment) {
                  if (unit.expansion_id === BOX_TYPE.Cool && !this.BinSizes.includes('Cool')) {
                    this.BinSizes.push('Cool');
                  }
                  if (unit.expansion_id === BOX_TYPE.L60 && !this.BinSizes.includes('Large')) {
                    this.BinSizes.unshift('Large');
                  }
                }
                return true;
              });
          }
        } else {
          order = order + 1;
          //UnitLayout.push({ id: -1, order: order, pos: 'M', selectedUnitIndex: 0, box_position: 0 });
          const unitExpansions = {
            id: -1,
            order: order,
            pos: 'M',
            selectedUnitIndex: 0,
            box_position: 0,
          };
          const boxes =
            this.state &&
            this.state.boxdata &&
            this.state.boxdata.length &&
            this.state.boxdata.length > 0 &&
            this.state.boxdata.find((x) => x.id === boxId);
          if (boxes && boxes !== undefined) {
            if (
              boxes &&
              boxes.type_id !== '' &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.Locker
            ) {
              UnitLayout.push(unitExpansions);
            } else if (
              boxes &&
              boxes.type &&
              boxes.type_id !== '' &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.M22
            ) {
              unitExpansions.pos = 'M22';
              UnitLayout.push(unitExpansions);
            } else if (
              boxes &&
              boxes.type &&
              boxes.type_id !== '' &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.M24
            ) {
              unitExpansions.pos = 'M24';
              UnitLayout.push(unitExpansions);
            } else if (
              boxes &&
              boxes.type &&
              boxes.type_id !== '' &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.box.type_id === BOX_TYPE.M41
            ) {
              unitExpansions.pos = 'M41';
              UnitLayout.push(unitExpansions);
            } else {
              UnitLayout.push(unitExpansions);
            }
          }
        }
        this.setState({ expansionUnits: UnitLayout, loader: false });
      }).catch(() => {
        this.setState({ loader: false });
      });
  }
  //End DI-329
  getAccountDetails(accountId) {
    this.setState({ loader: true });
    fetch(
      process.env.REACT_APP_BASEURL + 'account/' + accountId,
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
      },
      accountId
    )
      .then((response) => response.json())
      .then((accountdetail) =>
        this.setState({ accountDetails: accountdetail && accountdetail[0], loader: false })
      ).catch(() => {
        this.setState({ loader: false });
      });
  }
  EventLogHanlder = (uData) => {
    let tofor_id = '';
    let descriptions = '';
    tofor_id =
      uData && uData.prescriptions_master && uData.prescriptions_master.id;
    descriptions =
      'Prescription is Assigned with stock code ' +
      this.state.stockCode +
      ' and pick up code ' +
      this.state.pickupCode +
      ' with Rx No ' +
      this.state.rxNumber;

    let event_name = '';
    let event_type_name = '';
    if (this.state.locationtype_id === LOCATION_TYPE.Kiosk) {
      event_name = EVENT_CRUD_TYPES.INSERT;
      event_type_name = EVENT_TYPES.ASSIGNED;
    } else {
      event_name = EVENT_CRUD_TYPES.INSERT;
      event_type_name = EVENT_TYPES.Ready;
    }

    const event_params = {
      event_name: event_name,
      event_type_name: event_type_name,
      description: descriptions,
      object_id: assignmentstatus.ASSIGNED,
      tofor_id: tofor_id,
      box_id: this.state.box_id,
    };
    new EventLogHandler().handleEventLog(event_params);
  };

  ReplaceAmount = (Amount) => {
    let reN = /[$,]/g;
    Amount = Amount.toString().replace(reN, '');
    return Amount;
  };

  getCartRxNumbers = () => {
    searchedRxNumbers = [];
    this.state.scanRxItems.map((item) => {
      if (item && item.rxNo !== '') {
        searchedRxNumbers.push(item.rxNo || item.rx_no);
      }
      return true;
    });
  };

  openAllBin() {
    let Ids = [];
    nums1.forEach((n1) => {
      nums.forEach((n) => {
        if ((elem[n] === 'B' || elem[n] === 'C') && n1 >= 0 && n1 <= 6) {
        } else {
          if (elem[n] === 'A') {
            Ids.push(elem[n] + '' + (n1 + 1));
          } else if (elem[n] === 'B' && n1 >= 7 && n1 <= 11) {
            Ids.push(elem[n] + '' + (n1 + 1));
          } else if (elem[n] === 'C' && n1 >= 7 && n1 <= 11) {
            Ids.push(elem[n] + '' + (n1 + 1));
          } else {
            Ids.push(elem[n] + '' + (n1 + 1));
          }
        }
      });
    });

    const filteredArray = this.sortArray(Ids);
    for (let index = 0; index < filteredArray.length; index++) {
      const element = filteredArray[index];
      let items = document.getElementById(element);
      items.style.background =
        '#f8fafc';
      items.style.color = '#000';
    }
  }

  sortArray(Ids) {
    let reA = /[^a-zA-Z]/g;
    let reN = /[^0-9]/g;

    function sortAlphaNum(a, b) {
      let aA = a.replace(reA, '');
      let bA = b.replace(reA, '');
      if (aA === bA) {
        let aN = parseInt(a.replace(reN, ''), 10);
        let bN = parseInt(b.replace(reN, ''), 10);
        return aN === bN ? 0 : aN > bN ? 1 : -1;
      } else {
        return aA > bA ? 1 : -1;
      }
    }
    return Ids.sort(sortAlphaNum);
  }

  handleSelectAllClick = (event) => {
    if (event.target.checked) {
      this.setState({
        selected: this.state.scanRxItems.map((n) => n.rxNo),
      });
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id, index) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };

  isSelected = (id) => this.state.selected.indexOf(id) !== -1;

  confirmDelete = (event) => {
    this.setState({
      deleteDialogOpen: true,
      forDeletion:
        this.state &&
        this.state.scanRxItems.filter(
          (x) => this.state.selected.indexOf(x.rxNo) > -1
        ),
    });
  };

  deleteConfirmClose = (event) => {
    this.setState({
      deleteDialogOpen: false,
      selectedRowId: null,
      forDeletion: null,
    });
  };

  deleteConfirmed = (event) => {
    this.deleteItems();
    this.setState({ deleteDialogOpen: false });
  };

  getDefaultCartItem = () => ({
    id: '-1',
    rxNo: '',
    drugname: '',
    ndcCode: '',
    price: '0.00',
    CoPayAmount: '0.00',
    qty: 0,
    ConsultRequire: false,
    is_consultrequire: false,
    is_payment_required: false,
    is_id_capture: false,
    IsReturnable: false,
    is_returnable: false,
    is_controlledsubstances: false,
  });

  isFlagTrue = (value) =>
    value === true || value === 'true' || value === 1 || value === '1';

  mapApiRxItemToCartItem = (rxItem, index) => ({
    id: index,
    rxNo: rxItem.rx_no,
    drugname: rxItem.drug_name,
    ndcCode: rxItem.ndc_code,
    price: rxItem.price,
    qty: rxItem.qty,
    ConsultRequire: rxItem.is_consultrequire,
    is_consultrequire: rxItem.is_consultrequire,
    is_payment_required: this.isFlagTrue(rxItem.is_payment_required),
    is_id_capture: this.isFlagTrue(rxItem.is_id_capture),
    orderid: rxItem.id,
    is_order_released: rxItem.is_order_released,
    is_returnable: this.isFlagTrue(rxItem.is_returnable),
    IsReturnable: this.isFlagTrue(rxItem.is_returnable),
    is_controlledsubstances: this.isFlagTrue(rxItem.is_controlledsubstances),
  });

  buildCartFromApiRxItems = (rxItems) =>
    (rxItems || []).map((rxItem, index) => this.mapApiRxItemToCartItem(rxItem, index));

  resetAfterDeleteAllPrescriptions = () => {
    const boxId = this.state.box_id || localStorage.getItem('selectedLocation');
    this.ClearFields('clear', () => {
      this.setState(
        {
          scanRxItems: [this.getDefaultCartItem()],
          box_id: boxId,
        },
        () => {
          if (boxId && !['null', 'undefined', '', null, undefined].includes(boxId)) {
            this.getBoxesByID(boxId);
            this.getAssignedBins(boxId);
            this.getExpansionBins(boxId);
          }
        }
      );
    });
  };

  deleteItems = (event) => {
    const rowIdToDelete = this.state.forDeletion;
    if (rowIdToDelete.length === this.state.scanRxItems.length) {
      this.resetAfterDeleteAllPrescriptions();
    } else {
      let newFilterDelete = [];
      for (let i = 0; i < rowIdToDelete.length; i++) {
        newFilterDelete = this.state.scanRxItems.filter(
          // eslint-disable-next-line no-loop-func
          (x) => x.rxNo !== rowIdToDelete[i].rxNo
        );
      }
      this.setState({
        rxNumber: '',
        selected: [],
        scanRxItems: newFilterDelete,
      });
    }
  };

  getPrescriptionDetails = (BinId, pm_id) => {
    const marketplaceLocked = (this.state.BinStatus || []).some((row) => {
      if (!row || !row.is_marketplace_lock) return false;
      return String(row.bin_id || '').trim().toUpperCase() === String(BinId || '').trim().toUpperCase();
    });
    if (marketplaceLocked) {
      const slot = (this.state.BinStatus || []).find((row) => (
        row && row.is_marketplace_lock
        && String(row.bin_id || '').trim().toUpperCase() === String(BinId || '').trim().toUpperCase()
      ));
      this.setState({ marketplaceBin: slot || { bin_id: BinId } });
      return;
    }
    const { accountDetails, scanRxItems } = this.state;
    const { t } = this.props;
    this.setState({ isEdit: true, binid: BinId, pmid: pm_id, indexNo: '' });
    if (
      scanRxItems &&
      scanRxItems.length > 0 &&
      this.state &&
      this.state.doesPatientSelected
    ) {
      let obj = {
        bin_id: BinId,
        box_id: this.state && this.state.box_id,
        account_id: accountDetails && accountDetails.id,
      };
      this.setState({ loader: true });
      fetch(process.env.REACT_APP_BASEURL + 'prescription/status/check', {
        crossDomain: true,
        method: 'post',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify(obj),
      })
        .then((response) => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          if (res && res.statusCode === 409) {
            this.setState({
              isVerifyingBin: true,
              isVerifyingBinMessage: t("Assign.BinNotAvailable"),
              loader: false,
            });
          }
        });
    } else {
      /**
       * Pre-assignment (Canada unplugged) flow:
       * When clicking a Recent Order row we always have a valid pm_id, and we
       * want to hydrate the Deliver Prescription screen from that PM record.
       * Previously this block only ran when BinId === null, which meant that
       * clicks where a bin was already assigned (BinId !== null) populated the
       * patient header but never loaded the prescription items grid.
       *
       * To fix that with minimal impact on legacy flows, we now:
       * - For pre-assignment accounts: always fetch by pm_id via rxbyPMID,
       *   regardless of whether BinId is null or not.
       * - For non pre-assignment accounts: retain the existing behaviour.
       */
      if (this.is_pre_assignment) {
        const boxId = this.state.box_id;
        this.getPharmacyDetails(boxId);
        const bin_info = {
          id: boxId,
          pm_id: pm_id,
        };
        this.setState({ loader: true, reminderData: [] });
        fetch(process.env.REACT_APP_BASEURL + 'pre-assignment/rxbyPMID', {
          method: 'POST',
          withCredentials: true,
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(bin_info),
        })
          .then((response) => {
            try {
              return response.json();
            } catch (error) {
              return null;
            }
          })
          .then((data) => {
            if (data) {
              this.setState({
                reminderData: { bin_info: bin_info, data: data },
                isVisibleForPause: true,
              });
              const details = data.response.box;
              if (details && details.customers.length > 0) {
                const basicDetails = details && details.customers[0];
                const orders = details && details.customers[0].orders[0];
                const typeId = orders.type_id;
                const stockcode = orders.stock_code;
                const pickupcode = orders.pucode;
                const rxItems = orders.items;
                const orderId = details && details.customers[0].orders[0].id;
                const rxNo =
                  details && details.customers[0].orders[0].items[0].rx_no;
                const bindId = details && details.customers[0].orders[0].bin_id;
                const binSize = orders && orders.bin_size;
                const contactDetails =
                  details && details.customers[0].contacts[0];
                const locationDetails = orders && orders.customerLocations;
                // Codes stored in state only - fetched fresh from database before printing
                this.setState({
                  stockCode: orders.stock_code,
                  pickupCode: orders.pucode,
                  locationDetails: locationDetails,
                  basicDetails: basicDetails,
                  contactDetails: contactDetails,
                  PrintisCoolItem: orders['is_cool_item'],
                  EmailID: contactDetails.email,
                  phone: contactDetails.phone,
                  notifyChannel: notifyChannelForContact(
                    contactDetails.email,
                    contactDetails.phone,
                    basicDetails
                  ),
                });
                let address1;
                let address2;
                let city;
                let state;
                let zip;
                let country;
                let location_notes;
                if (locationDetails.length > 0) {
                  const locationtypesdata = mapLocationTypesHelper(locationDetails, this.props.t);
                  this.setState({
                    locationtype: locationtypesdata,
                    locationtype_id: locationtypesdata[0].id,
                  });
                  if (this.state.locationtype_id === LOCATION_TYPE.Kiosk) {
                    const boxData = this.state.boxdata;
                    boxData.forEach((item) => {
                      if (this.state.box_id === item.id && item && item.address) {
                        address1 = item.address.address_line_1 || '';
                        address2 = item.address.address_line_2 || '';
                        city = item.address.city || '';
                        state = item.address.state || '';
                        zip = item.address.zip || '';
                        country = item.address.country || '';
                        location_notes = item.address.location_notes || '';
                      }
                    });
                  } else {
                    locationDetails.forEach((type) => {
                      if (this.state.locationtype_id === type.locationtype_id) {
                        address1 = type.addressline1;
                        address2 = type.addressline2;
                        city = type.city;
                        state = type.state;
                        zip = type.zip;
                        country = type.country;
                        location_notes = type.location_notes;
                      }
                    });
                  }
                } else {
                  if (this.state.locationtype_id === LOCATION_TYPE.Kiosk) {
                    const locationtypesdata = [
                      { id: this.state.locationtype_id, label: this.props.t('API.LocationType.Kiosk') },
                    ];
                    this.setState({ locationtype: locationtypesdata });
                    const boxData = this.state.boxdata;
                    boxData.forEach((item) => {
                      if (this.state.box_id === item.id && item && item.address) {
                        address1 = item.address.address_line_1 || '';
                        address2 = item.address.address_line_2 || '';
                        city = item.address.city || '';
                        state = item.address.state || '';
                        zip = item.address.zip || '';
                        country = item.address.country || '';
                        location_notes = item.address.location_notes || '';
                      }
                    });
                  }
                }
                if (typeId === DEVICE_TYPE.Hold) {
                  this.setState({ isAlreadyOnHold: true });
                } else {
                  this.setState({ isAlreadyOnHold: false });
                }
                if (typeId === DEVICE_TYPE.Assigned) {
                  this.setState({ isAlreadyAssigned: true });
                } else {
                  this.setState({ isAlreadyAssigned: false });
                }
                if (typeId === DEVICE_TYPE.Stocked) {
                  this.setState({ is_stocked: true });
                } else {
                  this.setState({ is_stocked: false });
                }
                let Patient = [];
                Patient.push({ id: basicDetails.id, name: basicDetails.name });
                let Arraycart = this.buildCartFromApiRxItems(rxItems);
                this.setState({
                  isPatientSelectionDisabled: true,
                  searchedItems: {
                    FirstName: basicDetails.first_name,
                    LastName: basicDetails.last_name,
                    DateOfBirth: basicDetails.dob_str,
                    MobileNo: this.state && this.state.phone,
                    EmailID: this.state && this.state.EmailID,
                    AddressLine1: address1,
                    AddressLine2: address2,
                    City: city,
                    State: state,
                    Zip: zip,
                    Country: country,
                    location_notes: location_notes,
                    isCoolItem: orders && orders.is_cool_item,
                  },
                  rxNumber: rxNo,
                  selectedBinId: bindId,
                  selectedBinSize: this.resolveSelectedBinSize(bindId, binSize),
                  binSizeLocked: true,
                  isBinSizeRequired: false,
                  isBinIdRequired: false,
                  stockCode: stockcode,
                  pickupCode: pickupcode,
                  orderId: orderId,
                  selectedPatient: Patient[0],
                  readOnly: true,
                  scanRxItems: Arraycart,
                  isPatientRecordNumberRequired: false,
                });
                this.getPaymentDetails(orderId, basicDetails.id);
              } else {
                this.setState(
                  Object.assign({}, this.clearHoldResumeOrderState(), {
                    loader: false,
                  })
                );
              }
              this.getCartRxNumbers();
              this.setState({ assignedPrescription: data.response.box });
              this.forceUpdate();
            } else {
              const DefaultCartItem = {
                id: '-1',
                rxNo: '',
                drugname: '',
                ndcCode: '',
                price: '0.00',
                CoPayAmount: '0.00',
                qty: 0,
                ConsultRequire: false,
              };
              this.setState({
                searchedRxNo: [],
                searchedItems: [],
                rxNumber: '',
                selected: [],
                scanRxItems: [DefaultCartItem],
                loader: false,
              });
            }
          });
        } else {
          const boxId = this.state.box_id;
          this.getPharmacyDetails(boxId);
          const bin_info = {
            id: boxId,
            bin_id: BinId,
            pm_id: pm_id,
          };
          this.setState({ loader: true, reminderData: [] });
          fetch(process.env.REACT_APP_BASEURL + 'rxbybin', {
          method: 'POST',
          withCredentials: true,
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(bin_info),
        })
          .then((response) => {
            try {
              return response.json();
            } catch (error) {
              return null;
            }
          })
          .then((data) => {
            if (data) {
              this.setState({
                reminderData: { bin_info: bin_info, data: data },
                isVisibleForPause: true,
              });
              const details = data.response.box;
              if (details && details.customers.length > 0) {
                const basicDetails = details && details.customers[0];
                const orders = details && details.customers[0].orders[0];
                const typeId = orders.type_id;
                const stockcode = orders.stock_code;
                const pickupcode = orders.pucode;
                const rxItems = orders.items;
                const orderId = details && details.customers[0].orders[0].id;
                const rxNo =
                  details && details.customers[0].orders[0].items[0].rx_no;
                const bindId = details && details.customers[0].orders[0].bin_id;
                const binSize = orders && orders.bin_size;
                const contactDetails =
                  details && details.customers[0].contacts[0];
                const locationDetails = orders && orders.customerLocations;
                // Codes stored in state only - fetched fresh from database before printing
                this.setState({
                  stockCode: orders.stock_code,
                  pickupCode: orders.pucode,
                  locationDetails: locationDetails,
                  basicDetails: basicDetails,
                  contactDetails: contactDetails,
                  PrintisCoolItem: orders['is_cool_item'],
                  EmailID: contactDetails.email,
                  phone: contactDetails.phone,
                  notifyChannel: notifyChannelForContact(
                    contactDetails.email,
                    contactDetails.phone,
                    basicDetails
                  ),
                });
                let address1;
                let address2;
                let city;
                let state;
                let zip;
                let country;
                let location_notes;
                if (locationDetails.length > 0) {
                  const locationtypesdata = mapLocationTypesHelper(locationDetails, this.props.t);
                  this.setState({
                    locationtype: locationtypesdata,
                    locationtype_id: locationtypesdata[0].id,
                  });
                if (this.state.locationtype_id === LOCATION_TYPE.Kiosk) {
                  const boxData = this.state.boxdata;
                  boxData.forEach((item) => {
                    if (this.state.box_id === item.id && item && item.address) {
                      address1 = item.address.address_line_1 || '';
                      address2 = item.address.address_line_2 || '';
                      city = item.address.city || '';
                      state = item.address.state || '';
                      zip = item.address.zip || '';
                      country = item.address.country || '';
                      location_notes = item.address.location_notes || '';
                    }
                  });
                } else {
                    locationDetails.forEach((type) => {
                      if (this.state.locationtype_id === type.locationtype_id) {
                        address1 = type.addressline1;
                        address2 = type.addressline2;
                        city = type.city;
                        state = type.state;
                        zip = type.zip;
                        country = type.country;
                        location_notes = type.location_notes;
                      }
                    });
                  }
                } else {
                if (this.state.locationtype_id === LOCATION_TYPE.Kiosk) {
                  const locationtypesdata = [
                    { id: this.state.locationtype_id, label: this.props.t('API.LocationType.Kiosk') },
                  ];
                  this.setState({ locationtype: locationtypesdata });
                  const boxData = this.state.boxdata;
                  boxData.forEach((item) => {
                    if (this.state.box_id === item.id && item && item.address) {
                      address1 = item.address.address_line_1 || '';
                      address2 = item.address.address_line_2 || '';
                      city = item.address.city || '';
                      state = item.address.state || '';
                      zip = item.address.zip || '';
                      country = item.address.country || '';
                      location_notes = item.address.location_notes || '';
                    }
                  });
                }
                }
                if (typeId === DEVICE_TYPE.Hold) {
                  this.setState({ isAlreadyOnHold: true });
                } else {
                  this.setState({ isAlreadyOnHold: false });
                }
                if (typeId === DEVICE_TYPE.Assigned) {
                  this.setState({ isAlreadyAssigned: true });
                } else {
                  this.setState({ isAlreadyAssigned: false });
                }
                if (typeId === DEVICE_TYPE.Stocked) {
                  this.setState({ is_stocked: true });
                } else {
                  this.setState({ is_stocked: false });
                }
                let Patient = [];
                Patient.push({ id: basicDetails.id, name: basicDetails.name });
                let Arraycart = this.buildCartFromApiRxItems(rxItems);
                this.setState({
                  isPatientSelectionDisabled: true,
                  searchedItems: {
                    FirstName: basicDetails.first_name,
                    LastName: basicDetails.last_name,
                    DateOfBirth: basicDetails.dob_str,
                    MobileNo: this.state && this.state.phone,
                    EmailID: this.state && this.state.EmailID,
                    AddressLine1: address1,
                    AddressLine2: address2,
                    City: city,
                    State: state,
                    Zip: zip,
                    Country: country,
                    location_notes: location_notes,
                    isCoolItem: orders && orders.is_cool_item,
                    notes: basicDetails.notes,
                  },
                  rxNumber: rxNo,
                  selectedBinId: bindId,
                  selectedBinSize: this.resolveSelectedBinSize(bindId, binSize),
                  binSizeLocked: true,
                  stockCode: stockcode,
                  pickupCode: pickupcode,
                  orderId: orderId,
                  selectedPatient: Patient[0],
                  readOnly: true,
                  scanRxItems: Arraycart,
                  patientNotes: this.validateFields(basicDetails && basicDetails.notes),
                  isPatientRecordNumberRequired: false
                });
                this.getPaymentDetails(orderId, basicDetails.id);
              } else {
                this.setState(
                  Object.assign({}, this.clearHoldResumeOrderState(), {
                    loader: false,
                  })
                );
              }
              this.getCartRxNumbers();
              this.setState({ assignedPrescription: data.response.box });
              this.forceUpdate();
            } else {
              this.setState({ loader: false });
            }
          }).catch(() => {
            this.setState({ loader: false });
          });
      }
    }
  };

  GetFormattedDate(dob) {
    let tempDate = new Date(dob);
    let formattedDate = ('0' + tempDate.getDate()).slice(-2);
    let formattedMonth = ('0' + (tempDate.getMonth() + 1)).slice(-2);
    let formattedYears = tempDate.getFullYear();
    let dateString =
      formattedMonth + '/' + formattedDate + '/' + formattedYears;
    return dateString;
  }

  sendOrederStatusEmail(reqDetails) {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'emailHoldStatus', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(reqDetails),
    }).then((res) => { return res.text() })
    .then(() => {
      this.setState({ loader: false });
    }).catch(() => {
      this.setState({ loader: false });
    });
  }

  reminderHandler = () => {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'reminder/notification', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(this.state.reminderData),
    })
      .then((response) => {
        if (response.status === 200) {
          this.setState({ searchedRxNo: [] });
          toast.success(this.props.t('Prescriptions.Messages.NotificationSent'));
        }
        try {
          return response.text();
        } catch (error) {
          this.setState({ loader: false });
          return null;
        }
      })
      .then((uData) => {
        // this.getBoxes();
        // searchedRxNumbers = [];
        // this.setState({
        //   selectedBinId: "",
        //   searchedItems: [],
        //   rxNumber: "",
        // });
        // this.textInput.current.focus();
        this.setState({ loader: false });
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  changeOrderStatus(status) {
    this.setState({ loader: true });
    let bin_info;
    let reqDetails = {};
    if (status === 'pause') {
      bin_info = {
        id: this.state.orderId,
        type_id: DEVICE_TYPE.Hold,
      };
      reqDetails = {
        box_id: this.state.box_id,
        pucode: this.state.pickupCode,
        onHold: true,
      };
    } else if (status === 'play') {
      bin_info = {
        id: this.state.orderId,
        type_id: DEVICE_TYPE.Stocked,
      };
      reqDetails = {
        box_id: this.state.box_id,
        pucode: this.state.pickupCode,
        onHold: false,
      };
    } else if (status === 'remove') {
      bin_info = {
        id: this.state.orderId,
        type_id: DEVICE_TYPE.RemoveRx,
      };
    }

    return fetch(process.env.REACT_APP_BASEURL + 'updateStatusOfRx', {
      method: 'POST',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ...bin_info, audit_writer: 'web-gap-v1' }),
    })
      .then((response) => {
        if (!response.ok) throw new Error('Order status was not saved');
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((data) => {
        if (!data || (!data.prescriptions_master || !data.prescriptions_master.id) || data.status === false || data.success === false) throw new Error('Order status was not saved');
          if (
            bin_info.type_id === assignmentstatus.REMOVE_RX &&
            data.prescriptions_master.id
          ) {
            const event_params = {
              event_name: EVENT_CRUD_TYPES.UPDATE,
              event_type_name: EVENT_TYPES.REMOVE_RX,
              description:
                'Prescription is Remove with stock code ' +
                this.state.stockCode,
              object_id: assignmentstatus.REMOVE_RX,
              tofor_id: this.state.orderId,
              box_id: this.state.box_id,
            };
            new EventLogHandler().handleEventLog(event_params);
          }

        if (status === 'pause' || status === 'play') this.sendOrederStatusEmail(reqDetails);
        const { t } = this.props;
        this.setState({ loader: false });
        if (status === 'pause') {
          toast.success(t('Prescriptions.Messages.OnHold'));
          this.setState({
            isAlreadyOnHold: true,
            isAlreadyAssigned: false,
            is_stocked: false,
            isVisibleForPause: true,
          });
        } else if (status === 'play') {
          toast.success(t('Prescriptions.Messages.NotOnHold'));
          this.setState({
            isAlreadyOnHold: false,
            is_stocked: true,
            isVisibleForPause: true,
          });
        } else if (status === 'remove') {
          toast.success(t('Prescriptions.Messages.RemovedRx'));
          this.setState({
            selectedBinId: '',
            selectedBinSize: '',
      binSizeLocked: false,
            searchedItems: [],
            rxNumber: '',
            isVisibleForPause: false,
            readOnly: false,
            scanRxItems: [],
            EmailID: '',
      notifyChannel: 'email',
            phone: '',
            isPatientSelectionDisabled: false,
            makePreAssignmentAPICall: true,
            orderId: '',
            isAlreadyOnHold: false,
            isAlreadyAssigned: false,
            is_stocked: false,
          });
          this.ClearFields('clear');
          searchedRxNumbers = [];
        }
        this.getBoxes();
        if (status === 'pause' || status === 'play') {
          this.refreshAfterHoldResume();
        }
        if (status === 'remove') {
          this.setState({ makePreAssignmentAPICall: false });
        }
        return true;
      }).catch(() => {
        this.setState({ loader: false });
        toast.error('Order status could not be saved. Please try again.');
        return false;
      });
  }

  getSelectedUnitName = (index) => {
    if (index === 1) {
      this.setState({ selectedUnitName: 'L60 (Locker Addon with 60 bins)' });
    } else if (index === 2) {
      this.setState({ selectedUnitName: 'HD36 (Locker Addon with 36 bins)' });
    } else if (index === 3) {
      this.setState({ selectedUnitName: 'Cool (Temp Controlled with 8 bins)' });
    } else if (index === 4) {
      this.setState({ selectedUnitName: 'C30 (C30 with 30 bins)' });
    } else {
      this.setState({ selectedUnitName: 'Locker (Main Unit with 46 bins)' });
    }
  };

  handleConsultrequire = (index) => {
    this.toggleScanOption(index, 'consult');
  };

  toggleScanOption = (index, field) => {
    const scanRxItems = (this.state.scanRxItems || []).slice();
    if (!scanRxItems[index]) return;
    const item = { ...scanRxItems[index] };
    if (field === 'consult') {
      const next = !(item.ConsultRequire || this.isFlagTrue(item.is_consultrequire));
      item.ConsultRequire = next;
      item.is_consultrequire = next;
    } else if (field === 'payment') {
      item.is_payment_required = !this.isFlagTrue(item.is_payment_required);
    } else if (field === 'idCapture') {
      item.is_id_capture = !this.isFlagTrue(item.is_id_capture);
    }
    scanRxItems[index] = item;
    this.setState({ scanRxItems });
  };
  checkBoxHandler = (value) => {
    this.setState({ default_courier_selected: value });
  };
  getDueAmount = () => {
    let orderAmount = 0;
    for (let i = 0; i < this.state.scanRxItems.length; i++) {
      if (!isNaN(this.state.scanRxItems[i].price)) {
        let amount = parseFloat(this.state.scanRxItems[i].price);
        orderAmount = orderAmount + amount;
      }
    }
    return `$${orderAmount.toFixed(2)}`;
  };

  getPaidAmountDisplay = () => {
    const { isAmountPaid, isPartiallyPaid, paymentPaidAmount } = this.state;
    if (isAmountPaid) {
      return this.getDueAmount();
    }
    if (isPartiallyPaid) {
      return `$${Number(paymentPaidAmount || 0).toFixed(2)}`;
    }
    return `$${(0).toFixed(2)}`;
  };

  getDueAmountDisplay = () => {
    const { isAmountPaid, isPartiallyPaid, paymentDueAmount } = this.state;
    if (isAmountPaid) {
      return `$${(0).toFixed(2)}`;
    }
    if (isPartiallyPaid) {
      return `$${Number(paymentDueAmount || 0).toFixed(2)}`;
    }
    return this.getDueAmount();
  };

  getPaymentDetails = (orderId, customerId) => {
    this.setState({ loader: true });
    fetch(
      `${process.env.REACT_APP_BASEURL}payments/validate-payment?order_id=${orderId}&customer_id=${customerId}`,
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    )
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((data) => {
        if (data) {
          const isPaid = data.res === true || data.is_paid === true;
          const isPartial =
            !isPaid &&
            (data.partial_payment === true || data.partial_payment === 'true') &&
            Number(data.remaining_amount || 0) > 0;
          this.setState({
            isAmountPaid: isPaid,
            isPartiallyPaid: isPartial,
            paymentPaidAmount: isPartial ? Number(data.paid_amount || 0) : 0,
            paymentDueAmount: isPartial ? Number(data.remaining_amount || 0) : 0,
            loader: false,
          });
        } else {
          this.setState({ loader: false });
        }
      })
      .catch(() => {
        this.setState({ loader: false });
      });
  };
  ManualPickupNotification = async (type) => {
    this.setState({ loader: true });
    const rawEmail =
      this.state.searchedItems.EmailID || (this.state && this.state.EmailID);
    const emailID =
      rawEmail && String(rawEmail).trim() !== '@' ? String(rawEmail).trim() : '';
    const firstRx =
      this.state.searchedRxNo && this.state.searchedRxNo[0];
    const cartItem = this.state.scanRxItems && this.state.scanRxItems[0];
    const cartRx =
      cartItem && (cartItem.rxNo || cartItem.rx_no);
    const rxNo =
      this.state.rxNumber ||
      (typeof firstRx === 'string'
        ? firstRx
        : firstRx && (firstRx.rxNo || firstRx.rx_no)) ||
      cartRx ||
      '';
    let reqDetails = {
      box_id: this.state.box_id,
      pucode: this.state.pickupCode,
      rxNo,
      emailID,
      firstName: this.state.searchedItems.FirstName,
      lastName: this.state.searchedItems.LastName,
      AccountName: this.state.accountDetails && this.state.accountDetails.name,
      AccountAddress:
        this.state.accountDetails &&
        this.state.accountDetails.contact &&
        this.state.accountDetails.contact.address &&
        this.state.accountDetails.contact.address.address_line_1 +
        ' ' +
        this.state.accountDetails.contact.address.address_line_2 +
        ' ',
      AccountAddress2:
        this.state.accountDetails &&
        this.state.accountDetails.contact &&
        this.state.accountDetails.contact.address &&
        this.state.accountDetails.contact.address.city +
        ', ' +
        this.state.accountDetails.contact.address.state +
        ' ' +
        this.state.accountDetails.contact.address.zip,
      location_notes: this.state.searchedItems.location_notes,
      scenario: type === 1 ? 'counter_pickup' : 'no_space',
    };
    if (type === 1) {
      if (!await this.changeOrderStatus('remove')) return;
    }
    fetch(process.env.REACT_APP_BASEURL + 'emailPickupNotification', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(reqDetails),
    })
      .then(function (response) {
        return response.text().then(function (text) {
          return { response: response, text: text };
        });
      })
      .then(function (payload) {
        var response = payload.response;
        var text = payload.text;
        var emailSent = false;
        var result = null;
        var parsed = null;
        try {
          parsed = JSON.parse(text);
          result = (parsed && parsed.result) || parsed;
          if ((parsed && parsed.emailSent === true) || result === 'Email Sent') {
            emailSent = true;
            this.setState({ loader: false });
            toast.success(this.props.t('Prescriptions.Messages.NotificationSent'));
          } else {
            this.setState({ loader: false });
            toast.error(
              this.props.t('Prescriptions.Messages.NotificationNotSent') ||
                (typeof result === 'string' ? result : 'Notification not sent')
            );
          }
        } catch (_parseErr) {
          if (response.status === 200 && text === 'Email Sent') {
            emailSent = true;
            this.setState({ loader: false });
            toast.success(this.props.t('Prescriptions.Messages.NotificationSent'));
          } else {
            this.setState({ loader: false });
            toast.error(
              this.props.t('Prescriptions.Messages.NotificationNotSent') ||
                text ||
                'Notification not sent'
            );
          }
        }
        return emailSent;
      }.bind(this))
      .then(function (emailSent) {
        // Full reset after Direct Pickup so the next patient/order can be scanned.
        // Partial clear left patient session state and blocked further scans.
        if (emailSent || type === 1) {
          var currentBoxId = this.state.box_id;
          var locationTypeId = this.state.locationtype_id;
          this.ClearFields(function () {
            if (currentBoxId) {
              this.setState(
                {
                  box_id: currentBoxId,
                  locationtype_id: locationTypeId,
                  isBoxSelected: true,
                  loader: false,
                },
                function () {
                  this.getBoxesByID(currentBoxId);
                }.bind(this)
              );
            } else {
              this.setState({ loader: false });
            }
          }.bind(this));
        } else {
          this.setState({ loader: false });
        }
      }.bind(this)).catch(function () {
        this.setState({ loader: false });
      }.bind(this));
  };
  ClearFields = (param, onComplete) => {
    let clearParam = param;
    let afterClear = onComplete;
    if (typeof param === 'function') {
      afterClear = param;
      clearParam = undefined;
    }
    searchedRxNumbers = [];
    this.setState({
      selectedBinId: '',
      searchedItems: [],
      scanRxItems: [],
      rxNumber: '',
      selected: [],
      box: [],
      hasError: false,
      box_id: null,
      pharmacyDetails: {},
      accountDetails: {},
      BinStatus: [],
      deactivatedBins: [],
      assignedPrescription: {},
      isVisibleForPause: false,
      isBoxSelected: false,
      selectedUnitName: '',
      customervalues: [],
      customerList: [],
      popupDOB: null,
      copyScanRxItems: [],
      isPaymentRequired: false,
      CoPayAmountIndex: '',
      CoPayAmountValue: '0.00',
      readOnly: false,
      selectedPatient: {},
      expansionUnits: [
        {
          id: -1,
          order: 0,
          pos: 'M',
          selectedUnitIndex: 0,
          box_position: 0,
        },
      ],
      box_expansions_id: '',
      isADACompatible: false,
      locationtype_id: '',
      featureEntitlements: this.state.featureEntitlements || null,
      EmailID: '',
      notifyChannel: 'email',
      phone: '',
      isEpicHasValidRx: true,
      isEpicHasValidRxMessage: '',
      is_stocked: false,
      order: 'desc',
      orderBy: 'created_on',
      PrintFirstName: '',
      PrintLastName: '',
      ADAData: [],
      SearchResultDialogOpen: false,
      reminderData: [],
      source_location: '',
      delivery_notes: '',
      order_notes: '',
      patient_notes: '',
      boxdata: [],
      prefer_location_name: '',
      courier_type: [],
      courier_tracking: '',
      default_courier_selected: '',
      isEdit: false,
      indexNo: null,
      page: 0,
      rowsPerPage: 10,
      printDialogOpen: false,
      selectedObject: [],
      searchObj: {
        searchTxt: '',
        pageNo: 0,
        pageSize: 10,
        sortOrder: 'desc',
      },
      patientSearchInput: '',
      openAutoComplete: false,
      isVerifyingBin: false,
      isVerifyingBinMessage: '',
      doesPatientSelected: false,
      boxTypeId: '',
      brandPhone: '',
      brandName: '',
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
      patientNotes: '',
      patientNotesReadOnly: true,
      selectedBinSize: '',
      binSizeLocked: false,
      isBinSizeRequired: false,
      isBinIdRequired: false,
      key: this.state.key + 1,
      isPatientSelectionDisabled: false,
      isPatientRecordNumberRequired: false,
      printLoading: false,
      binid: null,
      pmid: null,
      rxEntries: [],
      binLayoutRefreshKey: this.state.binLayoutRefreshKey + 1,
    }, () => {
      const autoCompleteResetElement = document.getElementsByClassName('MuiAutocomplete-clearIndicator');
      if (autoCompleteResetElement.length > 0) {
        autoCompleteResetElement[0].click();
      }
      if (clearParam === 'clear') {
        this.setState({ searchedItems: [], basicDetails: null }, () => {
          this.BindPatientId(clearParam);
          this.getBoxes();
          const kioskId = 'a5bd2ad0-0780-42cd-a270-7e76c4f20500';
          this.getAllBoxes(kioskId);
          if (typeof afterClear === 'function') {
            afterClear();
          }
        });
        return;
      }
      this.BindPatientId(clearParam);
      this.getBoxes();
      const kioskId = 'a5bd2ad0-0780-42cd-a270-7e76c4f20500';
      this.getAllBoxes(kioskId);
      if (typeof afterClear === 'function') {
        afterClear();
      }
    });
  };

  onInputChange = (event) => {
    const { searchedItems } = this.state;
    searchedItems[event.target.name] = event.target.value;
    this.setState({ [event.target.name]: event.target.value, searchedItems });
  };
  handleConsultClick = () => {
    this.setState({ detailDialogOpen: true });
  };

  handleConsultClose = () => {
    this.setState({ detailDialogOpen: false });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
  };

  onSearchChange = (event) => {
    const searchString = event.target.value;
    this.setState(
      { searchObj: { ...this.state.searchObj, searchTxt: searchString } },
      () => {
        if (searchString.length > 2) {
          this.FetchSearchResult();
        } else {
          searchedRxNumbers = [];
          this.setState({
            selectedBinId: '',
            selectedBinSize: '',
      binSizeLocked: false,
            searchedItems: [],
            rxNumber: '',
            isVisibleForPause: false,
            EmailID: '',
      notifyChannel: 'email',
            phone: '',
            isEpicHasValidRx: true,
            isEpicHasValidRxMessage: '',
          });
        }
      }
    );
  };

  FetchSearchResult = () => {
    let FilterObj = {
      searchtext: this.state.searchObj.searchTxt,
      pageNo: this.state.searchObj.pageNo,
      pageSize: this.state.searchObj.pageSize,
      sortOrder: this.state.searchObj.sortOrder,
    };
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'getPrescriptionSearchResult', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(FilterObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        this.setState({
          totalSearchRecords: uData && uData['total'],
          loader: false,
          innerSearchLoader: false,
        });
        if (
          uData &&
          Array.isArray(uData['results']) &&
          uData['results']['length'] > 0
        ) {
          if (uData['results']['length'] === 1) {
            let BinId = uData['results'][0].bin_id;
            let pm_id = uData['results'][0].pm_id;
            this.getPrescriptionDetails(BinId, pm_id);
          } else
            this.setState({
              selectedObject: uData['results'],
              SearchResultDialogOpen: true,
            });
        } else {
          searchedRxNumbers = [];
          this.setState({
            selectedBinId: '',
            selectedBinSize: '',
      binSizeLocked: false,
            searchedItems: [],
            rxNumber: '',
            isVisibleForPause: false,
            EmailID: '',
      notifyChannel: 'email',
            phone: '',
            isEpicHasValidRx: true,
            isEpicHasValidRxMessage: '',
            SearchResultDialogOpen: false,
            innerSearchLoader: false,
            searchObj: { pageNo: 0, pageSize: 10, sortOrder: 'desc' },
          });
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  handleSearchClose = (event) => {
    event.preventDefault();
    this.setState({
      SearchResultDialogOpen: false,
      selectedObject: [],
      innerSearchLoader: false,
      searchObj: { searchTxt: '', pageNo: 0, pageSize: 10, sortOrder: 'desc' },
    });
  };

  handlePUcodeClick = (event, BinId, pm_id, boxid) => {
    event.preventDefault();
    this.getPharmacyDetails(boxid);
    this.getExpansionBins(boxid);    
    this.getAssignedBins(boxid);
    this.setState({ box_id: boxid });
    setTimeout(() => {
      this.handleSearchClose(event);
      this.getPrescriptionDetails(BinId, pm_id);
    }, 100);
  };

  handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      this.handleDialogValidate();
    }
  };

  courierTrackingHandler = (evt) => {
    this.setState({ courier_tracking: evt.target.value });
  };

  BindPatientId = (param) => {
    const { searchedItems, basicDetails } = this.state;
    if(param === 'clear') {
      return ''
    } else {
      if (
        searchedItems &&
        searchedItems.PatientID &&
        searchedItems.PatientID !== null &&
        searchedItems.PatientID !== 'null'
      ) {
        return searchedItems.PatientID;
      } else if (
        basicDetails &&
        basicDetails.patient_id &&
        basicDetails.patient_id !== null &&
        basicDetails.patient_id !== 'null'
      ) {
        return basicDetails.patient_id;
      } else {
        return '';
      }
    }
  };

  updateDueAmount = (orderid, dueAmount) => {
    this.setState({ loader: true });
    const updateParams = {
      orderid: orderid,
      dueamount: dueAmount,
    };
    try {
      fetch(process.env.REACT_APP_BASEURL + 'updateorderdueamout', {
        method: 'PUT',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateParams),
      })
        .then((response) => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          if (res) {
            this.setState({ loader: false });
            toast.success(
              res && res.UpdateDueAmount && res.UpdateDueAmount.message
            );
            //this.getPrescriptionDetails(this.state.binid, this.state.pmid);
          } else {
            this.setState({ loader: false });
            toast.error(res.error);
          }
        });
    } catch (error) {
      this.setState({ loader: false });
      console.log(error);
    }
  };

  handleOpenDueAmountEditInput = (index) => {
    this.setState({ indexNo: index });
  };

  handleCloseDueAmountEditInput = (index, orderid) => {
    this.setState({ indexNo: Math.random() || index });
    const orderdueamount =
      this.state.scanRxItems &&
      this.state.scanRxItems.find((item, i) => item.orderid === orderid);
    this.updateDueAmount(orderid, orderdueamount['price']);
  };

  onHandleChangeInputValue = (id, type, value) => {
    if (type === 'price') {
      const items =
        this.state.scanRxItems &&
        this.state.scanRxItems.map((item, i) => {
          if (item.id === id) {
            return { ...item, price: parseFloat(value) };
          }
          return item;
        });
      this.setState({ scanRxItems: items });
    }
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    const { selectedObject } = this.state;
    this.setState(
      { searchObj: { ...this.state.searchObj, pageNo: page } },
      () => {
        if (selectedObject && selectedObject.length > 0) {
          this.setState({ innerSearchLoader: true });
          this.FetchSearchResult();
        }
      }
    );
  };

  handleChangeRowsPerPage = (event) => {
    const { selectedObject } = this.state;
    this.setState(
      {
        searchObj: {
          ...this.state.searchObj,
          pageSize: event.target.value,
          pageNo: 0,
        },
      },
      () => {
        if (selectedObject && selectedObject.length > 0) {
          this.setState({ innerSearchLoader: true });
          this.FetchSearchResult();
        }
      }
    );
  };

  resolveStockCodeForRxByBin = (binId, pmId, stockCodeOverride = null) => {
    const explicitOverride = (stockCodeOverride || '').trim();
    if (explicitOverride) {
      return explicitOverride;
    }
    const { BinStatus } = this.state;
    if (Array.isArray(BinStatus) && BinStatus.length > 0) {
      const match = BinStatus.find(
        (entry) =>
          (pmId && entry.id === pmId) ||
          (binId && entry.bin_id === binId)
      );
      if (match && match.stock_code) {
        return String(match.stock_code).trim();
      }
    }
    const hasUsableBinId = ![undefined, 'undefined', null, 'null', ''].includes(binId);
    if (!hasUsableBinId) {
      return (this.state.stockCode || '').trim();
    }
    return '';
  };

  fetchOrderDataForPrint = async (boxId, binId, pmId) => {
    this.setState({ printLoading: true });

    try {
      // eslint-disable-next-line no-undef
      const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      const timeoutId = controller ? setTimeout(() => controller.abort(), 30000) : null;

      const resolvedStockCode = this.resolveStockCodeForRxByBin(binId, pmId);
      const hasUsableBinId = ![undefined, 'undefined', null, 'null', ''].includes(binId);
      const requestBody = {
        id: boxId,
        bin_id: hasUsableBinId ? binId : null,
        pm_id: pmId,
        stock_code: resolvedStockCode || null,
      };

      const fetchOptions = {
        method: 'POST',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      };

      if (controller && controller.signal) {
        fetchOptions.signal = controller.signal;
      }

      const response = await fetch(
        process.env.REACT_APP_BASEURL + 'rxbybin',
        fetchOptions
      );

      if (timeoutId) clearTimeout(timeoutId);

      if (!response.ok) {
        throw new Error(`API returned status ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();

      if (!data || !data.response || !data.response.box) {
        throw new Error('Invalid response structure from /rxbybin');
      }

      const details = data.response.box;
      const customers = details.customers;

      if (!customers || customers.length === 0) {
        throw new Error('No customer data found');
      }

      const customer = customers[0];
      const orders = customer.orders;

      if (!orders || orders.length === 0) {
        throw new Error('No order data found');
      }

      const order = orders[0];
      const items = order.items || [];
      const contacts = customer.contacts || [];
      const contact = contacts[0] || {};

      let finalBinId = binId;
      if (!binId && order.bin_id) {
        finalBinId = order.bin_id;
      }

      const labelData = {
        stockCode: order.stock_code,
        pickupCode: order.pucode,
        firstName: customer.first_name,
        lastName: customer.last_name,
        dateOfBirth: customer.dob_str,
        patientId: customer.patient_id,
        binId: finalBinId || order.bin_id,
        isCoolItem: order.is_cool_item || false,
        rxNumbers: items.map((item) => item.rx_no),
        rxItems: items,
        locationTypeId:
          order.customerLocations && order.customerLocations.length > 0
            ? order.customerLocations[0].locationtype_id
            : null,
        email: contact.email,
        phone: contact.phone,
        orderId: order.id,
        createdOn: order.created_on,
        rxEntries: items.map((item) => ({
          rxNumber: item.rx_no,
          isConsultRequired: item.is_consultrequire,
        })),
      };

      this.setState({ printLoading: false });
      return labelData;
    } catch (error) {
      if (error.name === 'AbortError') {
        toast.error(
          this.props.t('Toast.Error.LabelData.Timeout') || 'Request timed out. Please try again.'
        );
      } else if (error.message && error.message.includes('status')) {
        toast.error(
          this.props.t('Toast.Error.LabelData.ApiError') || `API Error: ${error.message}`
        );
      } else {
        toast.error(
          this.props.t('Toast.Error.LabelData.FetchFailed') ||
            `Failed to fetch label data: ${error.message || error}`
        );
      }

      this.setState({ printLoading: false });
      return null;
    }
  };

  validateLabelData = (labelData, locationtype_id = null, boxTypeId = null) => {
    const isCounter = locationtype_id === LOCATION_TYPE.Counter;
    const isFastlaneGoliath = boxTypeId === BOX_TYPE.FASTLANEGOLIATH;
    // Canada size-based pre-assignment: bin is chosen at stock time, not at assign.
    const isSizeBasedPreAssignment =
      this.state.isSizeBasedPreAssignment ||
      resolveSizeBasedAssignUIFromBox(
        this.state.boxdata &&
          this.state.boxdata.find((x) => x && String(x.id) === String(this.state.box_id))
      );
    const isBinOptional = isCounter || isFastlaneGoliath || isSizeBasedPreAssignment;

    if (!labelData) {
      return { isValid: false, missingFields: ['labelData is null'] };
    }

    const requiredFields = {
      stockCode: labelData.stockCode,
      pickupCode: labelData.pickupCode,
      firstName: labelData.firstName,
      lastName: labelData.lastName,
      dateOfBirth: labelData.dateOfBirth,
      ...(isBinOptional ? {} : { binId: labelData.binId }),
      rxNumbers: labelData.rxNumbers,
    };

    if (isBinOptional && labelData.binId) {
      requiredFields.binId = labelData.binId;
    }

    const missingFields = [];

    Object.keys(requiredFields).forEach((field) => {
      const value = requiredFields[field];
      if ([undefined, null, '', 'undefined', 'null'].includes(value)) {
        missingFields.push(field);
      } else if (field === 'rxNumbers' && (!Array.isArray(value) || value.length === 0)) {
        missingFields.push('rxNumbers (empty array)');
      }
    });

    if (isBinOptional && missingFields.includes('binId')) {
      const binIdIndex = missingFields.indexOf('binId');
      if (binIdIndex > -1) {
        missingFields.splice(binIdIndex, 1);
      }
    }

    return { isValid: missingFields.length === 0, missingFields };
  };

  handleOpenPrintDialogWithFreshData = async (serverPrescriptionResponse, preservedBinId = null) => {
    const { box_id, selectedBinId, locationtype_id } = this.state;

    const prescription =
      serverPrescriptionResponse && serverPrescriptionResponse.prescription;
    const order = serverPrescriptionResponse && serverPrescriptionResponse.order;
    const patient = serverPrescriptionResponse && serverPrescriptionResponse.patient;

    const pmId = prescription && prescription.id;
    const prescriptionBinId = prescription && prescription.bin_id;
    const orderBinId = order && order.bin_id;
    const patientBinId = patient && patient.bin_id;

    const binId =
      preservedBinId || prescriptionBinId || orderBinId || patientBinId || selectedBinId;

    const isCounter = locationtype_id === LOCATION_TYPE.Counter;
    const isSizeBasedPreAssignment =
      this.state.isSizeBasedPreAssignment ||
      resolveSizeBasedAssignUIFromBox(
        this.state.boxdata &&
          this.state.boxdata.find((x) => x && String(x.id) === String(box_id))
      );
    // Counter / Canada size-based: bin may be null at assign/print time.
    const binIdForApi =
      (isCounter || isSizeBasedPreAssignment) && !binId ? null : binId;

    const labelData = await this.fetchOrderDataForPrint(box_id, binIdForApi, pmId);

    if (!labelData) {
      toast.error(
        this.props.t('Toast.Error.LabelData.FetchFailed') ||
          'Failed to load label data from database'
      );
      return;
    }

    const validation = this.validateLabelData(labelData, locationtype_id, this.state.boxTypeId);

    if (!validation.isValid) {
      toast.error(
        this.props.t('Toast.Error.LabelData.Incomplete') ||
          `Cannot print: missing ${validation.missingFields.join(', ')}`
      );
      return;
    }

    const boxIdStr = box_id != null ? String(box_id) : '';
    const getBranding =
      this.state.boxdata &&
      this.state.boxdata.find((ele) => ele && String(ele.id) === boxIdStr);
    const brandName = (getBranding && getBranding.brandName) || '';
    const brandPhone = (getBranding && getBranding.brandPhone) || '';

    this.setState({
      labelDataForPrint: labelData,
      stockCode: labelData.stockCode,
      pickupCode: labelData.pickupCode,
      PrintFirstName: labelData.firstName,
      PrintLastName: labelData.lastName,
      PrintDateOfBirth: labelData.dateOfBirth,
      PrintisCoolItem: labelData.isCoolItem,
      binid: labelData.binId,
      printDialogOpen: true,
      brandName,
      brandPhone,
      rxEntries: labelData.rxEntries,
    });
    searchedRxNumbers = labelData.rxNumbers || [];

    const auditAccountId = labelData.parentAccountId || (getBranding && getBranding.parent_account_id);
    const auditDescription = `Label print requested. Order: ${labelData.orderId || pmId || 'unavailable'}; stock code: ${labelData.stockCode || 'unavailable'}; bin: ${labelData.binId || 'not assigned'}. Physical printing or cancellation cannot be confirmed by the browser.`;
    setTimeout(() => {
      if (auditAccountId) {
        writeAuditLog(auditDescription, 'Print Label', { boxId: box_id, parentAccountId: auditAccountId }, {}, { wait: true, deferMs: 0 })
          .catch(error => console.error('Failed to record print request', error));
      } else console.error('Print audit missing owning account');
      window.print();
      setTimeout(() => {
        this.handleClosePrintDialog();
      }, 500);
    }, 1500);
  };

  handleClosePrintDialog = () => {
    this.setState({
      printDialogOpen: false,
      labelDataForPrint: null,
      brandName: '',
      brandPhone: '',
      loader: false,
      makePreAssignmentAPICall: true,
    });
    searchedRxNumbers = [];
    toast.success(this.props.t('Assign.RxAssignedSuccessfully'));
    this.setState({
      storage_location: '',
      order_notes: '',
      selectedBinId: '',
      selectedBinSize: '',
      binSizeLocked: false,
      searchedItems: [],
      rxNumber: '',
      scanRxItems: [],
      EmailID: '',
      notifyChannel: 'email',
      phone: '',
      patientNotes: '',
      patientNotesReadOnly: true,
      key: this.state.key + 1,
      isPatientSelectionDisabled: false,
      makePreAssignmentAPICall: true,
    }, () => this.socket && this.socket.emit('updateConsole'));
    this.getBoxes();
    this.setState({ makePreAssignmentAPICall: false });
  };

  handlePrintReceipt = async () => {
    const {
      box_id,
      selectedBinId,
      binid,
      pmid,
      printLoading,
      locationtype_id,
      boxTypeId,
    } = this.state;

    if (printLoading) {
      return;
    }

    const effectiveBinId = selectedBinId || binid;
    const isCounter = locationtype_id === LOCATION_TYPE.Counter;
    const isFastlaneGoliath = boxTypeId === BOX_TYPE.FASTLANEGOLIATH;
    const isSizeBasedPreAssignment =
      this.state.isSizeBasedPreAssignment ||
      resolveSizeBasedAssignUIFromBox(
        this.state.boxdata &&
          this.state.boxdata.find((x) => x && String(x.id) === String(box_id))
      );
    const resolvedStockCode = this.resolveStockCodeForRxByBin(effectiveBinId, pmid);
    const hasUsableStockCode = resolvedStockCode.length > 0;
    const isBinOptional =
      isCounter || isFastlaneGoliath || isSizeBasedPreAssignment || hasUsableStockCode;
    const binIdForApi = !effectiveBinId && isBinOptional ? null : effectiveBinId;

    if (!pmid || !box_id || (!binIdForApi && !isBinOptional)) {
      toast.error(
        this.props.t('Toast.Error.LabelData.MissingIds') ||
          'Cannot print: missing order information'
      );
      return;
    }

    const labelData = await this.fetchOrderDataForPrint(box_id, binIdForApi, pmid);

    if (!labelData) {
      return;
    }

    const validation = this.validateLabelData(labelData, locationtype_id, boxTypeId);
    if (!validation.isValid) {
      toast.error(
        this.props.t('Toast.Error.LabelData.Incomplete') ||
          `Cannot print: missing ${validation.missingFields.join(', ')}`
      );
      return;
    }

    const boxIdStr = box_id != null ? String(box_id) : '';
    const getBranding =
      this.state.boxdata &&
      this.state.boxdata.find((ele) => ele && String(ele.id) === boxIdStr);
    const brandName = (getBranding && getBranding.brandName) || '';
    const brandPhone = (getBranding && getBranding.brandPhone) || '';

    this.setState({
      labelDataForPrint: labelData,
      stockCode: labelData.stockCode,
      pickupCode: labelData.pickupCode,
      PrintFirstName: labelData.firstName,
      PrintLastName: labelData.lastName,
      PrintDateOfBirth: labelData.dateOfBirth,
      PrintisCoolItem: labelData.isCoolItem,
      binid: labelData.binId,
      printDialogOpen: true,
      brandName,
      brandPhone,
      rxEntries: labelData.rxEntries,
    });
    searchedRxNumbers = labelData.rxNumbers || [];

    setTimeout(() => {
      window.print();
      this.getBoxes();
      searchedRxNumbers = [];
      this.setState({
        printDialogOpen: false,
        selectedBinId: '',
        selectedBinSize: '',
      binSizeLocked: false,
        isBinSizeRequired: false,
        isBinIdRequired: false,
        searchedItems: [],
        rxNumber: '',
        isVisibleForPause: false,
        scanRxItems: [],
        EmailID: '',
      notifyChannel: 'email',
        phone: '',
        brandName: '',
        brandPhone: '',
        isPatientSelectionDisabled: false,
        isPatientRecordNumberRequired: false,
      });
      if (this.textInput && this.textInput.current) {
        this.textInput.current.focus();
      }
    }, 500);
  };

  validateFields = (value) => {
    if (!['', undefined, 'undefined', null, 'null'].includes(value)) {
      return value;
    }
    return '';
  };

  setAutoCompleteOpen = (value) => {
    this.setState({ openAutoComplete: value });
  };

  onOptionSelect = async (event, value, reason) => {
    if (reason === 'selectOption') {
      if (value && value.id) {
        this.setState({
          showDialog: true,
          searchedItems: {},
          scanRxItems: [],
          selectedPatient: value,
          isEdit: false,
          doesPatientSelected: true,
        });
        const pObj = this.state.customerList.find((x) => x.id === value.id);
        if (pObj && pObj.id) {
          let locationDetails = Array.isArray(pObj.customerLocations)
            ? pObj.customerLocations
            : [];
          let defaultLocation = {};
          if (locationDetails.length > 0) {
            const locationtypesdata = locationDetails.map((type) => {
              if (type && (type.is_default_address === true || type.is_default_address === 'true' || type.is_default_address === 1)) {
                defaultLocation = { ...type };
              }
              const mapped = mapLocationTypesHelper([type], this.props.t);
              const base = (mapped && mapped[0]) || {};
              return {
                ...type,
                id: base.id || type.locationtype_id || type.id,
                label: base.label || type.label,
              };
            });
            const box_id =
              pObj.box_id ||
              defaultLocation.box_id ||
              (locationtypesdata[0] && locationtypesdata[0].box_id) ||
              this.state.box_id;
            const locationtype_id =
              defaultLocation.locationtype_id ||
              defaultLocation.id ||
              (locationtypesdata[0] && locationtypesdata[0].id) ||
              this.state.locationtype_id;
            this.setState({
              locationtype: locationtypesdata,
              locationtype_id,
              box_id,
            });
            if (locationtype_id) {
              await this.handletypeChange(locationtype_id);
            }
            if (box_id) {
              await this.handleChange(box_id);
            }
          }
        }
      }
    } else {
      this.setState({ customervalues: [], customerList: [] });
      this.setAutoCompleteOpen(false);
    }
  };

  showAppDialog = ({ variant, title, message }) => {
    this.setState({
      appDialog: {
        open: true,
        variant: variant || 'info',
        title: title || '',
        message: message || '',
      },
      loader: false,
    });
  };

  closeAppDialog = () => {
    this.setState({
      appDialog: {
        ...(this.state.appDialog || {}),
        open: false,
      },
    });
  };

  saveCustomerMaster = async (type) => {
    const { selectedBinId, scanRxItems, EmailID, phone, box_id, selectedBinSize, deactivatedBins } = this.state;
    const { t } = this.props;
    const missing = (value) => [undefined, 'undefined', null, 'null', ''].includes(value);
    const errors = [];
    const binDeactivated = !!(deactivatedBins && deactivatedBins.includes(selectedBinId));
    const locationMissing = !box_id;
    const binSizeMissing = this.state.locationtype_id === LOCATION_TYPE.Kiosk
      && this.state.isSizeBasedPreAssignment
      && missing(selectedBinSize);
    const binMissing = this.state.locationtype_id === LOCATION_TYPE.Kiosk
      && !this.state.isSizeBasedPreAssignment
      && missing(selectedBinId);
    const recordField = document.getElementById('Patient Record Number');
    const patientRecordMissing = this.state.locationtype_id === LOCATION_TYPE.Kiosk
      && (!recordField || missing(recordField.value));
    if (binDeactivated) errors.push(t('Toast.Error.BinDeactivated'));
    if (locationMissing) errors.push(t('Assign.SelectOneBox'));
    if (binSizeMissing) errors.push(t('Unplugged.PleaseSelectBinSizeMessage'));
    if (binMissing) errors.push(t('Unplugged.PleaseSelectBinMessage'));
    if (patientRecordMissing) errors.push(t('Patient.Validation.EnterPatientRecordNumber'));
    const filledCartItems = (scanRxItems || []).filter(
      (item) =>
        item &&
        item.rxNo != null &&
        !['', 'undefined', 'null'].includes(String(item.rxNo).trim())
    );
    if (filledCartItems.length < 1) {
      errors.push(t('Assign.OneItemRequired'));
    } else {
      const notifyChannel = this.state.notifyChannel === 'sms' ? 'sms' : 'email';
      if (notifyChannel === 'email' && String(EmailID || '').trim() === '') {
        errors.push(t('Toast.Error.EnterEmail'));
      }
      if (notifyChannel === 'sms' && String(phone || '').trim() === '') {
        errors.push(t('Toast.Error.EnterMobile'));
      }
    }
    this.setState({
      hasError: locationMissing,
      isBinSizeRequired: binSizeMissing,
      isBinIdRequired: binMissing,
      isPatientRecordNumberRequired: patientRecordMissing,
      loader: false,
    });
    if (errors.length > 0) {
      this.showAppDialog({
        variant: 'error',
        title: t('Unplugged.UnableToSave'),
        message: errors,
      });
      return;
    }
    this.setState({ loader: true });
    const isValidPrescription = await this.checkPrescriptionStatus();
    if (!isValidPrescription) {
      this.showAppDialog({
        variant: 'error',
        title: t('Unplugged.UnableToSave'),
        message: t('Assign.BinNotAvailable'),
      });
      return;
    }
    this.openScanFlagsDialog(type);
  }

  openScanFlagsDialog = (type) => {
    const scanFlagRows = (this.state.scanRxItems || [])
      .map((item, index) => ({ item, index }))
      .filter(({ item }) =>
        item &&
        item.rxNo != null &&
        !['', 'undefined', 'null'].includes(String(item.rxNo).trim())
      )
      .map(({ item, index }) => ({
        index,
        rxNo: item.rxNo,
        drugname: item.drugname || '',
        is_payment_required: this.isFlagTrue(item.is_payment_required),
        is_id_capture: this.isFlagTrue(item.is_id_capture),
      }));
    this.setState({
      scanFlagsDialogOpen: true,
      scanFlagRows,
      pendingSaveType: type,
      loader: false,
    });
  };

  toggleScanFlagRow = (rowIndex, field) => {
    this.setState({
      scanFlagRows: (this.state.scanFlagRows || []).map((row) =>
        row.index === rowIndex ? { ...row, [field]: !row[field] } : row
      ),
    });
  };

  closeScanFlagsDialog = () => {
    this.setState({
      scanFlagsDialogOpen: false,
      scanFlagRows: [],
      pendingSaveType: null,
      loader: false,
    });
  };

  confirmScanFlagsAndSave = () => {
    const rows = this.state.scanFlagRows || [];
    const type = this.state.pendingSaveType;
    const scanRxItems = (this.state.scanRxItems || []).map((item, index) => {
      const row = rows.find((entry) => entry.index === index);
      if (!row) return item;
      return {
        ...item,
        is_payment_required: !!row.is_payment_required,
        is_id_capture: !!row.is_id_capture,
      };
    });
    this.setState(
      {
        scanRxItems,
        copyScanRxItems: scanRxItems,
        scanFlagsDialogOpen: false,
        scanFlagRows: [],
        pendingSaveType: null,
        loader: true,
      },
      () => this.submitServePrescription(type)
    );
  };

  submitServePrescription = async (type) => {
    const { t } = this.props;
    this.getCartRxNumbers();
    const _prepareServePrescriptionRequest = await this.prepareServePrescriptionRequest();
    fetch(process.env.REACT_APP_BASEURL + "serve/prescription", {
            method: "post",
            withCredentials: true,
            headers: {
              Authorization:
                "Bearer " +
                JSON.parse(sessionStorage.getItem("user")).signInUserSession
                  .idToken.jwtToken,
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ ..._prepareServePrescriptionRequest, audit_writer: 'web-gap-v1' })
          }).then(response => {
            try {
              return response.json();
            } catch (error) {
              return null;
            }
          }).then(async (serverPrescriptionResponse) => {
            if (type === 1) {
              const preservedBinId = this.state.selectedBinId;
              try {
                await this.handleOpenPrintDialogWithFreshData(
                  serverPrescriptionResponse,
                  preservedBinId
                );
              } catch (error) {
                console.error('Error opening print dialog:', error);
                this.showAppDialog({
                  variant: 'error',
                  title: t('Unplugged.UnableToSave'),
                  message:
                    this.props.t('Toast.Error.PrintDialog') ||
                    'Failed to open print dialog: ' + (error.message || error),
                });
              }
            } else {
              this.setState({
                printDialogOpen: false,
                brandName: '',
                brandPhone: '',
                storage_location: '',
                order_notes: '',
                selectedBinId: '',
                selectedBinSize: '',
      binSizeLocked: false,
                searchedItems: [],
                rxNumber: '',
                scanRxItems: [],
                EmailID: '',
                notifyChannel: 'email',
                phone: '',
                loader: false,
                patientNotes: '',
                patientNotesReadOnly: true,
                key: this.state.key + 1,
                isPatientSelectionDisabled: false,
                makePreAssignmentAPICall: true,
              }, () => {
                this.socket && this.socket.emit('updateConsole');
                this.showAppDialog({
                  variant: 'info',
                  title: t('Unplugged.Saved'),
                  message: t('Assign.RxAssignedSuccessfully'),
                });
              });
              this.getBoxes();
            }
            this.setState({ makePreAssignmentAPICall: false });
          }).catch(() => {
            this.setState({ loader: false });
          });
  };

  checkIfCodesExists = (data) => {
    this.setState({ loader: true });
    let codes = {...data}
    fetch(process.env.REACT_APP_BASEURL + 'verify/codes', {
      crossDomain: true,
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(codes),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((res) => {
        if (res && res.isExist === true) {
          const _stockCode = randomized('A0', 6, { exclude: '0oOiIlL1&zZ' });
          const _pickupCode = randomized('A0', 6, { exclude: '0oOiIlL1&zZ' });
          codes = {
            stockCode: _stockCode,
            pickupCode: _pickupCode,
          };
        }
        // Codes stored in state only - fetched fresh from database before printing
        this.setState({
          stockCode: codes.stockCode,
          pickupCode: codes.pickupCode,
          loader: false
        });
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  checkPrescriptionStatus = async () => {
    this.setState({ loader: true });
    const { scanRxItems, selectedBinId, box_id, accountDetails } = this.state;
    if (scanRxItems.length > 0) {
      let obj = {
        bin_id: selectedBinId,
        box_id: box_id,
        account_id: accountDetails && accountDetails.id,
      };
      let codes = {
        stockCode: this.state.stockCode,
        pickupCode: this.state.pickupCode,
      };
      this.checkIfCodesExists(codes);
      if (this.is_pre_assignment) {
        return true
      } else {
        return fetch(process.env.REACT_APP_BASEURL + 'prescription/status/check', {
          crossDomain: true,
          method: 'post',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
          },
          body: JSON.stringify(obj),
        }).then((response) => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        }).then((res) => {
          if (
            (res && res.statusCode === 200) ||
            (res && res.statusCode === 404)
          ) {
            this.setState({ loader: false });
            return true;
          } else {
            this.setState({ loader: false });
            return false;
          }
        }).catch(() => {
          this.setState({ loader: false });
        })
      }
    }
  }

  prepareServePrescriptionRequest = async () => {
    const { searchedItems, phone, EmailID, box_id, locationtype_id,
      selectedPatient, selectedBinId, stockCode, pickupCode, box_position,
      source_location, storage_location, order_notes, location_notes,
      orderId, default_courier_selected, courier_tracking, isSelectedFlag, selectedBinSize } = this.state;
    let emailAddress, phoneNumber;
    if (locationtype_id === LOCATION_TYPE.Kiosk) {
      emailAddress = EmailID;
      phoneNumber = phone;
    } else {
      const i = this.state.customerList.findIndex(
        (x) => x.id === selectedPatient.id
      );
      if (i !== -1) {
        emailAddress = this.state.customerList[i].contacts[0].email;
        phoneNumber = this.state.customerList[i].contacts[0].phone;
      } else {
        emailAddress = EmailID;
        phoneNumber = phone;
      }
    }
    return {
      first_name: searchedItems.FirstName,
      middle_name: searchedItems.MiddleName || null,
      last_name: searchedItems.LastName,
      dob: searchedItems.DateOfBirth,
      phone: phoneNumber,
      email: emailAddress,
      notify_channel: this.state.notifyChannel === 'sms' ? 'sms' : 'email',
      parent_box_id: box_id,
      patient_id: searchedItems.PatientID || uuidv4(),
      locationtype_id: locationtype_id,
      ...(() => {
        const deliveryAddress = this.resolveDeliveryAddress();
        return {
          address1: deliveryAddress.addressLine1,
          address2: deliveryAddress.addressLine2,
          city: deliveryAddress.city,
          state: deliveryAddress.state,
          zip: deliveryAddress.zip,
          country: deliveryAddress.country,
        };
      })(),
      location_notes: searchedItems.location_notes,
      notes: this.validateFields(searchedItems && searchedItems.notes) || this.state.patientNotes,
      bin_size: selectedBinSize,
      prescription: {
        bin_id: selectedBinId,
        type_id: locationtype_id === LOCATION_TYPE.Kiosk ? assignmentstatus.ASSIGNED : DEVICE_TYPE.Ready,
        stock_code: stockCode,
        pucode: pickupCode,
        box_id: box_id,
        box_position: box_position,
        source_location: source_location,
        locationtype_id: locationtype_id,
        storage_location: storage_location,
        order_notes: order_notes,
        location_notes: searchedItems.location_notes || location_notes,
        order_id: orderId,
        courier_type: default_courier_selected,
        tracking_number: courier_tracking,
        iscool_item: isSelectedFlag,
        items: await this.preparePrescriptionItemRequest(),
        is_controlled_substance: (this.state.scanRxItems || []).some((item) =>
          this.isFlagTrue(item && item.is_controlledsubstances)
        ),
        is_fastlane: false
      }
    }
  }

  preparePrescriptionItemRequest = async () => {
    let prescriptionItemArray = [];
    // Use live cart rows — copyScanRxItems can be stale due to async setState.
    const sourceItems = Array.isArray(this.state.scanRxItems)
      ? this.state.scanRxItems.slice()
      : [];
    const filledItems = sourceItems.filter(
      (item) =>
        item &&
        item.rxNo != null &&
        !['', 'undefined', 'null'].includes(String(item.rxNo).trim())
    );
    for (let i = 0; i < filledItems.length; i++) {
      let singleItem = filledItems[i];
      prescriptionItemArray.push({
        rx_no: singleItem.rxNo,
        drug_name: singleItem.drugname,
        ndc_code: singleItem.ndcCode,
        price: this.ReplaceAmount(singleItem.price),
        expires_on: [undefined, 'undefined', null, 'null', ''].includes(singleItem.ExpirationDate) ? '01/01/2020' : singleItem.ExpirationDate,
        qty: singleItem.qty,
        strength: singleItem.strength,
        route: singleItem.route,
        doseage_form: singleItem.doseage_form,
        non_proprietary_name: singleItem.non_proprietary_name,
        fillNumber: [undefined, 'undefined', null, 'null', ''].includes(singleItem.fillNumber) ? 0 : singleItem.fillNumber,
        is_consultrequire: this.isFlagTrue(singleItem.ConsultRequire) || this.isFlagTrue(singleItem.is_consultrequire),
        is_payment_required: this.isFlagTrue(singleItem.is_payment_required),
        is_id_capture: this.isFlagTrue(singleItem.is_id_capture),
        prescriptionnumber: [undefined, 'undefined', null, 'null', ''].includes(singleItem.prescriptionNumber) ? '' : singleItem.prescriptionNumber,
        is_returnable: this.isFlagTrue(singleItem.IsReturnable) || this.isFlagTrue(singleItem.is_returnable),
        is_controlledsubstances: this.isFlagTrue(singleItem.is_controlledsubstances)
      })
    }
    return prescriptionItemArray;
  }

  handleBinSizeChange = async (event) => {
    event.preventDefault();
    this.setState({
      selectedBinSize: event.target.value,
      isBinSizeRequired: false,
    });
  };

  getDeliveryTypeSelectItems = () =>
    decorateLocationTypesWithLicense(
      this.state.locationtype,
      this.state.featureEntitlements
    ).map((type) => ({
      id: type.id,
      name: type.locked
        ? `${type.label} (${this.props.t('Features.StatusLocked', {
            defaultValue: 'Not enabled',
          })})`
        : type.label,
    }));

  getLocationSelectItems = () =>
    (this.state.boxdata || []).map((box) => ({
      id: box.id,
      name: box.value,
    }));

  getBinSizeSelectItems = (t) => {
    const binSizeTranslationObj = getBinSizeTranslationMap(t);
    return [
      { id: '', name: t('Unplugged.SelectBinSize') },
      ...(this.BinSizes || []).map((size) => ({
        id: size,
        name: binSizeTranslationObj[size] || size,
      })),
    ];
  };

  confirmBinOkButton = () => {
    this.setState({
      isVerifyingBin: false,
      isVerifyingBinMessage: '',
      selectedBinId: '',
    });
  };

  getAvailableBinsCount = async (box_id) => {
    fetch(process.env.REACT_APP_BASEURL + 'pre-assignment/getAvailableBinsCount/' + box_id, {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
      },
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((result) => {
        if (!result || !result.data) {
          return;
        }
        const legacyCounts = parseAvailableBinCounts(result.data);
        const applyBinSizes = this.storeBinSizeMap(result.binSizes);
        this.setState((prev) => ({
          ...applyBinSizes(prev),
          binCountsBySize: parseSizeBasedBinCounts(result.data),
          largeBinsCount: legacyCounts.largeCounts,
          mediumBinsCount: legacyCounts.mediumCounts,
          smallBinsCount: legacyCounts.smallCounts,
          coolBinsCount: legacyCounts.coolCounts,
        }));
      })
      .catch(error => console.error(error));
  }

  handleIsReturnable = (index) => {
    const scanRxItems = (this.state.scanRxItems || []).slice();
    if (scanRxItems[index]) {
      const nextValue = !(
        this.isFlagTrue(scanRxItems[index].IsReturnable) ||
        this.isFlagTrue(scanRxItems[index].is_returnable)
      );
      scanRxItems[index] = {
        ...scanRxItems[index],
        IsReturnable: nextValue,
        is_returnable: nextValue,
      };
      this.setState({ scanRxItems });
    }
  }

  handleIsControlledSubstance = (index) => {
    const scanRxItems = (this.state.scanRxItems || []).slice();
    if (scanRxItems[index]) {
      scanRxItems[index] = {
        ...scanRxItems[index],
        is_controlledsubstances: !this.isFlagTrue(
          scanRxItems[index].is_controlledsubstances
        ),
      };
      this.setState({ scanRxItems });
    }
  }

  setPermission = () => {
    let permissions = JSON.parse(sessionStorage.getItem("permissions"));
    let _checkUserRole = JSON.parse(sessionStorage.getItem("permissionUser"));
    if(_checkUserRole === userroles.SUPERADMIN) {
      this.setState({ 
        isManualOverridePermissionEnabled: true, 
        prescriptionUnAssign: true, 
        prescriptionAssign: true, 
        prescriptionView: true,
        prescriptionDirectPickup: true,
        prescriptionRemind: true,
        prescriptionConsult: true,
        prescriptionHoldResume: true,
        prescriptionAcDc: true, });
    } else {
      if (permissions && permissions.length > 0) {
        const manualOverride = permissions.filter((item) => {
          return item.permission_entity_type === "Manual Override"
        });
        const assignPrescriptions = permissions.filter((item) => {
          return item.permission_entity_type === "Assign Prescription"
        });

        if (manualOverride.length > 0) {
          this.setState({ isManualOverridePermissionEnabled: manualOverride.some((x) => x.name.trim() === 'Open Bin' && x.is_allowed === 1) })
        } else {
          this.setState({ isManualOverridePermissionEnabled: false });
        }

        if (assignPrescriptions.length > 0) {
          this.setState({
            prescriptionUnAssign: assignPrescriptions.some((x) => x.name.trim() === 'UnAssign' && x.is_allowed === 1),
            prescriptionAssign: assignPrescriptions.some((x) => x.name.trim() === 'Assign' && x.is_allowed === 1),
            prescriptionView: assignPrescriptions.some((x) => x.name.trim() === 'View' && x.is_allowed === 1),
            prescriptionRemind: assignPrescriptions.some((x) => x.name.trim() === 'Remind' && x.is_allowed === 1),
            prescriptionDirectPickup: assignPrescriptions.some((x) => x.name.trim() === 'Direct Pickup' && x.is_allowed === 1),
            prescriptionConsult: assignPrescriptions.some((x) => x.name.trim() === 'Consult' && x.is_allowed === 1),
            prescriptionAcDc: assignPrescriptions.some((x) => x.name.trim() === 'Activate/DeActivate' && x.is_allowed === 1),
            prescriptionHoldResume: assignPrescriptions.some((x) => x.name.trim() === 'Hold/Resume' && x.is_allowed === 1),
          })
        } else {
          this.setState({
            prescriptionUnAssign: false,
            prescriptionAssign: false,
            prescriptionView: false,
            prescriptionDirectPickup: false,
            prescriptionRemind: false,
            prescriptionConsult: false,
            prescriptionHoldResume: false,
            prescriptionAcDc: false,
          });
        }
      } else {
        this.setState({ 
          isManualOverridePermissionEnabled: false, 
          prescriptionUnAssign: false, 
          prescriptionAssign: false, 
          prescriptionView: false,
          prescriptionDirectPickup: false,
          prescriptionRemind: false,
          prescriptionConsult: false,
          prescriptionHoldResume: false,
          prescriptionAcDc: false 
        });
      } 
    }
  }

  checkIfBinIsOccupedFromAnotherLocation = (type) => {
    const { box_id, selectedBinId, binid } = this.state;
    if(this.state.locationtype_id !== LOCATION_TYPE.Kiosk) {
      if([undefined, 'undefined', null, 'null', ""].includes(selectedBinId)) {
        console.log("No action required for other types of locations.");
        this.saveCustomerMaster(type);
        return;
      }
      if([undefined, 'undefined', null, 'null', ""].includes(binid)) {
        console.log("No action required for other types of locations.");
        this.saveCustomerMaster(type);
        return;
      }
    }
    fetch(process.env.REACT_APP_BASEURL + "api/v2/orders/bin/status", {
      crossDomain: true,
      method: "post",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify({
        box_id: box_id,
        bin_id: selectedBinId || binid,
      }),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          console.log(
            `Preflight error while processing request ${error && error.message}`
          );
          return null;
        }
      })
      .then(async (res) => {
        if (res && res.isOccupied === true) {
          toast.error(res.message);
        } else {
          this.saveCustomerMaster(type);
        }
      })
      .catch((error) => {
        toast.error(`Error while checking status ${error && error.message}`);
      });
  };

  renderUnpluggedActionButton = (label, onClick, options = {}) => {
    const {
      disabled,
      variant = 'neutral',
      children,
      tooltip,
      placement = 'top',
      iconOnly,
      ...rest
    } = options;
    const isIconOnly =
      iconOnly === true || (Boolean(children) && (label == null || label === ''));
    const tooltipTitle = formatAssignActionTooltip(
      tooltip !== undefined && tooltip !== null && tooltip !== ''
        ? tooltip
        : label
    );
    const button = (
      <Button
        type='button'
        variant='contained'
        disableElevation
        disabled={disabled}
        onClick={onClick}
        sx={{
          ...getAssignActionButtonSx(variant),
          ...(isIconOnly
            ? {
                minWidth: assignActionIconButtonSize,
                width: assignActionIconButtonSize,
                height: assignActionIconButtonSize,
                p: 0,
                borderRadius: '12px',
              }
            : {}),
        }}
        {...rest}
      >
        {children || label}
      </Button>
    );

    if (!tooltipTitle) {
      return button;
    }

    return (
      <Tooltip title={tooltipTitle} arrow placement={placement}>
        <span style={{ display: 'inline-flex' }}>{button}</span>
      </Tooltip>
    );
  };

  renderUnpluggedActionFooter = () => {
    const { t } = this.props;
    const {
      scanRxItems,
      copyScanRxItems,
      isAlreadyOnHold,
      isAlreadyAssigned,
      is_stocked,
      prescriptionUnAssign,
      prescriptionAssign,
      prescriptionDirectPickup,
      prescriptionRemind,
      prescriptionConsult,
      prescriptionHoldResume,
    } = this.state;
    const itemCount =
      (scanRxItems && scanRxItems.length) ||
      (copyScanRxItems && copyScanRxItems.length) ||
      (searchedRxNumbers && searchedRxNumbers.length) ||
      0;
    const zeroItems = itemCount === 0;
    const loading = this.state && this.state.isLoadingTrans === true;
    const saveLocked = !!(this.state.loader || this.state.scanFlagsDialogOpen || this.state.printLoading);
    const itemDisabled = zeroItems || loading || saveLocked;

    return (
      <div style={saveLocked ? { pointerEvents: 'none' } : undefined}>
      <AssignPrescriptionActionFooter>
        {(is_stocked || isAlreadyAssigned || isAlreadyOnHold) && itemCount !== 0 ? (
          <React.Fragment>
            {prescriptionRemind
              ? this.renderUnpluggedActionButton(
                  t('Unplugged.Remind'),
                  () => this.reminderHandler(),
                  { variant: 'remind' }
                )
              : null}
            {prescriptionConsult
              ? this.renderUnpluggedActionButton(
                  t('Unplugged.Consult'),
                  () => this.handleConsultClick(),
                  { variant: 'consult' }
                )
              : null}
          </React.Fragment>
        ) : null}
        {this.renderUnpluggedActionButton(
          t('Unplugged.Clear'),
          () => this.ClearFields('clear'),
          { variant: 'neutral', disabled: itemDisabled }
        )}
        {!this.state.isVisibleForPause ? (
          <React.Fragment>
            {prescriptionDirectPickup
              ? this.renderUnpluggedActionButton(
                  t('Unplugged.DirectPickup'),
                  () => this.ManualPickupNotification(0),
                  { variant: 'pickup', disabled: itemDisabled }
                )
              : null}
            {prescriptionAssign ? (
              <React.Fragment>
                {this.renderUnpluggedActionButton(
                  t('Unplugged.Save'),
                  () => this.checkIfBinIsOccupedFromAnotherLocation(0),
                  { variant: 'primary', disabled: itemDisabled }
                )}
                {this.renderUnpluggedActionButton(
                  t('Unplugged.SavePrint'),
                  () => this.checkIfBinIsOccupedFromAnotherLocation(1),
                  { variant: 'savePrint', disabled: itemDisabled }
                )}
              </React.Fragment>
            ) : null}
          </React.Fragment>
        ) : !isAlreadyOnHold ? (
          <React.Fragment>
            {isAlreadyAssigned ? (
              <React.Fragment>
                {prescriptionDirectPickup
                  ? this.renderUnpluggedActionButton(
                      t('Unplugged.DirectPickup'),
                      () => this.ManualPickupNotification(1),
                      { variant: 'pickup', disabled: itemDisabled }
                    )
                  : null}
                {prescriptionUnAssign
                  ? this.renderUnpluggedActionButton(
                      null,
                      () => this.changeOrderStatus('remove'),
                      {
                        variant: 'remove',
                        disabled: isAlreadyOnHold,
                        tooltip: t('Assign.RemovePrescription', {
                          defaultValue: 'Remove',
                        }),
                        children: <RemoveIcon fontSize='small' />,
                        iconOnly: true,
                      }
                    )
                  : null}
              </React.Fragment>
            ) : null}
            {prescriptionHoldResume
              ? this.renderUnpluggedActionButton(
                  null,
                  () => this.changeOrderStatus('pause'),
                  {
                    variant: 'hold',
                    disabled: isAlreadyOnHold || isAlreadyAssigned,
                    tooltip: t('API.Roles.Permission.Assign.Hold', {
                      defaultValue: 'Pause order',
                    }),
                    children: <Pause fontSize='small' />,
                    iconOnly: true,
                  }
                )
              : null}
            {this.renderUnpluggedActionButton(
              this.state.printLoading ? null : t('Unplugged.PrintLabel'),
              () => this.handlePrintReceipt(),
              {
                variant: 'printLabel',
                disabled: this.state.printLoading,
                children: this.state.printLoading ? (
                  <CircularProgress size={18} sx={{ color: '#ffffff' }} />
                ) : null,
              }
            )}
          </React.Fragment>
        ) : (
          <React.Fragment>
            {prescriptionHoldResume
              ? this.renderUnpluggedActionButton(
                  null,
                  () => this.changeOrderStatus('play'),
                  {
                    variant: 'resume',
                    disabled: !isAlreadyOnHold,
                    tooltip: t('Assign.ResumeButton', {
                      defaultValue: 'Resume order',
                    }),
                    children: <PlayArrow fontSize='small' />,
                    iconOnly: true,
                  }
                )
              : null}
            {this.renderUnpluggedActionButton(
              this.state.printLoading ? null : t('Unplugged.PrintLabel'),
              () => this.handlePrintReceipt(),
              {
                variant: 'printLabel',
                disabled: this.state.printLoading,
                children: this.state.printLoading ? (
                  <CircularProgress size={18} sx={{ color: '#ffffff' }} />
                ) : null,
              }
            )}
          </React.Fragment>
        )}
      </AssignPrescriptionActionFooter>
      </div>
    );
  };

  resolveDeliveryAddress = () => {
    const searched = this.state.searchedItems || {};
    const stored = this.state.address || {};
    const box = (this.state.boxdata || []).find(
      (item) => item && String(item.id) === String(this.state.box_id)
    );
    const boxAddr = (box && box.address) || box || {};
    const locations = this.state.locationDetails || [];
    const location = locations.find(
      (type) => String(type.locationtype_id) === String(this.state.locationtype_id)
    ) || locations[0] || {};
    const first = (...values) => {
      for (let i = 0; i < values.length; i += 1) {
        if (values[i] != null && String(values[i]).trim() !== '' && String(values[i]) !== 'null') {
          return values[i];
        }
      }
      return '';
    };
    return {
      addressLine1: first(
        searched.AddressLine1,
        stored.address1,
        boxAddr.address_line_1,
        location.addressline1,
        location.address_line_1
      ),
      addressLine2: first(
        searched.AddressLine2,
        stored.address2,
        boxAddr.address_line_2,
        location.addressline2,
        location.address_line_2
      ),
      city: first(searched.City, stored.city, boxAddr.city, location.city),
      state: first(searched.State, stored.state, boxAddr.state, location.state),
      zip: first(searched.Zip, stored.zip, boxAddr.zip, location.zip),
      country: first(searched.Country, stored.country, boxAddr.country, location.country),
    };
  };

  renderLocationField = () => {
    const { classes, t } = this.props;
    const { hasError } = this.state;
    return (
      <div className={classes.layoutBorder}>
        <SearchableSelect
          label={t('Unplugged.Location')}
          items={this.getLocationSelectItems()}
          value={this.state.box_id || ''}
          onChange={(e) => this.handleChange(e.target.value)}
          placeholder={t('Unplugged.Location')}
          id='box_ids'
          fullWidth={true}
          variant='standard'
        />
        {hasError && (
          <FormHelperText className={classes.selectLable}>
            {t('Assign.SelectOneBox')}
          </FormHelperText>
        )}
      </div>
    );
  };

  renderBinField = () => {
    const { classes, t } = this.props;
    if (this.getActiveLocationTypeId() !== LOCATION_TYPE.Kiosk || !this.state.isSizeBasedPreAssignment) {
      return null;
    }
    return (
      <div className={classes.layoutBorder}>
        <SearchableSelect
          label={t('Unplugged.BinSize')}
          items={this.getBinSizeSelectItems(t)}
          value={this.state.selectedBinSize || ''}
          onChange={this.handleBinSizeChange}
          placeholder={t('Unplugged.SelectBinSize')}
          id='bin_sizes'
          fullWidth={true}
          variant='standard'
          disabled={Boolean(this.state.readOnly) || Boolean(this.state.binSizeLocked)}
        />
        {this.state.isBinSizeRequired ? (
          <FormHelperText className={classes.selectLable}>
            {t('Validation.Required')}
          </FormHelperText>
        ) : null}
      </div>
    );
  };

  renderAddressFields = () => {
    const { classes, t } = this.props;
    const { searchedItems } = this.state;
    const field = (id, label, value) => (
      <div className={classes.layoutBorder} key={id}>
        <TextField
          id={id}
          type='text'
          className={classes.textField}
          margin='normal'
          variant='standard'
          label={label}
          fullWidth
          InputLabelProps={{ shrink: true }}
          value={this.validateFields(value)}
          inputProps={{
            autocomplete: 'off',
            form: { autocomplete: 'off' },
          }}
        />
      </div>
    );
    return (
      <div className={classes.addressBlock}>
        {field('address1', t('Unplugged.Address1'), searchedItems && searchedItems.AddressLine1)}
        {field('address2', t('Unplugged.Address2'), searchedItems && searchedItems.AddressLine2)}
        {field('city', t('Unplugged.City'), searchedItems && searchedItems.City)}
        {field('state', t('Unplugged.State'), searchedItems && searchedItems.State)}
        {field('zip', t('Unplugged.Zip'), searchedItems && searchedItems.Zip)}
        {field('country', t('Unplugged.Country'), searchedItems && searchedItems.Country)}
      </div>
    );
  };

  render() {
    const { locale } = this.state;
    const {
      searchedItems,
      selectedBinId,
      stockCode,
      pickupCode,
      selected,
      order,
      orderBy,
      openAutoComplete,
      customervalues,
      prescriptionView,
    } = this.state;
    const { classes, t } = this.props;
    const locationtype_id = this.getActiveLocationTypeId();
    const loading = openAutoComplete && customervalues.length === 0;
    const deliveryAddress = this.resolveDeliveryAddress();
    return (
      <Box component='div' className={classes.assignPageRoot}>
        <Paper className={`${classes.paperRoot} assign-prescription-dense`}>
          {/* Search Bar Row - At top of Paper (aligned with other connection types) */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 0,
              gap: 2,
              width: '100%',
              px: 1,
              pt: 0.25,
            }}
          >
            <Box sx={{ flexShrink: 0, ml: 'auto' }}>
              <TextField
                id='idsearchtxt'
                type='text'
                margin='normal'
                variant='standard'
                value={this.state.searchObj.searchTxt}
                label={t('Unplugged.Search')}
                InputProps={{
                  inputProps: { autoComplete: 'off' },
                  form: {
                    autoComplete: 'off',
                  },
                  startAdornment: (
                    <InputAdornment position='start'>
                      <MagnifyIcon />
                    </InputAdornment>
                  ),
                }}
                onChange={this.onSearchChange}
                inputRef={this.textInput}
                sx={{ width: '6cm' }}
              />
            </Box>
          </Box>
          {(this.state.loader || this.state.printLoading || this.state.isLoadingTrans) ? (
            <LinearProgress
              className={classes.loaderBar}
              aria-label={t('Unplugged.Loading')}
            />
          ) : null}
          {this.state.loader ? (
            <div className={classes.spinner} role='status' aria-live='polite'>
              <CircularProgress size={44} thickness={4} sx={{ color: '#00a7e1' }} />
            </div>
          ) : null}
          <div id='react-no-print'>
            <div id='react-no-print' className={classes.root}>
              <ConfirmDialog
                open={this.state.deleteDialogOpen || false}
                title={t('Assign.DeleteConfirmation')}
                message={`${t('Unplugged.AreYouSureToDelete')}:`}
                items={(this.state.forDeletion || [])
                  .filter((item) => item && item.rxNo !== '')
                  .map((item) => item.drugname || item.rxNo)}
                cancelLabel={t('Unplugged.Cancel')}
                confirmLabel={t('Unplugged.Delete')}
                onClose={this.deleteConfirmClose}
                onConfirm={this.deleteConfirmed}
              />
              <Dialog
                open={this.state.SearchResultDialogOpen || false}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
                fullWidth={true}
                PaperProps={{
                  style: { maxWidth: '1315px' },
                }}>
                {/* <DialogTitle id="alert-dialog-title">{'Picked up by'}</DialogTitle> */}
                <DialogContent>
                  {this.state.innerSearchLoader && (
                    <Box component='div' className={classes.spinner}>
                      <CircularProgress size={40} thickness={4} sx={{ color: '#00a7e1' }} />
                    </Box>
                  )}
                  <Table aria-labelledby='tableTitle'>
                    <TableHead>
                      <TableRow style={{ height: '56px' }}>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Unplugged.SearchPopup.FirstName')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Unplugged.SearchPopup.LastName')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Unplugged.SearchPopup.Email')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Unplugged.SearchPopup.Phone')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Unplugged.SearchPopup.Bin')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Unplugged.SearchPopup.Status')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Unplugged.SearchPopup.StockCode')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Unplugged.SearchPopup.PUCode')}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Array.isArray(this.state.selectedObject) &&
                        this.state.selectedObject.length > 0 ? (
                        this.state.selectedObject.map((n) => {
                          return (
                            <TableRow>
                              <TableCell className={classes.tablebody}>
                                {n.first_name}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.last_name}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.email}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.phone}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.bin_id}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.status}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                <a
                                  href=''
                                  title='View'
                                  style={{
                                    color: '#385cad',
                                    fontWeight: 500,
                                    textDecoration: 'none ',
                                    fontSize: '1rem',
                                  }}
                                  onClick={(event) =>
                                    this.handlePUcodeClick(
                                      event,
                                      n.bin_id,
                                      n.pm_id,
                                      n.box_id
                                    )
                                  }>
                                  {n.stock_code}
                                </a>
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                <a
                                  href=''
                                  title='View'
                                  style={{
                                    color: '#385cad',
                                    fontWeight: 500,
                                    textDecoration: 'none ',
                                    fontSize: '1rem',
                                  }}
                                  onClick={(event) =>
                                    this.handlePUcodeClick(
                                      event,
                                      n.bin_id,
                                      n.pm_id,
                                      n.box_id
                                    )
                                  }>
                                  {n.pucode}
                                </a>
                              </TableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <TableRow>
                          <TableCell colSpan={5}>
                            {t('Unplugged.NoDataFound')}
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                  <ThemeProvider theme={localeTheme}>
                    <TablePagination
                      component='div'
                      count={this.state.totalSearchRecords || 0}
                      rowsPerPage={this.state.searchObj.pageSize}
                      page={this.state.searchObj.pageNo}
                      backIconButtonProps={{
                        'aria-label': 'Previous Page',
                      }}
                      nextIconButtonProps={{
                        'aria-label': 'Next Page',
                      }}
                      style={{ color: 'rgba(0, 0, 0, 0.54)' }}
                      onPageChange={this.handleChangePage}
                      onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                  </ThemeProvider>
                </DialogContent>
                <DialogActions style={{ marginTop: '-20px' }}>
                  <Button
                    onClick={(e) => {
                      this.handleSearchClose(e);
                    }}
                    color='primary'
                    className={classes.primaryButton}>
                    Close
                  </Button>
                </DialogActions>
              </Dialog>
              <div className="assign-page-columns">
              <div id='react-no-print' className={classNames(classes.assignForm, 'assign-form-panel')}>
                <div className={classes.deliverFields}>
                  <div className={classNames(classes.layoutBorder, classes.deliverFieldSpan)}>
                    <ThemeProvider theme={localeTheme}>
                      <Autocomplete
                        key={this.state.key}
                        id='search-unplugged-patient'
                        style={{ width: '100%' }}
                        open={this.state && this.state.openAutoComplete}
                        onOpen={() => {
                          this.setAutoCompleteOpen(true);
                        }}
                        onClose={() => {
                          this.setAutoCompleteOpen(false);
                        }}
                        getOptionSelected={(option, value) =>
                          option.id === value.id
                        }
                        getOptionLabel={(option) => option.name}
                        options={this.state && this.state.customervalues}
                        loading={loading}
                        onChange={this.onOptionSelect}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={t('Unplugged.SearchPatient')}
                            variant='standard'
                            onChange={(ev) => {
                              if (
                                ev.target.value !== '' ||
                                ev.target.value !== null
                              ) {
                                this.onPatientChange(ev.target.value);
                              }
                            }}
                            disabled={this.state.isPatientSelectionDisabled}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <React.Fragment>
                                  {loading ? (
                                    <CircularProgress
                                      size={20}
                                      sx={{ color: '#00a7e1' }}
                                    />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </React.Fragment>
                              ),
                            }}
                          />
                        )}
                      />
                    </ThemeProvider>
                  </div>
                  <div className={classes.layoutBorder}>
                    <TextField
                      id='firstName'
                      type='text'
                      className={classes.textField}
                      margin='normal'
                      variant='standard'
                      label={t('Unplugged.FirstName')}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ autocomplete: 'off', form: { autocomplete: 'off' } }}
                      value={this.validateFields(searchedItems && searchedItems.FirstName)}
                    />
                  </div>
                  <div className={classes.layoutBorder}>
                    <TextField
                      id='lastName'
                      type='text'
                      className={classes.textField}
                      margin='normal'
                      variant='standard'
                      label={t('Unplugged.LastName')}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ autocomplete: 'off', form: { autocomplete: 'off' } }}
                      value={this.validateFields(searchedItems && searchedItems.LastName)}
                    />
                  </div>
                  <div className={classes.layoutBorder}>
                    <TextField
                      required
                      error={this.state.isPatientRecordNumberRequired}
                      id='Patient Record Number'
                      type='text'
                      className={classes.textField}
                      margin='normal'
                      variant='standard'
                      label={t('Unplugged.PatientRecordNumber')}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      value={this.BindPatientId('')}
                      inputProps={{ autocomplete: 'off', form: { autocomplete: 'off' } }}
                    />
                  </div>
                  <div className={classNames(classes.contactChoice, classes.deliverFieldSpan)}>
                    <span className={classes.contactChoiceLabel}>{t('Unplugged.NotifyBy')}</span>
                    <RadioGroup
                      row
                      name='notifyChannel'
                      value={this.state.notifyChannel === 'sms' ? 'sms' : 'email'}
                      onChange={(event) => this.setState({ notifyChannel: event.target.value })}
                    >
                      <FormControlLabel
                        value='email'
                        control={<Radio size='small' color='primary' />}
                        label={t('Unplugged.Email')}
                      />
                      <FormControlLabel
                        value='sms'
                        control={<Radio size='small' color='primary' />}
                        label={t('Unplugged.SMSPhone')}
                      />
                    </RadioGroup>
                    <span className={classes.contactChoiceHelp}>{t('Unplugged.NotifyByHelp')}</span>
                  </div>
                  <div className={classes.layoutBorder}>
                    <TextField
                      id='dateOfBirth'
                      type='text'
                      className={classes.textField}
                      margin='normal'
                      variant='standard'
                      label={t('Unplugged.DOB')}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      autoComplete='off'
                      value={this.validateFields(searchedItems && searchedItems.DateOfBirth)}
                      inputProps={{ autocomplete: 'off', form: { autocomplete: 'off' } }}
                    />
                  </div>
                  <div className={classes.layoutBorder}>
                    <TextField
                      id='phoneNo'
                      type='text'
                      className={classes.textField}
                      fullWidth
                      margin='normal'
                      variant='standard'
                      label={
                        this.state.notifyChannel === 'sms'
                          ? `${t('Unplugged.SMSPhone')} *`
                          : t('Unplugged.SMSPhone')
                      }
                      name='phone'
                      onChange={this.onInputChange}
                      InputLabelProps={{ shrink: true, maxLength: 10 }}
                      value={this.state.phone}
                      inputProps={{ autocomplete: 'off', form: { autocomplete: 'off' } }}
                    />
                  </div>
                  <div className={classes.layoutBorder}>
                    <TextField
                      id='email'
                      type='email'
                      className={classes.textField}
                      fullWidth
                      margin='normal'
                      variant='standard'
                      label={
                        this.state.notifyChannel === 'sms'
                          ? t('Unplugged.Email')
                          : `${t('Unplugged.Email')} *`
                      }
                      name='EmailID'
                      onChange={this.onInputChange}
                      InputLabelProps={{ shrink: true }}
                      value={this.state.EmailID}
                      inputProps={{ autocomplete: 'off', form: { autocomplete: 'off' } }}
                    />
                  </div>
                  <div className={classNames(classes.layoutBorder, classes.deliverFieldSpan)}>
                    <TextField
                      id='patientNotes'
                      type='text'
                      className={classes.textField}
                      margin='normal'
                      variant='standard'
                      label={t('Unplugged.PatientNotes')}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ autocomplete: 'off', form: { autocomplete: 'off' } }}
                      value={this.state.patientNotes}
                      onChange={(e) => !this.state.patientNotesReadOnly && this.setState({ patientNotes: e.target.value })}
                      readOnly={this.state.patientNotesReadOnly}
                    />
                  </div>
                </div>
                <div className={classNames(classes.adjustDrugGrid, classes.rxCartSection, 'assign-rx-cart')}>
                  {selected.length > 0 ? (
                    <EnhancedTableToolbar
                      numSelected={selected.length}
                      deleteItems={this.deleteItems}
                      confirmDelete={this.confirmDelete}
                    />
                  ) : null}
                  <div
                    className={classNames(classes.handleOverflow, 'assign-rx-cart-scroll', {
                      'is-empty': !this.state.scanRxItems.length,
                    })}
                  >
                    <Table
                      className={classes.table}
                      aria-labelledby='tableTitle'>
                      <EnhancedTableHead
                        numSelected={selected.length}
                        order={order}
                        orderBy={orderBy}
                        onSelectAllClick={this.handleSelectAllClick}
                        onRequestSort={this.handleRequestSort}
                        rowCount={
                          this.state.scanRxItems
                            ? this.state.scanRxItems.length
                            : 0
                        }
                        isVisibleForPause={this.state.isVisibleForPause}
                        className={classes.tableCellLabel}
                      />
                      <TableBody>
                        {this.state.scanRxItems.length === 0 ? (
                          <TableRow>
                            <TableCell
                              className={classes.emptyRowCell}
                              style={{ padding: '6px 0px' }}
                              colSpan={this.state.isVisibleForPause ? 8 : 9}>
                              {t('Unplugged.NoDataFound')}
                            </TableCell>
                          </TableRow>
                        ) : (
                          stableSort(
                            this.state.scanRxItems,
                            getSorting(order, orderBy)
                          ).map((row, index) => {
                            const isSelected = this.isSelected(
                              this.state.scanRxItems[index].rxNo
                            );
                            return (
                              <TableRow
                                hover
                                role='checkbox'
                                aria-checked={isSelected}
                                tabIndex={-1}
                                key={index}
                                selected={isSelected}>
                                {!this.state.isVisibleForPause && (
                                  <TableCell
                                    padding='checkbox'
                                    onClick={(event) =>
                                      this.handleClick(
                                        event,
                                        this.state.scanRxItems[index].rxNo,
                                        index
                                      )
                                    }
                                    style={{ padding: 0, textAlign: 'center' }}>
                                    <Checkbox
                                      checked={isSelected}
                                      style={{ color: '#4fc3f7' }}
                                    />
                                  </TableCell>
                                )}
                                <TableCell
                                  sx={{
                                    p: '0px',
                                    pl: '5px',
                                    pr: '0px',
                                    textAlign: 'left',
                                  }}>
                                  <TextField
                                    id='rxNo'
                                    type='text'
                                    className={classes.textField}
                                    fullWidth
                                    margin='normal'
                                    variant='standard'
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{
                                      autocomplete: 'off',
                                      form: {
                                        autocomplete: 'off',
                                      },
                                      readOnly: Boolean(this.state.readOnly),
                                    }}
                                    value={this.state.scanRxItems[index].rxNo}
                                    sx={{
                                      pr: '10px',
                                      '.MuiInput-root': { fontSize: '0.80rem' },
                                    }}
                                    onBlur={(e) => {
                                      if (this.state.isEdit === false)
                                        this.onRXValidate(index, 'rxNo', e.target.value);
                                    }}
                                    onChange={(e) =>
                                      this.onScanRxChange(index, 'rxNo', e.target.value)
                                    }
                                  />
                                </TableCell>
                                <TableCell
                                  className={classes.tableCell}
                                  sx={{ padding: 0, textAlign: 'left' }}>
                                  <TextField
                                    id='drugname'
                                    type='text'
                                    fullWidth
                                    className={classes.textField}
                                    margin='normal'
                                    variant='standard'
                                    inputProps={{
                                      autocomplete: 'off',
                                      form: {
                                        autocomplete: 'off',
                                      },
                                      readOnly: Boolean(this.state.readOnly),
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                    value={
                                      this.state.scanRxItems[index].drugname
                                    }
                                    sx={{
                                      pr: '10px',
                                      '.MuiInput-root': { fontSize: '0.80rem' },
                                    }}
                                    onChange={(e) =>
                                      this.onScanRxChange(
                                        index,
                                        'drugname',
                                        e.target.value
                                      )
                                    }
                                  />
                                </TableCell>
                                <TableCell
                                  className={classes.tableCell}
                                  sx={{ padding: 0, textAlign: 'left' }}>
                                  <TextField
                                    id='ndccode'
                                    type='text'
                                    fullWidth
                                    className={classes.textField}
                                    margin='normal'
                                    variant='standard'
                                    inputProps={{
                                      readOnly: Boolean(this.state.readOnly),
                                      autocomplete: 'off',
                                      form: {
                                        autocomplete: 'off',
                                      },
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                    value={
                                      this.state.scanRxItems[index].ndcCode
                                    }
                                    sx={{
                                      pr: '10px',
                                      '.MuiInput-root': { fontSize: '0.80rem' },
                                    }}
                                    onChange={(e) =>
                                      this.onScanRxChange(
                                        index,
                                        'ndcCode',
                                        e.target.value
                                      )
                                    }
                                  />
                                </TableCell>
                                <TableCell
                                  className={classes.tableCell}
                                  sx={{ padding: 0, textAlign: 'left' }}>
                                  <TextField
                                    id='qty'
                                    type='number'
                                    fullWidth
                                    className={classes.textField}
                                    margin='normal'
                                    variant='standard'
                                    inputProps={{
                                      inputMode: 'numeric',
                                      pattern: '[0-9]*',
                                      readOnly: Boolean(this.state.readOnly),
                                      min: 0,
                                      autocomplete: 'off',
                                      form: {
                                        autoComplete: 'off',
                                      },
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                    value={this.state.scanRxItems[index].qty}
                                    sx={{
                                      pr: '10px',
                                      '.MuiInput-root': { fontSize: '0.80rem' },
                                    }}
                                    onChange={(e) =>
                                      this.onScanRxChange(
                                        index,
                                        'qty',
                                        e.target.value
                                      )
                                    }
                                  />
                                </TableCell>
                                <TableCell
                                  className={`${classes.tableCell} assign-rx-cart-price-cell-wrap`}
                                  sx={{ textAlign: 'left', verticalAlign: 'middle' }}>
                                  <div className='assign-rx-cart-price-cell'>
                                    {this.state.isEdit === true &&
                                    this.state.isAmountPaid === false &&
                                    this.state.isPartiallyPaid !== true ? (
                                      this.state.indexNo === index ? (
                                        <React.Fragment>
                                          <TextField
                                            sx={{
                                              width: '64px',
                                              m: 0,
                                              '.MuiInput-root': {
                                                fontSize: '0.75rem',
                                              },
                                            }}
                                            value={parseFloat(
                                              this.state.scanRxItems[index][
                                              'price'
                                              ]
                                            )}
                                            variant='standard'
                                            onChange={(e) =>
                                              this.onHandleChangeInputValue(
                                                this.state.scanRxItems[index][
                                                'id'
                                                ],
                                                'price',
                                                e.target.value
                                              )
                                            }
                                            id='price'
                                            InputProps={{
                                              inputComponent: NumberFormatCustom,
                                              autocomplete: 'off',
                                              form: {
                                                autocomplete: 'off',
                                              },
                                            }}
                                          />
                                          <Tooltip
                                            title={t(
                                              'Unplugged.SaveTooltip'
                                            )}>
                                            <IconButton
                                              size='small'
                                              onClick={() =>
                                                this.handleCloseDueAmountEditInput(
                                                  index,
                                                  this.state.scanRxItems[
                                                  index
                                                  ]['orderid']
                                                )
                                              }
                                              className={
                                                classes.onAmoutDueEditPrimaryButton
                                              }>
                                              <SaveIcon fontSize='small' />
                                            </IconButton>
                                          </Tooltip>
                                        </React.Fragment>
                                      ) : (
                                        <React.Fragment>
                                          <span className='assign-rx-cart-price-value'>
                                            {'$' +
                                              parseFloat(
                                                this.state.scanRxItems[index][
                                                  'price'
                                                ]
                                              ).toFixed(2)}
                                          </span>
                                          <Tooltip
                                            title={t('Unplugged.EditTooltip')}>
                                            <IconButton
                                              size='small'
                                              className={
                                                classes.onAmoutDueEditPrimaryButton
                                              }
                                              onClick={() =>
                                                this.handleOpenDueAmountEditInput(
                                                  index
                                                )
                                              }>
                                              <EditIcon fontSize='small' />
                                            </IconButton>
                                          </Tooltip>
                                        </React.Fragment>
                                      )
                                    ) : (
                                      <AmountFormat
                                        setStyle={'70px'}
                                        id='price'
                                        onBlur={(e) =>
                                          this.onScanRxChange(
                                            index,
                                            'price',
                                            e.target.value
                                          )
                                        }
                                        defaultValue={
                                          this.state.scanRxItems[index].price
                                        }
                                        value={this.state.price}
                                        readOnly={this.state.readOnly}
                                      />
                                    )}
                                  </div>
                                </TableCell>
                                <TableCell
                                  sx={{ padding: 0, textAlign: 'left' }}
                                  className={classes.tableCell}>
                                  {' '}
                                  {this.state.scanRxItems[index] &&
                                    this.state.scanRxItems[index]
                                      .is_order_released &&
                                    this.state.scanRxItems[index]
                                      .is_order_released === true ? (
                                    <div>
                                      <img
                                        src={checked}
                                        alt={
                                          this.state.scanRxItems[index].rx_no
                                        }
                                        height={24}
                                        width={24}
                                      />
                                    </div>
                                  ) : (
                                    <div>
                                      {this.state.scanRxItems[index] &&
                                        this.state.scanRxItems[index]
                                          .is_order_released &&
                                        this.state.scanRxItems[index]
                                          .is_order_released}
                                      {this.state.isLoadingTrans === true ? (
                                        <CircularProgress size={22} thickness={4} sx={{ color: '#00a7e1' }} />
                                      ) : (
                                        <Checkbox
                                          checked={
                                            this.state.scanRxItems[index]
                                              .ConsultRequire ||
                                            this.state.scanRxItems[index]
                                              .is_consultrequire
                                          }
                                          disabled={Boolean(this.state.readOnly)}
                                          onChange={() =>
                                            !this.state.readOnly && this.handleConsultrequire(index)
                                          }
                                          value={
                                            this.state.scanRxItems[index]
                                              .ConsultRequire ||
                                            this.state.scanRxItems[index]
                                              .is_consultrequire
                                          }
                                          color='primary'
                                        />
                                      )}
                                    </div>
                                  )}
                                </TableCell>
                                <TableCell>
                                  <Checkbox
                                    onChange={() => !this.state.readOnly && this.handleIsReturnable(index)}
                                    disabled={Boolean(this.state.readOnly)}
                                    value={this.isFlagTrue(this.state.scanRxItems[index].IsReturnable) || this.isFlagTrue(this.state.scanRxItems[index].is_returnable)}
                                    checked={ this.isFlagTrue(this.state.scanRxItems[index].IsReturnable) || this.isFlagTrue(this.state.scanRxItems[index].is_returnable) }
                                    color="primary"
                                  />
                                </TableCell>
                                <TableCell>
                                  <Checkbox
                                    onChange={() => !this.state.readOnly && this.handleIsControlledSubstance(index)}
                                    disabled={Boolean(this.state.readOnly)}
                                    value={ this.isFlagTrue(this.state.scanRxItems[index].is_controlledsubstances) }
                                    checked={ this.isFlagTrue(this.state.scanRxItems[index].is_controlledsubstances) }
                                    color="primary"
                                  />
                                </TableCell>
                              </TableRow>
                            );
                          })
                        )}
                      </TableBody>
                    </Table>
                  </div>
                </div>
                {this.state.isVisibleForPause ? (
                  <div
                    className={
                      'assign-rx-payment-summary' +
                      (this.state.isAmountPaid
                        ? ' is-paid'
                        : this.state.isPartiallyPaid
                          ? ' is-partial'
                          : ' is-due')
                    }
                  >
                    <div className='assign-rx-payment-metric'>
                      <span className='assign-rx-payment-metric-label'>
                        {this.state.isPartiallyPaid ? (
                          <span style={{ color: '#b45309' }}>
                            {t('Unplugged.PartiallyPaid', { defaultValue: 'Partially Paid' })}
                          </span>
                        ) : (
                          t('Unplugged.Paid')
                        )}
                      </span>
                      <span
                        className={
                          'assign-rx-payment-metric-value' +
                          (this.state.isPartiallyPaid
                            ? ' is-partial'
                            : this.state.isAmountPaid
                              ? ' is-paid'
                              : '')
                        }
                      >
                        {this.getPaidAmountDisplay()}
                      </span>
                    </div>
                    <div className='assign-rx-payment-metric is-emphasis'>
                      <span className='assign-rx-payment-metric-label'>
                        {t('Unplugged.AmountDue')}
                      </span>
                      <span
                        className={
                          'assign-rx-payment-metric-value' +
                          (this.state.isPartiallyPaid
                            ? ' is-partial'
                            : this.state.isAmountPaid
                              ? ' is-settled'
                              : ' is-due')
                        }
                      >
                        {this.getDueAmountDisplay()}
                      </span>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>

              <div
                id='react-no-print'
                key='BoxLayout'
                className={classNames(classes.boxHolder, 'assign-bin-panel')}>
                {locationtype_id !== LOCATION_TYPE.Kiosk ? (
                  <div className={classes.locationFooter}>
                    {this.renderLocationField()}
                    {this.renderAddressFields()}
                  </div>
                ) : null}
                {locationtype_id === LOCATION_TYPE.Kiosk ? (
                  <React.Fragment>
                    {this.state.isSizeBasedPreAssignment ? (
                      <SizeBasedBinAvailabilitySummary
                        t={t}
                        binCountsBySize={this.state.binCountsBySize}
                      />
                    ) : null}
                    {this.renderBinsSectionRefreshButton(t)}
                    <Grid container sx={this.is_pre_assignment ? { m: '0px' } : { m: '0px', mt: 0.5 }}>
                      <Grid item xs={12}>
                        <Boxlayout
                          key={`bin-layout-${this.state.binLayoutRefreshKey}`}
                          BinStatus={this.state.BinStatus}
                          deactivatedBins={this.state.deactivatedBins}
                          selectedBinId={this.state.selectedBinId}
                          expansionUnits={this.state.expansionUnits} //Added by Naresh | DI-329
                          getPrescriptionDetails={this.getPrescriptionDetails}
                          getSelectedBin={this.getSelectedBin}
                          getSelectedUnitName={this.getSelectedUnitName}
                          currentTabIndex={this.state.expansionUnits.findIndex(
                            (x) => x.pos === 'M' || x.pos === 'M22' || x.pos === 'FASTLANE' || x.pos === 'M24' || x.pos === 'M41'
                          )}
                          isADACompatible={this.state.isADACompatible}
                          ADAData={this.state.ADAData}
                          PatientID={
                            this.state &&
                            this.state.searchedItems &&
                            this.state.searchedItems.PatientID
                          }
                          boxTypeId={this.state && this.state.boxTypeId}
                          is_pre_assignment={this.is_pre_assignment}
                          is_size_based_pre_assignment={this.state.isSizeBasedPreAssignment}
                          binSizeByBinId={this.state.binSizeByBinId || {}}
                          BoxID={this.state && this.state.box_id}
                          getAvailableBinsCount={this.getAvailableBinsCount}
                          makeAPICall={this.state.makePreAssignmentAPICall}
                          makeFastlaneAPICall={this.state.makeFastlaneAPICall}
                          onGridRefreshSettled={this.handleBinsSectionRefreshSettled}
                          isViewPermissionAllowed={prescriptionView}
                        />
                      </Grid>
                    </Grid>
                    <div className="box-sidebar-footer">
                      {!this.is_pre_assignment && !this.state.isSizeBasedPreAssignment && (
                        <BinStatusLegend
                          items={withKioskMarketplaceLegend(
                            BIN_STATUS_LEGEND,
                            isFeatureUsable(findEntitlement(this.state.featureEntitlements, KIOSK_MARKETPLACE_KEY))
                          )}
                        />
                      )}
                      <KioskDeliveryInfoPanel
                        t={t}
                        stockCode={stockCode}
                        pickupCode={pickupCode}
                        selectedBinId={selectedBinId || ''}
                        locationControl={this.renderLocationField()}
                        binSlot={this.renderBinField()}
                        addressLine1={deliveryAddress.addressLine1}
                        addressLine2={deliveryAddress.addressLine2}
                        city={deliveryAddress.city}
                        state={deliveryAddress.state}
                        zip={deliveryAddress.zip}
                        country={deliveryAddress.country}
                        expirationDays={
                          this.state.accountDetails && this.state.accountDetails.expiration_days
                        }
                      />
                      {this.state.isBinIdRequired && !this.state.isSizeBasedPreAssignment ? (
                        <FormHelperText className={classes.selectLable}>
                          {t('Unplugged.PleaseSelectBinMessage')}
                        </FormHelperText>
                      ) : null}
                    </div>
                  </React.Fragment>
                ) : locationtype_id === LOCATION_TYPE.Home ? (
                  <Box
                    component='div'
                    sx={{ height: '100%', width: '100%', textAlign: 'center' }}>
                    <HomeIcon
                      style={{ height: '100%', width: '50%', color: '#0369a1' }}
                    />
                  </Box>
                ) : locationtype_id === LOCATION_TYPE.Work ? (
                  <Box
                    component='div'
                    style={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                    }}>
                    <WorkIcon
                      style={{ height: '100%', width: '50%', color: '#0369a1' }}
                    />
                  </Box>
                ) : locationtype_id === LOCATION_TYPE.Bedside ? (
                  <Box
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: '2%',
                    }}>
                    <img
                      src={inpatientIcon}
                      style={{ height: '30%', width: '50%', color: '#0369a1' }}
                      alt='no-icon'
                    />
                    <Grid container sx={{ m: '0px', pl: '0.5rem', pr: '0.5rem' }}>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.BedSide.StorageLocation')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='storage_location'
                          value={this.state.storage_location}
                          onChange={(e) =>
                            this.textInputHandler(
                              'storage_location',
                              e.target.value
                            )
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.BedSide.PatientOrderComment')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={
                            searchedItems && searchedItems.patient_order_comment
                              ? searchedItems.patient_order_comment
                              : ''
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.BedSide.OrderNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={this.state.order_notes}
                          onChange={(e) =>
                            this.textInputHandler('order_notes', e.target.value)
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.BedSide.LocationNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='delivery_notes'
                          value={
                            searchedItems && searchedItems.location_notes
                              ? searchedItems.location_notes
                              : ''
                          }
                          onChange={(e) =>
                            this.textInputHandler(
                              'delivery_notes',
                              e.target.value
                            )
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <Table
                          aria-labelledby='tableTitle'
                          sx={{ marginTop: '5%', textAlign: 'start' }}>
                          <TableRow>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.StockCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{stockCode}</span>
                            </TableCell>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.PUCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{pickupCode}</span>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                    </Grid>
                  </Box>
                ) : locationtype_id === LOCATION_TYPE.Courier ? (
                  <Box
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: '2%',
                    }}>
                    <img
                      src={courierIcon}
                      style={{ height: '30%', width: '50%', color: '#0369a1' }}
                      alt='no-icon'
                    />
                    <Grid
                      container
                      spacing={1}
                      sx={{ pl: '0.5rem', pr: '0.5rem', mt: '-7%' }}>
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Courier.StorageLocation')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='storage_location'
                          value={this.state.storage_location}
                          onChange={(e) =>
                            this.textInputHandler(
                              'storage_location',
                              e.target.value
                            )
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Courier.PatientOrderComment')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={
                            searchedItems && searchedItems.patient_order_comment
                              ? searchedItems.patient_order_comment
                              : ''
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      spacing={1}
                      sx={{ pl: '0.5rem', pr: '0.5rem', mt: '1%' }}>
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Courier.OrderNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={this.state.order_notes}
                          onChange={(e) =>
                            this.textInputHandler('order_notes', e.target.value)
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Courier.LocationNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='delivery_notes'
                          value={
                            searchedItems && searchedItems.location_notes
                              ? searchedItems.location_notes
                              : ''
                          }
                          onChange={(e) =>
                            this.textInputHandler(
                              'delivery_notes',
                              e.target.value
                            )
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      spacing={1}
                      sx={{ pl: '0.5rem', pr: '0.5rem', mt: '1%' }}>
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Courier.Courier')}
                        </label>
                        {this.state.courier_type &&
                          this.state.courier_type.length > 0
                          ? this.state.courier_type.map((val) => {
                            return (
                              <div>
                                <FormControlLabel
                                  label={
                                    <span style={{ color: '#000' }}>
                                      {val}
                                    </span>
                                  }
                                  control={
                                    <Checkbox
                                      value={val}
                                      color='primary'
                                      checked={
                                        this.state
                                          .default_courier_selected === val
                                      }
                                      onClick={() =>
                                        this.checkBoxHandler(val)
                                      }
                                    />
                                  }
                                />
                              </div>
                            );
                          })
                          : ''}
                      </Grid>
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Courier.TrackingNumber')}
                        </label>
                        <br />
                        <input
                          type='text'
                          style={{
                            width: '100%',
                            borderRadius: '5px',
                            padding: '5px',
                            height: '45px',
                            fontSize: '15px',
                          }}
                          value={this.state.courier_tracking}
                          onChange={(evt) => this.courierTrackingHandler(evt)}
                          placeholder={t(
                            'Unplugged.Courier.ScanOrEnterTrackingNumber'
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <Table
                          aria-labelledby='tableTitle'
                          sx={{ marginTop: '5%', textAlign: 'start' }}>
                          <TableRow>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.StockCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{stockCode}</span>
                            </TableCell>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.PUCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{pickupCode}</span>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                    </Grid>
                  </Box>
                ) : locationtype_id === LOCATION_TYPE.Other ? (
                  <Box
                    component='div'
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: '2%',
                    }}>
                    <img
                      src={curbsideIcon}
                      style={{ height: '30%', width: '50%', color: '#0369a1' }}
                      alt='no-icon'
                    />
                    <Table
                      aria-labelledby='tableTitle'
                      style={{ marginTop: '-6%', textAlign: 'start' }}>
                      <TableRow>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Other.StorageLocation')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='storage_location'
                          value={this.state.storage_location}
                          onChange={(e) =>
                            this.textInputHandler(
                              'storage_location',
                              e.target.value
                            )
                          }
                          className={classes.textArea}
                        />
                      </TableRow>
                      <br />
                      <TableRow>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Other.PatientOrderComment')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={
                            searchedItems && searchedItems.patient_order_comment
                              ? searchedItems.patient_order_comment
                              : ''
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </TableRow>
                      <br />
                      <TableRow>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Other.OrderNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={this.state.order_notes}
                          onChange={(e) =>
                            this.textInputHandler('order_notes', e.target.value)
                          }
                          className={classes.textArea}
                        />
                      </TableRow>
                      <br />
                      <TableRow>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Other.LocationNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='delivery_notes'
                          value={
                            searchedItems && searchedItems.location_notes
                              ? searchedItems.location_notes
                              : ''
                          }
                          onChange={(e) =>
                            this.textInputHandler(
                              'delivery_notes',
                              e.target.value
                            )
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </TableRow>
                      <br />
                      <TableRow>
                        <div className={classes.handleStcPic}>
                          <Table>
                            <TableRow>
                              <TableCell className={classes.TableHeadTop}>
                                <span style={{ color: '#a4a6a5' }}>
                                  {t("Unplugged.StockCode")}:
                                </span>
                                &nbsp;&nbsp; <span>{stockCode}</span>
                              </TableCell>
                              <TableCell className={classes.TableHeadTop}>
                                <span style={{ color: '#a4a6a5' }}>
                                  {t("Unplugged.PUCode")}:
                                </span>
                                &nbsp;&nbsp; <span>{pickupCode}</span>
                              </TableCell>
                            </TableRow>
                          </Table>
                        </div>
                      </TableRow>
                    </Table>
                  </Box>
                ) : locationtype_id === LOCATION_TYPE.Counter ? (
                  <Box
                    component='div'
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: '2%',
                    }}>
                    <img
                      src={counterIcon}
                      style={{ height: '30%', width: '50%', color: '#0369a1' }}
                      alt='no-icon'
                    />
                    <Grid container sx={{ m: '0px', pl: '0.5rem', pr: '0.5rem' }}>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Counter.StorageLocation')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='storage_location'
                          value={this.state.storage_location}
                          onChange={(e) =>
                            this.textInputHandler(
                              'storage_location',
                              e.target.value
                            )
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Counter.PatientOrderComment')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={
                            searchedItems && searchedItems.patient_order_comment
                              ? searchedItems.patient_order_comment
                              : ''
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Counter.OrderNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={this.state.order_notes}
                          onChange={(e) =>
                            this.textInputHandler('order_notes', e.target.value)
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Counter.LocationNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='delivery_notes'
                          value={
                            searchedItems && searchedItems.location_notes
                              ? searchedItems.location_notes
                              : ''
                          }
                          onChange={(e) =>
                            this.textInputHandler(
                              'delivery_notes',
                              e.target.value
                            )
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <Table
                          aria-labelledby='tableTitle'
                          sx={{ marginTop: '5%', textAlign: 'start' }}>
                          <TableRow>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.StockCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{stockCode}</span>
                            </TableCell>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.PUCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{pickupCode}</span>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                    </Grid>
                  </Box>
                ) : locationtype_id === LOCATION_TYPE.Curbside ? (
                  <Box
                    component='div'
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: '2%',
                    }}>
                    <img
                      src={curbsideIcon}
                      style={{
                        height: '30%',
                        width: '50%',
                        marginTop: '-5%',
                        color: '#0369a1',
                      }}
                      alt='no-icon'
                    />
                    <Grid container sx={{ m: '0px', pl: '0.5rem', pr: '0.5rem' }}>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.CurbSide.StorageLocation')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='storage_location'
                          value={this.state.storage_location}
                          onChange={(e) =>
                            this.textInputHandler(
                              'storage_location',
                              e.target.value
                            )
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.CurbSide.PatientOrderComment')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={
                            searchedItems && searchedItems.patient_order_comment
                              ? searchedItems.patient_order_comment
                              : ''
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.CurbSide.OrderNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={this.state.order_notes}
                          onChange={(e) =>
                            this.textInputHandler('order_notes', e.target.value)
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.CurbSide.LocationNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='delivery_notes'
                          value={
                            searchedItems && searchedItems.location_notes
                              ? searchedItems.location_notes
                              : ''
                          }
                          onChange={(e) =>
                            this.textInputHandler(
                              'delivery_notes',
                              e.target.value
                            )
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <Table
                          aria-labelledby='tableTitle'
                          sx={{ marginTop: '5%', textAlign: 'start' }}>
                          <TableRow>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.StockCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{stockCode}</span>
                            </TableCell>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.PUCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{pickupCode}</span>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                    </Grid>
                  </Box>
                ) : locationtype_id === LOCATION_TYPE.Bedside ? (
                  <Box
                    component='div'
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: '2%',
                    }}>
                    <img
                      src={inpatientIcon}
                      style={{
                        height: '30%',
                        width: '50%',
                        marginTop: '-5%',
                        color: '#0369a1',
                      }}
                      alt='no-icon'
                    />
                    <Grid container sx={{ m: '0px', pl: '0.5rem', pr: '0.5rem' }}>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.BedSide.StorageLocation')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='storage_location'
                          value={this.state.storage_location}
                          onChange={(e) =>
                            this.textInputHandler(
                              'storage_location',
                              e.target.value
                            )
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.BedSide.PatientOrderComment')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={
                            searchedItems && searchedItems.patient_order_comment
                              ? searchedItems.patient_order_comment
                              : ''
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.BedSide.OrderNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={this.state.order_notes}
                          onChange={(e) =>
                            this.textInputHandler('order_notes', e.target.value)
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.BedSide.LocationNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='delivery_notes'
                          value={
                            searchedItems && searchedItems.location_notes
                              ? searchedItems.location_notes
                              : ''
                          }
                          onChange={(e) =>
                            this.textInputHandler(
                              'delivery_notes',
                              e.target.value
                            )
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid xs={12} sx={{ textAlign: 'left' }}>
                        <Table
                          aria-labelledby='tableTitle'
                          sx={{ marginTop: '5%', textAlign: 'start' }}>
                          <TableRow>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.StockCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{stockCode}</span>
                            </TableCell>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.PUCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{pickupCode}</span>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                    </Grid>
                  </Box>
                ) : (
                  ''
                )}
              </div>
              </div>
              {this.state.detailDialogOpen ? (
                <Manualconsultation
                  detailDialogOpen={this.state.detailDialogOpen}
                  selectedObject={this.state.searchedItems}
                  stockCode={stockCode}
                  pickupCode={pickupCode}
                  boxId={this.state.box_id}
                  accountDetails={this.state.accountDetails}
                  pharmacyDetails={this.state.pharmacyDetails}
                  onPopupClose={this.handleConsultClose}
                />
              ) : null}
            </div>
          </div>

          <Box component='div' id='react-no-print'>
            <ThemeProvider theme={detailsDialogTheme}>
              <Dialog
                open={(this.state && this.state.showDialog) || false}
                aria-labelledby='form-dialog-title'
                PaperProps={{ className: classes.detailsDialog }}>
                <DialogTitle id='form-dialog-title' className={classes.detailsDialogHeader}>
                  {t('Unplugged.Popup.EnterDetails')}
                </DialogTitle>
                <DialogContent className={classes.detailsDialogBody}>
                  <FormControl variant='standard' fullWidth>
                    <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                      <DesktopDatePicker
                        disableFuture
                        value={this.state.popupDOB}
                        onChange={this.onDateSelect}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={t('Unplugged.Popup.DOB')}
                            variant='standard'
                            autoFocus
                            allowKeyboardControl={true}
                            onBlur={this.handleBlurdob}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </FormControl>
                  <FormControl variant='standard' sx={{ mt: '4%' }} fullWidth>
                    <InputLabel htmlFor='formatted-text-mask-input'>
                      {t('Unplugged.Popup.PhoneNumber')}
                    </InputLabel>
                    <Input
                      onChange={this.handlePhoneChange}
                      onKeyDown={(e) => this.handleKeyDown(e)}
                      value={this.state.popupphone}
                      name='Phone Number'
                      id='formatted-text-mask-input'
                      autoComplete='off'
                      inputComponent={TextMaskCustom}
                    />
                  </FormControl>
                </DialogContent>
                <DialogActions className={classes.detailsDialogActions}>
                  <Button
                    onClick={this.handleDialogClose}
                    variant='outlined'
                    className={classes.detailsDialogClose}>
                    {t('Unplugged.Popup.Close')}
                  </Button>
                  <Button
                    type='submit'
                    onClick={this.handleDialogValidate}
                    variant='contained'
                    disableElevation
                    className={classes.detailsDialogValidate}>
                    {t('Unplugged.Popup.Validate')}
                  </Button>
                </DialogActions>
              </Dialog>
            </ThemeProvider>
          </Box>

          <Box component='div' id='react-no-print'>
            <ThemeProvider theme={detailsDialogTheme}>
              <Dialog
                open={!!this.state.scanFlagsDialogOpen}
                onClose={this.closeScanFlagsDialog}
                maxWidth='md'
                fullWidth
                aria-labelledby='scan-flags-dialog-title'
                sx={{ zIndex: 22000 }}
                PaperProps={{ className: classes.scanFlagsDialog }}>
                <DialogTitle id='scan-flags-dialog-title' className={classes.detailsDialogHeader}>
                  {t('Unplugged.ScanFlagsTitle')}
                </DialogTitle>
                <DialogContent className={classes.detailsDialogBody}>
                  <p style={{ margin: '0 0 12px', color: '#475569', fontSize: '0.875rem' }}>
                    {t('Unplugged.ScanFlagsHelp')}
                  </p>
                  <Table size='small'>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>{t('Unplugged.RxHash')}</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>{t('Unplugged.DrugName')}</TableCell>
                        <TableCell align='center' sx={{ whiteSpace: 'nowrap' }}>{t('Unplugged.Payment')}</TableCell>
                        <TableCell align='center' sx={{ whiteSpace: 'nowrap' }}>{t('Unplugged.IdCapture')}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(this.state.scanFlagRows || []).map((row) => (
                        <TableRow key={`${row.rxNo}-${row.index}`}>
                          <TableCell>{row.rxNo}</TableCell>
                          <TableCell>{row.drugname}</TableCell>
                          <TableCell align='center' padding='checkbox'>
                            <Checkbox
                              color='primary'
                              checked={!!row.is_payment_required}
                              onChange={() => this.toggleScanFlagRow(row.index, 'is_payment_required')}
                            />
                          </TableCell>
                          <TableCell align='center' padding='checkbox'>
                            <Checkbox
                              color='primary'
                              checked={!!row.is_id_capture}
                              onChange={() => this.toggleScanFlagRow(row.index, 'is_id_capture')}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </DialogContent>
                <DialogActions className={classes.detailsDialogActions}>
                  <Button
                    onClick={this.closeScanFlagsDialog}
                    variant='outlined'
                    className={classes.detailsDialogClose}>
                    {t('Unplugged.Popup.Close')}
                  </Button>
                  <Button
                    onClick={this.confirmScanFlagsAndSave}
                    variant='contained'
                    disableElevation
                    className={classes.detailsDialogValidate}>
                    {this.state.pendingSaveType === 1 ? t('Unplugged.SavePrint') : t('Unplugged.Save')}
                  </Button>
                </DialogActions>
              </Dialog>
            </ThemeProvider>
          </Box>

          <Box component='div' id='react-no-print'>
            <Dialog
              open={(this.state && this.state.showCoPayAmountDialog) || false}
              aria-labelledby='form-dialog-title'>
              <DialogTitle id='form-dialog-title'>
                {t('Unplugged.CoPayAmount')}
              </DialogTitle>
              <DialogContent>
                <AmountFormat
                  style={{ width: '70px' }}
                  id='CoPayAmount'
                  onBlur={(e) =>
                    this.handleCoPayAmountDialogClose(
                      this.state.CoPayAmountIndex,
                      'CoPayAmount',
                      e.target.value
                    )
                  }
                  defaultValue={this.state.CoPayAmountValue}
                  readOnly={this.state.readOnly}
                />
              </DialogContent>
              <DialogActions>
                <Button
                  type='submit'
                  onClick={(e) =>
                    this.handleCoPayAmountDialogClose(
                      this.state.CoPayAmountIndex,
                      'ok',
                      false
                    )
                  }
                  color='primary'
                  className={classes.primaryButton}>
                  {t('Unplugged.OK')}
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
          <WarningDialog
            open={this.state.isVerifyingBin || false}
            title={t('Unplugged.BinStatus')}
            message={this.state.isVerifyingBinMessage}
            confirmLabel={t('Unplugged.Okay')}
            onClose={this.confirmBinOkButton}
            onConfirm={this.confirmBinOkButton}
          />
          <ErrorDialog
            open={!!(this.state.appDialog && this.state.appDialog.open && this.state.appDialog.variant === 'error')}
            title={this.state.appDialog && this.state.appDialog.title}
            message={this.state.appDialog && this.state.appDialog.message}
            confirmLabel={t('Unplugged.OK')}
            onClose={this.closeAppDialog}
            onConfirm={this.closeAppDialog}
          />
          <InfoDialog
            open={!!(this.state.appDialog && this.state.appDialog.open && this.state.appDialog.variant === 'info')}
            title={this.state.appDialog && this.state.appDialog.title}
            message={this.state.appDialog && this.state.appDialog.message}
            confirmLabel={t('Unplugged.OK')}
            onClose={this.closeAppDialog}
            onConfirm={this.closeAppDialog}
          />
        </Paper>
        {this.renderUnpluggedActionFooter()}

        {/* Print Label Functionality  */}
        <Box component='div' id='Print_UnpluggedPrescription_Label'>
          <PrintTemplate>
            <Dialog
              open={this.state.printDialogOpen || false}
              aria-labelledby='alert-dialog-title'
              aria-describedby='alert-dialog-description'
              PaperProps={{
                sx: { borderRadius: '0px', width: '255px', height: '500px' },
              }}>
              <DialogContent sx={{ p: '10px' }}>
                <LabelTemplate
                  style={{ display: 'none' }}
                  stockCode={stockCode || ''}
                  pickupCode={pickupCode || ''}
                  rxNumbers={searchedRxNumbers || ''}
                  boxId={this.state.box_id || ''}
                  ref={(el) => (this.componentRef = el)}
                  accountDetails={this.state.accountDetails || ''}
                  pharmacyDetails={this.state.pharmacyDetails || ''}
                  firstName={this.state.PrintFirstName || ''}
                  lastName={this.state.PrintLastName || ''}
                  dateOfBirth={this.state.PrintDateOfBirth || ''}
                  isCoolItem={this.state.PrintisCoolItem || ''}
                  prefer_location_name={this.state.prefer_location_name || ''}
                  locationTypeID={locationtype_id || ''}
                  brandingName={this.state.brandName || ''}
                  brandingPhone={this.state.brandPhone || ''}
                  boxDetails={this.state.boxdata}
                  connectionType={1}
                  t={t}
                  bin_id={this.state.binid}
                  rxEntries={this.state.rxEntries}
                  accountConnectionsId={
                    sessionStorage.getItem('accountConnectionId') || ''
                  }
                  compactStockLabelLayout={true}
                />
              </DialogContent>
            </Dialog>
          </PrintTemplate>
        </Box>
        <ShopBinDialog
          bin={this.state.marketplaceBin}
          onClose={() => this.setState({ marketplaceBin: null })}
        />
      </Box>
    );
  }
}

export default withStyles(styles)(withTranslation()(AssignPrescriptions));



// WEBPACK FOOTER //
// ./src/components/unplugged-assign-prescriptions/index.js